(() => {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     CONFIG
     ═══════════════════════════════════════════════════════════ */

  var root = document.getElementById('rogma-scan-root');
  if (!root) return;

  var CONFIG = {
    apiUrl: root.dataset.apiUrl || 'https://rogmai.labsmx.online/api/analyze-multi',
    feedbackUrl: root.dataset.feedbackUrl || 'https://rogmai.labsmx.online/api/feedback',
    analyticsUrl: root.dataset.analyticsUrl || 'https://rogmai.labsmx.online/api/track-event',
    logoBlackUrl: root.dataset.logoBlack || '',
    logoWhiteUrl: root.dataset.logoWhite || '',
    silhouetteFrontalUrl: root.dataset.silhouetteFrontal || '',
    silhouetteLeftUrl: root.dataset.silhouetteLeft || '',
    silhouetteRightUrl: root.dataset.silhouetteRight || '',
    minAge: parseInt(root.dataset.minAge, 10) || 15,
    maxAge: parseInt(root.dataset.maxAge, 10) || 80,
    jpegQuality: Math.min(0.98, Math.max(0.96, (parseInt(root.dataset.jpegQuality, 10) || 96) / 100)),
    maxWidthMobile: Math.max(1600, parseInt(root.dataset.maxWidthMobile, 10) || 1600),
    maxWidthDesktop: Math.max(2160, parseInt(root.dataset.maxWidthDesktop, 10) || 2160),
    apiTimeoutMs: parseInt(root.dataset.apiTimeoutMs, 10) || 90000,
    showFeedback: root.dataset.showFeedback !== 'false',
    cartUtm: 'utm_source=rogma_ia&utm_medium=ai_routine&utm_campaign=v1_scan',
    trackingVersion: 'v1.2a.5.3.39-flush-portrait-v1',

    /*
     * V1.2A.5.3.10-TC — Modo temporal de checkout test.
     * Objetivo:
     * - Mantener escaneo/resultados/rutina igual.
     * - Al presionar “Añadir mi ritual completo”, agregar SOLO el producto de prueba.
     * - Validar checkout, line item properties, cart attributes y posible order tag.
     *
     * Activación segura:
     * - Desde Liquid: data-test-checkout-mode="true"
     * - O desde URL: ?rogma_test_checkout=1
     *
     * IMPORTANTE:
     * - Shopify agrega variantes, por eso testProductVariantId es obligatorio.
     * - Apagar/remover después de la prueba.
     */
    testCheckoutMode:
      root.dataset.testCheckoutMode === 'true' ||
      /(?:\?|&)rogma_test_checkout=1(?:&|$)/.test(window.location.search || ''),
    testProductId: root.dataset.testProductId || '',
    testProductVariantId: root.dataset.testProductVariantId || '',
    testProductTitle: root.dataset.testProductTitle || 'RŌGMA IA Test Product',
    testProductHandle: root.dataset.testProductHandle || '',
    testProductPrice: root.dataset.testProductPrice || '1.00',
    testProductImage: root.dataset.testProductImage || '',
    captureDebug:
      /(?:\?|&)rogma_debug=1(?:&|$)/.test(window.location.search || '') ||
      /(?:#|&)rogma_debug=1(?:&|$)/.test(window.location.hash || '') ||
      root.dataset.captureDebug === 'true',
    controlSubjectMode:
      /(?:\?|&)control=1(?:&|$)/.test(window.location.search || '') ||
      /(?:\?|&)rogma_control=1(?:&|$)/.test(window.location.search || '') ||
      root.dataset.controlSubjectMode === 'true',
    loaderStepMs: 900,
    loaderMinTotalMs: 2000,

    /*
     * V1.1 — validación ligera de iluminación.
     * Se puede desactivar desde Liquid con data-lighting-validation="false".
     */
    lightingValidation: root.dataset.lightingValidation === 'true',
    lightingSampleMs: parseInt(root.dataset.lightingSampleMs, 10) || 320,
    lightingDarkThreshold: parseInt(root.dataset.lightingDarkThreshold, 10) || 92,
    lightingGoodThreshold: parseInt(root.dataset.lightingGoodThreshold, 10) || 116,
    lightingStableMs: parseInt(root.dataset.lightingStableMs, 10) || 980,

    /*
     * V1.2A.5.3 — Captura Premium QA.
     * Validación en vivo para mejorar la imagen antes de mandarla al VLM:
     * contraluz, sobreexposición, luz dispareja y obstrucciones evidentes.
     */
    capturePremiumQa: root.dataset.capturePremiumQa !== 'false',
    lightingBacklightDelta: parseInt(root.dataset.lightingBacklightDelta, 10) || 42,
    lightingUnevenWarnDelta:
      parseInt(root.dataset.lightingUnevenWarnDelta, 10) ||
      parseInt(root.dataset.lightingUnevenDelta, 10) ||
      52,
    lightingUnevenBlockDelta: parseInt(root.dataset.lightingUnevenBlockDelta, 10) || 88,
    lightingUnevenValidation: root.dataset.lightingUnevenValidation === 'true',
    lightingOverexposedThreshold: parseInt(root.dataset.lightingOverexposedThreshold, 10) || 226,
    obstructionValidation: root.dataset.obstructionValidation === 'true',

    /*
     * V1.2A — guía facial inteligente con MediaPipe Face Landmarker.
     * Se puede desactivar desde Liquid con data-face-guidance="false".
     */
    faceGuidance: root.dataset.faceGuidance !== 'false',
    faceSampleMs: parseInt(root.dataset.faceSampleMs, 10) || 170,
    faceStableMs: parseInt(root.dataset.faceStableMs, 10) || 1100,
    faceLoadTimeoutMs: parseInt(root.dataset.faceLoadTimeoutMs, 10) || 30000,
    faceModuleAttemptTimeoutMs:
      parseInt(root.dataset.faceModuleAttemptTimeoutMs, 10) || 9000,
    faceWasmAttemptTimeoutMs:
      parseInt(root.dataset.faceWasmAttemptTimeoutMs, 10) || 10000,
    faceModelAttemptTimeoutMs:
      parseInt(root.dataset.faceModelAttemptTimeoutMs, 10) || 16000,
    handObstructionValidation: root.dataset.handObstructionValidation === 'true',
    handModelUrl: root.dataset.handModelUrl || '',
    handModelAttemptTimeoutMs:
      parseInt(root.dataset.handModelAttemptTimeoutMs, 10) || 14000,

    /*
     * V1.2A.1 — captura automática únicamente cuando MediaPipe está activo,
     * la postura es válida y la iluminación también es suficiente.
     */
    autoCapture: root.dataset.autoCapture !== 'false',
    autoCaptureDelayMs: parseInt(root.dataset.autoCaptureDelayMs, 10) || 650,

    mediapipeVersion: '0.10.35',

    /*
     * Las URLs data-* permiten alojar módulo, WASM y modelo como assets
     * propios o en un CDN controlado sin volver a modificar este JS.
     */
    mediapipeModuleUrl: root.dataset.mediapipeModuleUrl || '',
    mediapipeWasmUrl: root.dataset.mediapipeWasmUrl || '',
    faceModelUrl: root.dataset.faceModelUrl || '',

    mediapipeCdnModuleUrl:
      'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/vision_bundle.mjs',
    mediapipeCdnWasmUrl:
      'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm',
    mediapipeUnpkgModuleUrl:
      'https://unpkg.com/@mediapipe/tasks-vision@0.10.35/vision_bundle.mjs?module',
    mediapipeUnpkgWasmUrl:
      'https://unpkg.com/@mediapipe/tasks-vision@0.10.35/wasm',
    faceGoogleModelUrl:
      'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
    handGoogleModelUrl:
      'https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task',
  };

  var CAPTURE_STEPS = [
    {
      key: 'frontal',
      title: 'Vista frontal',
      label: 'Frontal',
      hint: 'Mira al centro y mantén el rostro relajado.',
      button: 'Capturar ahora',
      guideTitle: 'Prepara tu vista frontal',
      guideText: 'Colócate frente a luz suave y uniforme, retira lentes o accesorios y deja que la guía capture por ti.',
      guideChips: ['Centro', 'Relax', 'Auto'],
      ovalClass: 'is-frontal',
    },
    {
      key: 'perfil_izq',
      title: 'Ángulo izquierdo 3/4',
      label: '3/4 izquierda',
      hint: 'Gira suave hacia tu izquierda, sin llegar a perfil completo.',
      button: 'Capturar ahora',
      guideTitle: 'Prepara tu ángulo izquierdo',
      guideText: 'Mantén el rostro despejado y gira suave para revelar mejilla y zona lateral.',
      guideChips: ['35° aprox.', 'Suave', 'No 90°'],
      ovalClass: 'is-profile-left',
    },
    {
      key: 'perfil_der',
      title: 'Ángulo derecho 3/4',
      label: '3/4 derecha',
      hint: 'Gira suave hacia tu derecha, sin llegar a perfil completo.',
      button: 'Capturar ahora',
      guideTitle: 'Prepara tu ángulo derecho',
      guideText: 'Mantén el rostro despejado y gira suave para revelar mejilla y zona lateral.',
      guideChips: ['35° aprox.', 'Suave', 'No 90°'],
      ovalClass: 'is-profile-right',
    },
  ];

  var LOADER_STEPS = [
    'Evaluando textura visible…',
    'Detectando tono y luminosidad…',
    'Preparando tu rutina RŌGMA…',
  ];

  var COPY = {
    heroFallback: 'Hemos preparado tu Skin Ritual RŌGMA con enfoque cosmético, privacidad y cuidado diario.',
    heroVerRutina: 'Ir a mi rutina',
    resumenEsencial: 'Tu resumen esencial',
    principalAspecto: 'Aspecto más visible',
    aspectPrincipalTag: 'Aspecto más visible',
    rutinaEnfocara: 'Enfoque de rutina',
    tipoPiel: 'Tipo de piel estimado',
    impactoNota: 'Lo más visible y lo primero que conviene atender pueden ser distintos. Por eso tu ritual prioriza el cuidado activo de tu piel.',
    ritualTitulo: 'Ritual recomendado',
    ritualSub: 'Tu ritual completo, listo para añadir al carrito.',
    ritualAmSub: 'Prepara tu piel para el día.',
    ritualPmSub: 'Apoya el cuidado y equilibrio de tu piel durante la noche.',
    ritualFocalSub: 'Aplicación puntual sobre zonas específicas.',
    rutinaAmOpcional: 'Rutina matutina opcional',
    rutinaAmOpcionalTxt: 'Actualmente no se requiere un cuidado específico por la mañana para tu evaluación.',
    tipSolar: 'Recuerda utilizar protección solar diariamente.',
    aspectosTitulo: 'Aspectos observados',
    aspectosSub: 'Nivel observado de cada aspecto visible durante tu evaluación.',
    enfoqueTitulo: 'Enfoque de tu ritual',
    enfoqueFrase: 'Preparamos tu rutina para equilibrar y suavizar la apariencia visible de tu piel.',
    verMasAspectos: 'Ver más aspectos',
    verMenosAspectos: 'Ver menos aspectos',
    productoBenefit: 'Formulado para acompañar la apariencia de',
    accordionPorQue: 'Por qué está en tu rutina',
    accordionComoUsar: 'Cómo usarlo',
    accordionVerProducto: 'Ver producto completo',
    cartAgregar: 'Añadir mi ritual completo',
    cartAgregarFaltantes: 'Añadir productos faltantes',
    cartAgregando: 'Agregando tu ritual…',
    cartAnadida: 'Ritual añadido',
    cartAbriendo: 'Abriendo carrito…',
    cartError: 'No pudimos agregar la rutina',
    cartNota: 'Puedes revisar cada producto antes de continuar.',
    ctaAgregar: 'Agregar este producto',
    ctaAgregando: 'Agregando…',
    ctaAnadido: 'Añadido',
    ctaError: 'No se pudo agregar',
    ctaVerMas: 'Ver detalle',
    modalPorQue: 'Por qué está en tu rutina',
    modalComoUsar: 'Cómo usarlo',
    modalVerPagina: 'Ver página completa del producto',
    evalLimitada: 'La evaluación se generó con información limitada. Puedes repetir el escaneo para mayor precisión cosmética.',
    timeout: 'La evaluación está tardando más de lo habitual. Intenta de nuevo con buena conexión e iluminación uniforme.',
    multivistaIncompleta: 'No pudimos procesar las tres vistas faciales. Repite la captura con buena luz y tu rostro centrado en cada ángulo.',
    sinRitual: 'Tu ritual se completará en la próxima evaluación.',
    feedbackTitulo: '¿Cómo se sintió tu resultado?',
    feedbackSub: 'Una respuesta rápida nos ayuda a mejorar RŌGMA IA Skin Ritual.',
    feedbackPercepcion: '¿El resultado se sintió cercano a lo que ves en tu piel?',
    feedbackPoco: 'No tanto',
    feedbackNeutral: 'Más o menos',
    feedbackMuy: 'Sí, fue acertado',
    feedbackExcelente: 'Muy acertado',
    feedbackComentarioPlaceholder: 'Opcional: cuéntanos qué ajustarías o qué tan útil te pareció tu ritual…',
    feedbackGracias: '✓ Gracias por ayudarnos a perfeccionar RŌGMA IA Skin Ritual.',
    luzHint: 'Busca luz frontal suave y uniforme; evita luz solo de un lado.',
    luzComprobando: 'Comprobando iluminación…',
    luzOscura: 'Agrega un poco más de luz frontal',
    luzOscuraDetalle: 'Acércate a una ventana o ilumina tu rostro de frente.',
    luzContraluz: 'Evita la luz detrás de ti',
    luzContraluzDetalle: 'Colócate frente a la luz, no con una ventana o foco a tus espaldas.',
    luzSobreexpuesta: 'La luz está demasiado fuerte',
    luzSobreexpuestaDetalle: 'Aléjate un poco del foco o busca una luz más suave y uniforme.',
    luzDispareja: 'Busca luz frontal uniforme',
    luzDisparejaDetalle: 'Evita luz solo de un lado; gira o muévete hasta iluminar ambos lados del rostro.',
    luzDisparejaFuerte: 'La luz está dispareja',
    luzDisparejaFuerteDetalle: 'Coloca la luz de frente. No captures con sombra marcada en un lado del rostro.',
    luzEstabilizando: 'Mantén el celular estable un momento…',
    luzAceptable: 'Agrega un poco más de luz frontal',
    luzAceptableDetalle: 'Necesitamos más luz uniforme antes de capturar.',
    luzAdecuada: 'Luz ideal',
    luzAdecuadaDetalle: 'Rostro iluminado de frente y listo para capturar.',
    luzNoDisponible: 'No pudimos comprobar la luz',
    luzNoDisponibleDetalle: 'Puedes continuar y revisar la imagen antes de enviarla.',

    guiaCargando: 'Activando guía inteligente…',
    guiaCargandoDetalle: 'La primera carga puede tardar unos segundos.',
    guiaFallback: 'Guía visual activa',
    guiaFallbackDetalle: 'Puedes continuar con la silueta y la validación de iluminación.',
    guiaSinRostro: 'Acomoda tu rostro en la guía',
    guiaUnRostro: 'Debe aparecer solo una persona',
    guiaRostroDespejado: 'Retira lentes, cabello o accesorios',
    guiaLentes: 'Retira tus lentes para continuar',
    guiaObstruccion: 'Acomoda tu rostro en la guía',
    guiaObstruccionDetalle: 'Mantén el rostro visible para continuar.',
    guiaAcercate: 'Acerca un poco el celular',
    guiaAlejate: 'Dale un poco más de aire al rostro',
    guiaCentra: 'Acomódate al centro',
    guiaEndereza: 'Endereza suavemente la cabeza',
    guiaMiraFrente: 'Mira naturalmente hacia la cámara',
    guiaFrontal: 'Vuelve un poco al frente',
    guiaIzquierda: 'Gira apenas más hacia tu izquierda',
    guiaDerecha: 'Gira apenas más hacia tu derecha',
    guiaDireccionIzquierda: 'Gira suave hacia tu izquierda',
    guiaDireccionDerecha: 'Gira suave hacia tu derecha',
    guiaRegresaCentro: 'Regresa apenas al centro',
    guiaEstable: 'Perfecto, mantente así…',
    guiaLista: 'Vista lista, mantente así',
    guiaCapturando: 'Capturando tu vista…',
    btnAjustando: 'Preparando vista…',
    btnComprobandoLuz: 'Preparando luz…',
    btnCapturarAhora: 'Capturar ahora',
    autoActivo: 'Sesión guiada RŌGMA',
  };

  var SEV_COLOR = {
    ninguno: 'low',
    leve: 'low',
    leve_moderado: 'mid',
    moderado: 'mid',
    moderado_severo: 'high',
    severo: 'high',
  };

  var FEEDBACK_PERCEPCION = [
    { value: 1, labelKey: 'feedbackPoco' },
    { value: 2, labelKey: 'feedbackNeutral' },
    { value: 3, labelKey: 'feedbackMuy' },
    { value: 4, labelKey: 'feedbackExcelente' },
  ];

  var SINTOMA_LABELS = {
    acne: 'Granitos visibles',
    manchas: 'Manchas visibles',
    cicatrices_post_acne: 'Marcas post-imperfección',
    ojeras: 'Zona de ojos',
    arrugas: 'Líneas de expresión',
    rojez: 'Rojeces visibles',
    poros_dilatados: 'Poros visibles',
    opacidad: 'Falta de luminosidad',
    ninguno: 'Equilibrio general',
  };

  var SINTOMA_VISUAL = {
    acne: { icon: 'granito', short: 'Granitos visibles' },
    manchas: { icon: 'mancha', short: 'Manchas visibles' },
    cicatrices_post_acne: { icon: 'textura', short: 'Textura irregular' },
    ojeras: { icon: 'ojos', short: 'Zona de ojos' },
    arrugas: { icon: 'lineas', short: 'Líneas de expresión' },
    rojez: { icon: 'rojez', short: 'Rojeces visibles' },
    poros_dilatados: { icon: 'poros', short: 'Poros visibles' },
    opacidad: { icon: 'luminosidad', short: 'Falta de luminosidad' },
    ninguno: { icon: 'equilibrio', short: 'Equilibrio general' },
  };

  var SEVERIDAD = {
    ninguno: { label: 'Equilibrado' },
    leve: { label: 'Bajo' },
    leve_moderado: { label: 'Bajo a medio' },
    moderado: { label: 'Medio' },
    moderado_severo: { label: 'Medio notable' },
    severo: { label: 'Notable' },
  };

  var SEV_ORDER = { ninguno: 0, leve: 1, leve_moderado: 2, moderado: 3, moderado_severo: 4, severo: 5 };

  var CATEGORIAS = [
    { id: 'textura', titulo: 'Textura', sub: 'Relieve, poros y apariencia de la piel', sintomas: ['acne', 'cicatrices_post_acne', 'poros_dilatados'] },
    { id: 'tono', titulo: 'Tono', sub: 'Uniformidad y luminosidad', sintomas: ['manchas', 'rojez', 'opacidad'] },
    { id: 'envejecimiento', titulo: 'Líneas y firmeza', sub: 'Aspectos visibles del envejecimiento', sintomas: ['arrugas'] },
    { id: 'contorno_ojos', titulo: 'Contorno de ojos', sub: 'Zona de ojos', sintomas: ['ojeras'] },
  ];

  var TITULOS_COSMETICOS = {
    blemish: 'Blemish Care — Gel crema equilibrante',
    vit_c: 'Antioxidant Support — Vitamina C liposomal',
    niacinamida: 'Niacinamida 10%',
    salicilico: 'Ácido Salicílico 2%',
    night_repair: 'Night Repair',
    hialuronico: 'Ácido Hialurónico 6%',
    contorno_ojos: 'We Are Young — Contorno de ojos',
    pca: 'Liposomal PCA',
  };

  var APORTA_PIEL = {
    blemish: 'Recomendado para rutinas enfocadas en granitos visibles y textura irregular.',
    vit_c: 'Recomendado para aportar luminosidad visual y apoyar una apariencia más uniforme.',
    niacinamida: 'Recomendada para rutinas enfocadas en marcas visibles y tono irregular.',
    salicilico: 'Cuidado focalizado para zonas específicas con imperfecciones puntuales.',
    night_repair: 'Apoya la renovación nocturna y una apariencia más descansada.',
    hialuronico: 'Aporta hidratación visible y sensación suave.',
    contorno_ojos: 'Complementa el cuidado del contorno de ojos.',
    pca: 'Cuidado intensivo para textura irregular y signos visibles de desgaste.',
    generico: 'Complementa tu ritual personalizado con cuidado cosmético diario.',
  };

  /* ═══════════════════════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════════════════════ */

  var STATE = {
    phase: 'prep',
    stepIndex: 0,
    edad: null,
    displayName: '',
    consent: false,
    preCameraConsentSeen: false,
    captures: { frontal: null, perfil_izq: null, perfil_der: null },
    previewUrls: {},
    stream: null,
    rawResult: null,
    normalized: null,
    lastScanId: '',
    analyticsSessionId: '',
    analyticsClientScanId: '',
    analyticsPageViewSent: false,
    modalProduct: null,
    modalPeriodo: null,
    loaderTimer: null,
    loaderFinished: false,
    apiDone: false,

    deviceMode: 'mobile',
    deviceFamily: 'mobile',
    deviceOrientation: 'portrait',
    devicePlatform: 'other',
    viewportWidth: 0,
    viewportHeight: 0,
    responsiveModeTimer: null,

    lightingTimer: null,
    lightingCanvas: null,
    lightingCtx: null,
    lightingSamples: [],
    lightingStatus: 'checking',
    lightingStableSince: 0,
    lightingAllowed: false,
    lightingUnavailableSince: 0,
    premiumLightQuality: null,

    faceLandmarker: null,
    faceLandmarkerPromise: null,
    faceGuideStatus: 'loading',
    faceAllowed: false,
    faceFallback: false,
    faceFallbackReason: '',
    faceRaf: null,
    faceLastRunAt: 0,
    faceLastVideoTime: -1,
    faceRuntimeErrors: 0,
    faceStableSince: 0,
    faceStableAnchor: null,
    faceMetrics: null,
    faceMessage: '',
    faceLoadToken: 0,
    handLandmarker: null,
    handLandmarkerPromise: null,
    handModelSource: '',
    handRuntimeErrors: 0,

    autoCaptureTimer: null,
    autoCountdownTimer: null,
    autoCountdownValue: 0,
    autoCaptureStepIndex: -1,
    autoCaptureInProgress: false,

    captureTransitionTimer: null,

    captureDebugFrames: {},
    captureDebugFramesFallback: {},
    capturesQualityFallback: { frontal: null, perfil_izq: null, perfil_der: null },
    qualityRetryUsed: false,
    lastAttemptMode: 'smart-face-crop',
    lastCaptureDebug: null,
    lastApiError: null,
    lastApiErrorMessage: '',
    lastResponseStatus: null,
    androidDebugTimer: null,
    androidLastDebugText: '',
    androidCameraDebugSnapshot: null,
    androidDebugFrozen: false,
    androidDebugFrozenAt: 0,
    androidDebugFrozenReason: '',
    androidDebugCopyStatusTimer: null,

    faceModuleSource: '',
    faceWasmSource: '',
    faceModelSource: '',
    facePreloadStarted: false,
    facePreloadError: '',

    routineItems: [],
    routineVariantIds: [],
    routineCartStatus: 'idle',
    routineTotalLabel: '—',
    cartSyncTimer: null,
    cartObserver: null,
  };

  /* ═══════════════════════════════════════════════════════════
     DOM
     ═══════════════════════════════════════════════════════════ */

  var DOM = {};
  var stickyObserver = null;
  var stickyScrollBound = false;
  var stickyRaf = null;
  function ensureStickyCtaMarkup() {
    var sticky = document.getElementById('rogma-sticky-cta');

    if (!sticky) {
      sticky = document.createElement('div');
      sticky.id = 'rogma-sticky-cta';
      sticky.className = 'rogma-sticky-cta';
      sticky.setAttribute('aria-hidden', 'true');
      sticky.innerHTML =
        '<div class="rogma-sticky-cta__inner">' +
          '<div class="rogma-sticky-cta__totals">' +
            '<span class="rogma-sticky-cta__label">RITUAL COMPLETO</span>' +
            '<strong class="rogma-sticky-cta__price" id="rogma-sticky-total">—</strong>' +
          '</div>' +
          '<button type="button" id="rogma-add-routine-sticky">' +
            escapeHtml(COPY.cartAgregar) +
          '</button>' +
        '</div>';
    }

    /*
     * El CTA se monta directamente en body como un portal. Esto evita que
     * wrappers del theme, transformaciones o contenedores con overflow
     * conviertan position:fixed en un elemento recortado o invisible.
     */
    if (sticky.parentNode !== document.body) {
      document.body.appendChild(sticky);
    }

    var button = document.getElementById('rogma-add-routine-sticky');
    var stickyHasTotals = !!sticky.querySelector('.rogma-sticky-cta__totals');
    var stickyHasPrice = !!document.getElementById('rogma-sticky-total');

    if (!button || !stickyHasTotals || !stickyHasPrice) {
      sticky.innerHTML =
        '<div class="rogma-sticky-cta__inner">' +
          '<div class="rogma-sticky-cta__totals">' +
            '<span class="rogma-sticky-cta__label">RITUAL COMPLETO</span>' +
            '<strong class="rogma-sticky-cta__price" id="rogma-sticky-total">—</strong>' +
          '</div>' +
          '<button type="button" id="rogma-add-routine-sticky">' +
            escapeHtml(COPY.cartAgregar) +
          '</button>' +
        '</div>';

      button = document.getElementById('rogma-add-routine-sticky');
    }

    if (!document.getElementById('rogma-sticky-portal-style')) {
      var style = document.createElement('style');
      style.id = 'rogma-sticky-portal-style';
      style.textContent =
        '#rogma-sticky-cta{' +
          'position:fixed!important;' +
          'left:0!important;' +
          'right:0!important;' +
          'bottom:var(--rogma-sticky-preview-offset,0px)!important;' +
          'z-index:2147483000!important;' +
          'width:100%!important;' +
          'box-sizing:border-box!important;' +
          'padding:12px 20px calc(14px + env(safe-area-inset-bottom,0px))!important;' +
          'background:linear-gradient(to top,#fbfaf7 78%,rgba(251,250,247,.94))!important;' +
          'border-top:1px solid rgba(163,122,73,.20)!important;' +
          'box-shadow:0 -12px 34px rgba(24,21,16,.10)!important;' +
          'transform:none!important;' +
          'opacity:1!important;' +
        '}' +
        '#rogma-sticky-cta[hidden]{display:none!important;}' +
        '#rogma-sticky-cta .rogma-sticky-cta__inner{display:flex!important;align-items:center!important;gap:12px!important;width:100%!important;max-width:430px!important;margin:0 auto!important;box-sizing:border-box!important;}' +
        '#rogma-sticky-cta .rogma-sticky-cta__totals{display:block!important;visibility:visible!important;opacity:1!important;flex:0 0 104px!important;min-width:104px!important;max-width:104px!important;}' +
        '#rogma-sticky-cta .rogma-sticky-cta__label{display:block!important;font-size:8.5px!important;letter-spacing:.10em!important;color:#8a8375!important;font-weight:800!important;line-height:1.15!important;text-transform:uppercase!important;}' +
        '#rogma-sticky-cta .rogma-sticky-cta__price{display:block!important;margin-top:3px!important;font-family:var(--font-heading-family, Space Grotesk, Assistant, sans-serif)!important;font-size:15px!important;font-weight:800!important;color:#181510!important;line-height:1.15!important;white-space:nowrap!important;}' +
        '#rogma-add-routine-sticky{' +
          'display:flex!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'flex:1 1 auto!important;' +
          'min-width:0!important;' +
          'width:auto!important;' +
          'max-width:none!important;' +
          'min-height:52px!important;' +
          'margin:0!important;' +
          'padding:14px 18px!important;' +
          'border:1px solid #181510!important;' +
          'border-radius:12px!important;' +
          'background:#181510!important;' +
          'color:#fff!important;' +
          'font-family:inherit!important;' +
          'font-size:14px!important;' +
          'font-weight:700!important;' +
          'letter-spacing:.02em!important;' +
          'cursor:pointer!important;' +
          'box-shadow:0 8px 24px rgba(18,18,18,.12)!important;' +
          'box-sizing:border-box!important;' +
          'white-space:nowrap!important;' +
        '}' +
        '@media(max-width:767px){#rogma-sticky-cta{padding-left:14px!important;padding-right:14px!important;}#rogma-sticky-cta .rogma-sticky-cta__inner{max-width:390px!important;padding-right:68px!important;gap:9px!important;}#rogma-sticky-cta .rogma-sticky-cta__totals{flex-basis:86px!important;min-width:86px!important;max-width:86px!important;}#rogma-sticky-cta .rogma-sticky-cta__price{font-size:13px!important;}#rogma-add-routine-sticky{font-size:12.5px!important;padding-left:10px!important;padding-right:10px!important;}}' +
        '#rogma-add-routine-sticky:disabled{opacity:.55!important;cursor:not-allowed!important;}' +
        '#rogma-add-routine-sticky.rogma-btn-state-success{' +
          'background:#f2f7f4!important;color:#2d5a3d!important;border-color:rgba(45,90,61,.22)!important;' +
        '}' +
        '#rogma-add-routine-sticky.rogma-btn-state-error{' +
          'background:#f7f7f7!important;color:#111!important;border-color:rgba(18,18,18,.20)!important;' +
        '}';
      document.head.appendChild(style);
    }

    var stickyTotal = document.getElementById('rogma-sticky-total');
    if (stickyTotal) {
      stickyTotal.textContent = STATE.routineTotalLabel || '—';
    }

    sticky.hidden = true;
    sticky.style.display = 'none';
  }

  function ensureResultsPremiumStyle() {
    if (document.getElementById('rogma-results-premium-style')) return;

    var style = document.createElement('style');
    style.id = 'rogma-results-premium-style';
    style.textContent =
      '#rogma-scan-root .rogma-result-hero--compact{margin-bottom:18px!important;}' +
      '#rogma-scan-root .rogma-result-section{margin-top:22px!important;}' +
      '#rogma-scan-root .rogma-result-section--first{margin-top:12px!important;}' +
      '#rogma-scan-root .rogma-section-title{margin-bottom:12px!important;}' +
      '#rogma-scan-root .rogma-resumen-card{padding:22px 20px!important;border-radius:18px!important;box-shadow:0 10px 30px rgba(24,21,16,.06)!important;}' +
      '#rogma-scan-root .rogma-resumen-card__row{display:grid!important;grid-template-columns:minmax(98px,.72fr) minmax(0,1.28fr)!important;align-items:center!important;gap:14px!important;}' +
      '#rogma-scan-root .rogma-resumen-card__value{line-height:1.18!important;}' +
      '#rogma-scan-root .rogma-enfoque-card{padding:22px 18px!important;border-radius:18px!important;}' +
      '#rogma-scan-root .rogma-enfoque-visual-grid{gap:0!important;}' +
      '#rogma-scan-root .rogma-enfoque-visual-card{min-height:126px!important;padding:18px 10px!important;}' +
      '#rogma-scan-root .rogma-enfoque-card__frase{max-width:92%!important;margin-left:auto!important;margin-right:auto!important;}' +
      '#rogma-scan-root .rogma-ritual-reason{padding:22px 20px!important;border-radius:18px!important;}' +
      '#rogma-scan-root .rogma-ritual-reason__header{margin-bottom:12px!important;}' +
      '#rogma-scan-root .rogma-ritual-reason__text{font-size:18px!important;line-height:1.48!important;margin-bottom:16px!important;}' +
      '#rogma-scan-root .rogma-ritual-reason__list{margin-top:0!important;}' +
      '#rogma-scan-root .rogma-ritual-buy-strip{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;margin:0 0 16px!important;padding:15px 16px!important;border:1px solid rgba(163,122,73,.22)!important;border-radius:16px!important;background:#fbfaf7!important;box-shadow:0 8px 24px rgba(24,21,16,.045)!important;}' +
      '#rogma-scan-root .rogma-ritual-buy-strip__label{display:block!important;font-size:10px!important;font-weight:800!important;letter-spacing:.12em!important;text-transform:uppercase!important;color:#8a8375!important;line-height:1.15!important;}' +
      '#rogma-scan-root .rogma-ritual-buy-strip__value{display:block!important;margin-top:4px!important;font-size:15px!important;font-weight:800!important;color:#181510!important;line-height:1.25!important;}' +
      '#rogma-scan-root .rogma-ritual-buy-strip__price{font-size:18px!important;font-weight:900!important;color:#9a7444!important;white-space:nowrap!important;}' +
      '#rogma-scan-root .rogma-routine-cta-wrap--inline{margin-top:18px!important;}' +
      '#rogma-scan-root .rogma-routine-cta-note{max-width:320px!important;margin-left:auto!important;margin-right:auto!important;}' +
      '#rogma-scan-root .rogma-product-accordion__benefit{font-size:17px!important;line-height:1.42!important;}' +
      '#rogma-scan-root .rogma-product-accordion__section-title{margin-top:16px!important;}' +
      '#rogma-scan-root .rogma-aspectos-visual-list{margin-top:18px!important;}' +
      '#rogma-scan-root .rogma-aspecto-row{padding:14px 0!important;}' +
      '#rogma-scan-root .rogma-feedback{margin-top:24px!important;border-radius:18px!important;}' +
      '#rogma-scan-root .rogma-feedback__body{padding-top:14px!important;}' +
      '@media(max-width:767px){' +
        '#rogma-scan-root .rogma-result-section{margin-top:20px!important;}' +
        '#rogma-scan-root .rogma-resumen-card{padding:19px 16px!important;}' +
        '#rogma-scan-root .rogma-resumen-card__row{display:block!important;}' +
        '#rogma-scan-root .rogma-resumen-card__label{font-size:10.5px!important;line-height:1.25!important;}' +
        '#rogma-scan-root .rogma-resumen-card__value{font-size:19px!important;text-align:left!important;margin-top:7px!important;}' +
        '#rogma-scan-root .rogma-resumen-card__badge{font-size:10px!important;margin-left:6px!important;}' +
        '#rogma-scan-root .rogma-ritual-reason__text{font-size:16.5px!important;line-height:1.46!important;}' +
        '#rogma-scan-root .rogma-ritual-buy-strip{padding:14px 14px!important;}' +
        '#rogma-scan-root .rogma-ritual-buy-strip__value{font-size:14px!important;}' +
        '#rogma-scan-root .rogma-ritual-buy-strip__price{font-size:16px!important;}' +
        '#rogma-scan-root .rogma-product-accordion__benefit{font-size:15.5px!important;}' +
      '}';
    document.head.appendChild(style);
  }

  function createRogmaAnalyticsId(prefix) {
    var stamp = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14);
    var rand = Math.random().toString(16).slice(2, 10);
    return String(prefix || 'rogma') + '_' + stamp + '_' + rand;
  }

  function ensureAnalyticsSessionId() {
    if (!STATE.analyticsSessionId) {
      STATE.analyticsSessionId = createRogmaAnalyticsId('session');
    }
    return STATE.analyticsSessionId;
  }

  function resetAnalyticsScanId() {
    STATE.analyticsClientScanId = createRogmaAnalyticsId('client_scan');
    STATE.lastScanId = '';
    return STATE.analyticsClientScanId;
  }

  function ensureAnalyticsScanId() {
    if (STATE.lastScanId) return STATE.lastScanId;
    if (!STATE.analyticsClientScanId) {
      resetAnalyticsScanId();
    }
    return STATE.analyticsClientScanId;
  }

  function getAnalyticsDeviceMetadata(extra) {
    var meta = {
      version: CONFIG.trackingVersion,
      device_mode: STATE.deviceMode || '',
      device_family: STATE.deviceFamily || '',
      device_platform: STATE.devicePlatform || '',
      orientation: STATE.deviceOrientation || '',
      viewport: String(STATE.viewportWidth || 0) + 'x' + String(STATE.viewportHeight || 0),
      test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
    };

    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        var lower = String(key || '').toLowerCase();
        if (/image|imagen|base64|rostro|foto|photo|canvas/.test(lower)) {
          meta[key] = '[redacted]';
        } else {
          meta[key] = extra[key];
        }
      });
    }

    return meta;
  }

  function trackRogmaEvent(eventName, metadata, options) {
    try {
      if (!CONFIG.analyticsUrl || !eventName) return;

      var opts = options || {};
      var scanId = opts.scanId != null ? String(opts.scanId || '') : ensureAnalyticsScanId();

      if ((eventName === 'page_view' || eventName === 'maintenance_viewed') && !opts.forceScanId) {
        scanId = opts.scanId != null ? String(opts.scanId || '') : '';
      }

      var payload = {
        scan_id: scanId,
        event: String(eventName),
        session_id: ensureAnalyticsSessionId(),
        page: 'rogma_ia_scan',
        metadata: getAnalyticsDeviceMetadata(metadata || {}),
      };

      fetch(CONFIG.analyticsUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () { /* analytics fire-and-forget */ });
    } catch (error) {
      /* analytics nunca debe romper el escaneo */
    }
  }

  function cssAssetUrl(url) {
    if (!url) return '';
    return 'url("' + String(url).replace(/"/g, '%22') + '")';
  }

  function applySilhouetteAssetOverrides() {
    /*
     * V1.2A.5.1.6:
     * Las guías ya no dependen solo de data URIs incrustados en CSS.
     * Se cargan como PNG limpios desde assets para poder reemplazarlas sin
     * tocar todo el CSS.
     */
    if (CONFIG.silhouetteFrontalUrl) {
      root.style.setProperty('--rg-silhouette-frontal', cssAssetUrl(CONFIG.silhouetteFrontalUrl));
    }
    if (CONFIG.silhouetteLeftUrl) {
      root.style.setProperty('--rg-silhouette-left', cssAssetUrl(CONFIG.silhouetteLeftUrl));
    }
    if (CONFIG.silhouetteRightUrl) {
      root.style.setProperty('--rg-silhouette-right', cssAssetUrl(CONFIG.silhouetteRightUrl));
    }
  }


  function getResponsiveViewport() {
    var vv = window.visualViewport || null;
    var width = Math.round(
      (vv && vv.width) ||
      window.innerWidth ||
      document.documentElement.clientWidth ||
      root.clientWidth ||
      0
    );
    var height = Math.round(
      (vv && vv.height) ||
      window.innerHeight ||
      document.documentElement.clientHeight ||
      0
    );

    return {
      width: width,
      height: height,
      minSide: Math.min(width, height),
      maxSide: Math.max(width, height),
      orientation: width >= height ? 'landscape' : 'portrait',
    };
  }

  function detectDevicePlatform() {
    var ua = '';

    try {
      ua = navigator.userAgent || '';
    } catch (err) {
      ua = '';
    }

    if (/Android/i.test(ua)) return 'android';
    if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
    return 'other';
  }

  function computeResponsiveMode() {
    /*
     * V1.2A.5.2 — frontend responsivo completo.
     *
     * No distingue “asesoría en tienda” vs cliente final; solo adapta la
     * experiencia al dispositivo real del cliente:
     * - mobile
     * - tablet portrait
     * - tablet landscape
     * - desktop/laptop
     */
    var vp = getResponsiveViewport();
    var coarsePointer = false;

    try {
      coarsePointer = Boolean(
        window.matchMedia &&
        window.matchMedia('(pointer: coarse)').matches
      );
    } catch (err) {
      coarsePointer = false;
    }

    var family = 'mobile';
    var mode = 'mobile';

    if (vp.maxSide >= 1180 && vp.minSide >= 720 && !coarsePointer) {
      family = 'desktop';
      mode = 'desktop';
    } else if (vp.maxSide >= 980 && vp.minSide >= 600) {
      family = 'tablet';
      mode = vp.orientation === 'landscape'
        ? 'tablet-landscape'
        : 'tablet-portrait';
    } else if (vp.maxSide >= 1024 && vp.minSide >= 720) {
      family = coarsePointer ? 'tablet' : 'desktop';
      mode = coarsePointer
        ? (vp.orientation === 'landscape' ? 'tablet-landscape' : 'tablet-portrait')
        : 'desktop';
    }

    return {
      mode: mode,
      family: family,
      orientation: vp.orientation,
      viewport: vp,
      coarsePointer: coarsePointer,
    };
  }

  function applyResponsiveDeviceMode() {
    var info = computeResponsiveMode();

    var platform = detectDevicePlatform();

    STATE.deviceMode = info.mode;
    STATE.deviceFamily = info.family;
    STATE.deviceOrientation = info.orientation;
    STATE.devicePlatform = platform;
    STATE.viewportWidth = info.viewport.width;
    STATE.viewportHeight = info.viewport.height;

    root.setAttribute('data-device-mode', info.mode);
    root.setAttribute('data-device-family', info.family);
    root.setAttribute('data-orientation', info.orientation);
    root.setAttribute('data-pointer', info.coarsePointer ? 'coarse' : 'fine');
    root.setAttribute('data-platform', platform);

    root.style.setProperty('--rg-vw', info.viewport.width + 'px');
    root.style.setProperty('--rg-vh', info.viewport.height + 'px');

    return info;
  }

  function scheduleResponsiveModeUpdate() {
    if (STATE.responsiveModeTimer) {
      clearTimeout(STATE.responsiveModeTimer);
    }

    STATE.responsiveModeTimer = setTimeout(function () {
      STATE.responsiveModeTimer = null;
      applyResponsiveDeviceMode();
      updateCaptureAvailability();
      updatePremiumCaptureStatus();
    }, 120);
  }

  function bindResponsiveModeEvents() {
    window.addEventListener('resize', scheduleResponsiveModeUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleResponsiveModeUpdate, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleResponsiveModeUpdate, { passive: true });
    }
  }

  function cacheDom() {
    DOM.phases = {};
    root.querySelectorAll('[data-phase]').forEach(function (el) {
      DOM.phases[el.dataset.phase] = el;
    });
    DOM.edad = document.getElementById('rogma-edad');
    DOM.edadHint = document.getElementById('rogma-edad-hint');
    DOM.nombre = document.getElementById('rogma-nombre');
    DOM.consent = document.getElementById('rogma-consent');
    DOM.prepError = document.getElementById('rogma-prep-error');
    DOM.startCamera = document.getElementById('rogma-start-camera');
    DOM.preCameraModal = document.getElementById('rogma-pre-camera-modal');
    DOM.preCameraContinue = document.getElementById('rogma-pre-camera-continue');
    DOM.preCameraCancel = document.getElementById('rogma-pre-camera-cancel');
    DOM.preCameraClose = document.getElementById('rogma-pre-camera-close');
    DOM.video = document.getElementById('rogma-video');
    DOM.cameraWrap = root.querySelector('.rogma-scan__camera-wrap');
    DOM.oval = document.getElementById('rogma-oval');
    DOM.flash = document.getElementById('rogma-flash');
    DOM.timeline = document.getElementById('rogma-timeline');
    DOM.stepCounter = document.getElementById('rogma-step-counter');
    DOM.stepTitle = document.getElementById('rogma-step-title');
    DOM.stepHint = document.getElementById('rogma-step-hint');
    DOM.captureGuide = document.getElementById('rogma-capture-guide');
    DOM.premiumStatus = document.getElementById('rogma-premium-capture-status');
    DOM.premiumStatusTitle = null;
    DOM.premiumStatusDetail = null;
    DOM.countdownBadge = document.getElementById('rogma-capture-countdown');
    DOM.captureTransition = document.getElementById('rogma-capture-transition');
    DOM.captureBtn = document.getElementById('rogma-capture-btn');
    DOM.retakeCurrent = document.getElementById('rogma-retake-current');
    DOM.cameraError = document.getElementById('rogma-camera-error');
    DOM.previews = document.getElementById('rogma-previews');
    DOM.reviewError = document.getElementById('rogma-review-error');
    DOM.sendAnalysis = document.getElementById('rogma-send-analysis');
    DOM.loaderSteps = document.getElementById('rogma-loader-steps');
    DOM.loaderDots = document.getElementById('rogma-loader-dots');
    DOM.resultMount = document.getElementById('rogma-result-mount');
    DOM.globalErrorMsg = document.getElementById('rogma-global-error-msg');
    DOM.feedbackMount = document.getElementById('rogma-feedback-mount');
    DOM.modal = document.getElementById('rogma-product-modal');
    DOM.modalTitle = document.getElementById('rogma-modal-title');
    DOM.modalMeta = document.getElementById('rogma-modal-meta');
    DOM.modalImage = document.getElementById('rogma-modal-image');
    DOM.modalBody = document.getElementById('rogma-modal-body');
    DOM.modalAdd = document.getElementById('rogma-modal-add');
    DOM.modalProductLink = document.getElementById('rogma-modal-product-link');
    DOM.stickyCta = document.getElementById('rogma-sticky-cta');
    DOM.stickyRoutineBtn = document.getElementById('rogma-add-routine-sticky');
    DOM.androidCameraDebug = document.getElementById('rogma-android-camera-debug');
    DOM.androidCameraDebugText = document.getElementById('rogma-android-camera-debug-text');
  }

  function ensureCameraStatusDock() {
    if (!DOM.cameraWrap) return null;

    var dock = document.getElementById('rogma-camera-status-dock');

    if (!dock) {
      dock = document.createElement('div');
      dock.id = 'rogma-camera-status-dock';
      dock.className = 'rogma-scan__camera-status-dock';
      dock.setAttribute('aria-label', 'Estado de captura');

      DOM.cameraWrap.insertAdjacentElement('afterend', dock);
    }

    DOM.cameraStatusDock = dock;
    return dock;
  }

  function ensurePremiumCaptureStatusUi() {
    var dock = ensureCameraStatusDock();
    if (!dock) return;

    var status = document.getElementById('rogma-premium-capture-status');

    if (!status) {
      status = document.createElement('div');
      status.id = 'rogma-premium-capture-status';
      status.className = 'rogma-scan__premium-status is-preparing';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.innerHTML =
        '<span class="rogma-scan__premium-orb" aria-hidden="true"></span>' +
        '<span class="rogma-scan__premium-copy">' +
          '<strong class="rogma-scan__premium-title">Preparando guía</strong>' +
          '<span class="rogma-scan__premium-detail">Busca luz suave de frente</span>' +
        '</span>' +
        '<span class="rogma-scan__premium-progress" aria-hidden="true"></span>';
    }

    if (status.parentNode !== dock) {
      dock.insertBefore(status, dock.firstChild);
    }

    DOM.premiumStatus = status;
    DOM.premiumStatusTitle = status.querySelector('.rogma-scan__premium-title');
    DOM.premiumStatusDetail = status.querySelector('.rogma-scan__premium-detail');
  }


  function getCurrentCaptureStepKey() {
    var step = CAPTURE_STEPS[STATE.stepIndex];
    return step ? step.key : '';
  }

  function isRogmaDebugEnabled() {
    try {
      return /(?:\?|&)rogma_debug=1(?:&|$)/.test(window.location.search || '');
    } catch (error) {
      return false;
    }
  }

  function isAndroidFrontalDebugActive() {
    return (
      isRogmaDebugEnabled() &&
      STATE.phase === 'capture' &&
      STATE.deviceFamily === 'mobile' &&
      STATE.devicePlatform === 'android' &&
      getCurrentCaptureStepKey() === 'frontal'
    );
  }

  function ensureAndroidCameraDebugPanel() {
    if (!DOM.cameraWrap) return null;

    var panel = document.getElementById('rogma-android-camera-debug');

    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'rogma-android-camera-debug';
      panel.className = 'rogma-scan__android-debug';
      panel.hidden = true;
      panel.innerHTML =
        '<div class="rogma-scan__android-debug-head">' +
          '<strong>Android Camera Debug Snapshot</strong>' +
          '<span>Se congela al detectar rostro frontal para que puedas copiarlo.</span>' +
        '</div>' +
        '<div class="rogma-scan__android-debug-actions">' +
          '<button type="button" class="rogma-scan__android-debug-btn" data-rogma-android-debug-copy>Copiar debug</button>' +
          '<button type="button" class="rogma-scan__android-debug-btn rogma-scan__android-debug-btn--ghost" data-rogma-android-debug-refresh>Actualizar snapshot</button>' +
        '</div>' +
        '<div class="rogma-scan__android-debug-status" data-rogma-android-debug-status>Esperando rostro frontal…</div>' +
        '<textarea id="rogma-android-camera-debug-text" class="rogma-scan__android-debug-text" readonly spellcheck="false"></textarea>';
    }

    if (!panel.parentNode) {
      var dock = ensureCameraStatusDock();
      if (dock && dock.parentNode) {
        dock.insertAdjacentElement('afterend', panel);
      } else {
        DOM.cameraWrap.insertAdjacentElement('afterend', panel);
      }
    }

    DOM.androidCameraDebug = panel;
    DOM.androidCameraDebugText = panel.querySelector('#rogma-android-camera-debug-text');
    bindAndroidDebugPanelActions(panel);
    return panel;
  }

  function setAndroidDebugStatus(message) {
    var panel = DOM.androidCameraDebug || document.getElementById('rogma-android-camera-debug');
    if (!panel) return;
    var status = panel.querySelector('[data-rogma-android-debug-status]');
    if (status) status.textContent = message || '';
  }

  function copyAndroidDebugText() {
    var text = STATE.androidLastDebugText || (DOM.androidCameraDebugText && DOM.androidCameraDebugText.value) || '';
    if (!text) {
      setAndroidDebugStatus('Aún no hay debug para copiar.');
      return;
    }

    function copied(ok) {
      setAndroidDebugStatus(ok ? 'Debug copiado. Pégamelo tal cual aquí.' : 'No se pudo copiar automático. Selecciona el texto del cuadro.');
      if (STATE.androidDebugCopyStatusTimer) clearTimeout(STATE.androidDebugCopyStatusTimer);
      STATE.androidDebugCopyStatusTimer = setTimeout(function () {
        if (STATE.androidDebugFrozen) {
          setAndroidDebugStatus('Snapshot congelado. Puedes copiarlo o actualizarlo.');
        } else {
          setAndroidDebugStatus('Esperando rostro frontal…');
        }
      }, 2800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { copied(true); }).catch(function () { copied(false); });
      return;
    }

    try {
      if (DOM.androidCameraDebugText) {
        DOM.androidCameraDebugText.focus();
        DOM.androidCameraDebugText.select();
        var ok = document.execCommand && document.execCommand('copy');
        copied(!!ok);
      }
    } catch (error) {
      copied(false);
    }
  }

  function refreshAndroidDebugSnapshot() {
    STATE.androidDebugFrozen = false;
    STATE.androidDebugFrozenAt = 0;
    STATE.androidDebugFrozenReason = '';
    updateAndroidCameraDebugPanel('manual-snapshot', true);
    if (STATE.faceMetrics && isAndroidFrontalDebugActive()) {
      STATE.androidDebugFrozen = true;
      STATE.androidDebugFrozenAt = Date.now();
      STATE.androidDebugFrozenReason = 'manual-snapshot';
      setAndroidDebugStatus('Snapshot actualizado y congelado.');
    }
  }

  function bindAndroidDebugPanelActions(panel) {
    if (!panel || panel.dataset.boundActions === 'true') return;
    panel.dataset.boundActions = 'true';

    var copyBtn = panel.querySelector('[data-rogma-android-debug-copy]');
    var refreshBtn = panel.querySelector('[data-rogma-android-debug-refresh]');

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        copyAndroidDebugText();
      });
    }

    if (refreshBtn) {
      refreshBtn.addEventListener('click', function () {
        refreshAndroidDebugSnapshot();
      });
    }
  }

  function safeRound(value, decimals) {
    var num = Number(value);
    if (!isFinite(num)) return 'NA';
    var factor = Math.pow(10, decimals || 0);
    return String(Math.round(num * factor) / factor);
  }

  function getSafeTrackDetails() {
    var out = {
      settings: null,
      capabilities: null,
      label: '',
    };

    try {
      var tracks = STATE.stream && STATE.stream.getVideoTracks
        ? STATE.stream.getVideoTracks()
        : [];
      var track = tracks && tracks[0];
      if (!track) return out;

      out.label = track.label || '';

      if (track.getSettings) {
        try { out.settings = track.getSettings(); } catch (settingsError) { out.settings = null; }
      }

      if (track.getCapabilities) {
        try { out.capabilities = track.getCapabilities(); } catch (capsError) { out.capabilities = null; }
      }
    } catch (error) {}

    return out;
  }

  function summarizeRange(range) {
    if (range == null) return 'NA';
    if (typeof range === 'number' || typeof range === 'string') return String(range);
    if (Array.isArray(range)) return range.slice(0, 4).join('|') + (range.length > 4 ? '|+' + (range.length - 4) : '');
    if (typeof range === 'object') {
      var min = typeof range.min === 'number' ? range.min : null;
      var max = typeof range.max === 'number' ? range.max : null;
      var step = typeof range.step === 'number' ? range.step : null;
      if (min !== null || max !== null) {
        return safeRound(min, 3) + '-' + safeRound(max, 3) + (step !== null ? ' step ' + safeRound(step, 3) : '');
      }
    }
    return 'NA';
  }

  function calculateAndroidDebugSnapshot(reason) {
    var video = DOM.video;
    var frame = DOM.cameraWrap;
    var frameRect = frame && frame.getBoundingClientRect ? frame.getBoundingClientRect() : null;
    var vw = video && video.videoWidth ? video.videoWidth : 0;
    var vh = video && video.videoHeight ? video.videoHeight : 0;
    var cw = frameRect && frameRect.width ? frameRect.width : (frame ? frame.clientWidth : 0);
    var ch = frameRect && frameRect.height ? frameRect.height : (frame ? frame.clientHeight : 0);
    var fit = 'NA';

    try {
      fit = video && window.getComputedStyle ? (window.getComputedStyle(video).objectFit || 'NA') : 'NA';
    } catch (error) {}

    var videoAspect = vw && vh ? vw / vh : 0;
    var frameAspect = cw && ch ? cw / ch : 0;
    var scaleCover = vw && vh && cw && ch ? Math.max(cw / vw, ch / vh) : 0;
    var drawnW = scaleCover ? vw * scaleCover : 0;
    var drawnH = scaleCover ? vh * scaleCover : 0;
    var cropX = Math.max(0, (drawnW - cw) / 2);
    var cropY = Math.max(0, (drawnH - ch) / 2);
    var cropXPct = drawnW ? (cropX * 2 / drawnW) * 100 : 0;
    var cropYPct = drawnH ? (cropY * 2 / drawnH) * 100 : 0;

    var track = getSafeTrackDetails();
    var settings = track.settings || {};
    var caps = track.capabilities || {};
    var face = STATE.faceMetrics || null;
    var lastLight = STATE.lightingSamples && STATE.lightingSamples.length
      ? STATE.lightingSamples[STATE.lightingSamples.length - 1]
      : null;

    var diagnosis = [];
    if (!vw || !vh) {
      diagnosis.push('VIDEO_METADATA_NO_LISTA');
    } else if (Math.abs(videoAspect - frameAspect) < 0.05) {
      diagnosis.push('ASPECT_RATIO_CASI_IGUAL');
    } else if (videoAspect > frameAspect) {
      diagnosis.push('VIDEO_MAS_ANCHO_QUE_FRAME');
      diagnosis.push('COVER_RECORTA_LADOS');
    } else {
      diagnosis.push('VIDEO_MAS_ALTO_QUE_FRAME');
      diagnosis.push('COVER_RECORTA_ARRIBA_ABAJO');
    }

    if (face) {
      if (face.width > 0.72 || face.height > 0.84) diagnosis.push('ROSTRO_LLENA_DEMASIADO_PREVIEW');
      if (face.centerY < 0.38) diagnosis.push('ROSTRO_MUY_ARRIBA');
      if (face.centerY > 0.64) diagnosis.push('ROSTRO_MUY_ABAJO');
    } else {
      diagnosis.push('SIN_METRICAS_ROSTRO_AUN');
    }

    if (!caps.zoom) diagnosis.push('ZOOM_API_NO_EXPUESTA');
    if (caps.zoom && settings.zoom != null) diagnosis.push('ZOOM_ACTUAL_' + safeRound(settings.zoom, 3));

    var snapshot = {
      reason: reason || 'update',
      version: CONFIG.trackingVersion,
      ua: navigator.userAgent || '',
      viewport: {
        inner: (window.innerWidth || 0) + 'x' + (window.innerHeight || 0),
        screen: window.screen ? (window.screen.width + 'x' + window.screen.height) : 'NA',
        dpr: window.devicePixelRatio || 1,
      },
      frame: {
        size: Math.round(cw || 0) + 'x' + Math.round(ch || 0),
        aspect: frameAspect,
      },
      video: {
        meta: vw + 'x' + vh,
        aspect: videoAspect,
        fit: fit,
        coverCropX: cropX,
        coverCropY: cropY,
        coverCropXPct: cropXPct,
        coverCropYPct: cropYPct,
      },
      track: {
        label: track.label || '',
        width: settings.width || 'NA',
        height: settings.height || 'NA',
        aspectRatio: settings.aspectRatio || 'NA',
        facingMode: settings.facingMode || 'NA',
        frameRate: settings.frameRate || 'NA',
        zoom: settings.zoom != null ? settings.zoom : 'NA',
        zoomCaps: summarizeRange(caps.zoom),
        widthCaps: summarizeRange(caps.width),
        heightCaps: summarizeRange(caps.height),
        aspectCaps: summarizeRange(caps.aspectRatio),
      },
      face: face ? {
        cx: face.centerX,
        cy: face.centerY,
        w: face.width,
        h: face.height,
        yaw: face.yaw,
        roll: face.roll,
        pitch: face.pitchRatio,
      } : null,
      rules: getFaceStepRules('frontal'),
      lighting: {
        status: STATE.lightingStatus,
        allowed: STATE.lightingAllowed,
        last: lastLight,
      },
      diagnosis: diagnosis,
      frozen: STATE.androidDebugFrozen,
      frozenReason: STATE.androidDebugFrozenReason || '',
    };

    STATE.androidCameraDebugSnapshot = snapshot;
    return snapshot;
  }

  function formatAndroidDebugSnapshot(snapshot) {
    if (!snapshot) return 'Sin datos todavía.';

    var face = snapshot.face;
    var lines = [];
    lines.push('ROGMA_ANDROID_DEBUG ' + snapshot.version);
    lines.push('reason=' + snapshot.reason + ' step=' + getCurrentCaptureStepKey());
    lines.push('frozen=' + (STATE.androidDebugFrozen ? '1' : '0') + ' frozenReason=' + (STATE.androidDebugFrozenReason || 'NA'));
    lines.push('viewport=' + snapshot.viewport.inner + ' screen=' + snapshot.viewport.screen + ' dpr=' + safeRound(snapshot.viewport.dpr, 2));
    lines.push('frameCSS=' + snapshot.frame.size + ' aspect=' + safeRound(snapshot.frame.aspect, 4));
    lines.push('videoMeta=' + snapshot.video.meta + ' aspect=' + safeRound(snapshot.video.aspect, 4) + ' fit=' + snapshot.video.fit);
    lines.push('coverCropX=' + Math.round(snapshot.video.coverCropX) + 'px (' + safeRound(snapshot.video.coverCropXPct, 1) + '%)');
    lines.push('coverCropY=' + Math.round(snapshot.video.coverCropY) + 'px (' + safeRound(snapshot.video.coverCropYPct, 1) + '%)');
    lines.push('track=' + snapshot.track.width + 'x' + snapshot.track.height + ' ar=' + safeRound(snapshot.track.aspectRatio, 4) + ' facing=' + snapshot.track.facingMode + ' fps=' + snapshot.track.frameRate);
    lines.push('zoom=' + snapshot.track.zoom + ' zoomCaps=' + snapshot.track.zoomCaps);
    lines.push('capsW=' + snapshot.track.widthCaps + ' capsH=' + snapshot.track.heightCaps + ' capsAR=' + snapshot.track.aspectCaps);
    if (face) {
      lines.push('face=cx:' + safeRound(face.cx, 3) + ' cy:' + safeRound(face.cy, 3) + ' w:' + safeRound(face.w, 3) + ' h:' + safeRound(face.h, 3));
      lines.push('pose=yaw:' + safeRound(face.yaw, 3) + ' roll:' + safeRound(face.roll, 1) + ' pitch:' + safeRound(face.pitch, 3));
    } else {
      lines.push('face=NA');
    }
    lines.push('rules=minW:' + snapshot.rules.minWidth + ' maxW:' + snapshot.rules.maxWidth + ' minH:' + snapshot.rules.minHeight + ' maxH:' + snapshot.rules.maxHeight);
    lines.push('light=' + snapshot.lighting.status + ' allowed=' + (snapshot.lighting.allowed ? '1' : '0'));
    if (snapshot.lighting.last) {
      lines.push('lightLast=' + JSON.stringify(snapshot.lighting.last));
    }
    lines.push('diagnosis=' + snapshot.diagnosis.join('|'));
    lines.push('ua=' + snapshot.ua.slice(0, 160));
    return lines.join('\n');
  }

  function updateAndroidCameraDebugPanel(reason, forceRefresh) {
    try {
      var panel = ensureAndroidCameraDebugPanel();
      if (!panel) return;

      if (!isAndroidFrontalDebugActive()) {
        panel.hidden = true;
        root.removeAttribute('data-android-debug-visible');
        STATE.androidDebugFrozen = false;
        STATE.androidDebugFrozenAt = 0;
        STATE.androidDebugFrozenReason = '';
        return;
      }

      panel.hidden = false;
      root.setAttribute('data-android-debug-visible', 'true');

      if (STATE.androidDebugFrozen && !forceRefresh) {
        if (STATE.androidLastDebugText) {
          root.setAttribute('data-android-camera-debug', STATE.androidLastDebugText.replace(/\n/g, ' | '));
          if (DOM.androidCameraDebugText && DOM.androidCameraDebugText.value !== STATE.androidLastDebugText) {
            DOM.androidCameraDebugText.value = STATE.androidLastDebugText;
          }
        }
        setAndroidDebugStatus('Snapshot congelado. Puedes copiarlo o actualizarlo.');
        return;
      }

      var snapshot = calculateAndroidDebugSnapshot(reason || 'update');
      var shouldFreeze = !!STATE.faceMetrics && (reason === 'face-metrics' || forceRefresh);

      if (shouldFreeze) {
        STATE.androidDebugFrozen = true;
        STATE.androidDebugFrozenAt = Date.now();
        STATE.androidDebugFrozenReason = reason === 'face-metrics' ? 'auto-face-detected' : (reason || 'manual-snapshot');
      }

      var text = formatAndroidDebugSnapshot(snapshot);
      STATE.androidLastDebugText = text;

      root.setAttribute('data-android-camera-debug', text.replace(/\n/g, ' | '));

      if (DOM.androidCameraDebugText) {
        DOM.androidCameraDebugText.value = text;
      }

      if (shouldFreeze) {
        setAndroidDebugStatus(reason === 'face-metrics' ? 'Snapshot congelado al detectar rostro. Presiona “Copiar debug”.' : 'Snapshot actualizado y congelado.');
      } else {
        setAndroidDebugStatus('Esperando rostro frontal…');
      }
    } catch (error) {
      console.warn('[RŌGMA] Android debug panel skipped:', error);
    }
  }

  function startAndroidDebugTimer() {
    if (STATE.androidDebugTimer) clearInterval(STATE.androidDebugTimer);
    if (!isAndroidMobileCapture()) return;
    ensureAndroidCameraDebugPanel();
    STATE.androidDebugTimer = setInterval(function () {
      updateAndroidCameraDebugPanel('timer');
    }, 900);
  }

  function stopAndroidDebugTimer() {
    if (STATE.androidDebugTimer) {
      clearInterval(STATE.androidDebugTimer);
      STATE.androidDebugTimer = null;
    }
  }

  function ensureCountdownBadgeUi() {
    if (!DOM.cameraWrap) return;

    var badge = document.getElementById('rogma-capture-countdown');

    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'rogma-capture-countdown';
      badge.className = 'rogma-scan__countdown-badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.hidden = true;
      DOM.cameraWrap.appendChild(badge);
    }

    DOM.countdownBadge = badge;
  }

  function setCountdownBadge(value) {
    ensureCountdownBadgeUi();

    STATE.autoCountdownValue = Number(value) || 0;

    if (!DOM.countdownBadge) return;

    if (STATE.autoCountdownValue > 0) {
      DOM.countdownBadge.textContent = String(STATE.autoCountdownValue);
      DOM.countdownBadge.hidden = false;
      DOM.countdownBadge.classList.remove('is-ticking');
      /*
       * Forzamos reflow para reiniciar la microanimación cada número.
       */
      void DOM.countdownBadge.offsetWidth;
      DOM.countdownBadge.classList.add('is-ticking');
    } else {
      DOM.countdownBadge.hidden = true;
      DOM.countdownBadge.textContent = '';
      DOM.countdownBadge.classList.remove('is-ticking');
    }

    updatePremiumCaptureStatus();
  }

  function ensureCaptureTransitionUi() {
    if (!DOM.cameraWrap) return;

    var transition = document.getElementById('rogma-capture-transition');

    if (!transition) {
      transition = document.createElement('div');
      transition.id = 'rogma-capture-transition';
      transition.className = 'rogma-scan__capture-transition';
      transition.setAttribute('aria-live', 'polite');
      transition.hidden = true;
      transition.innerHTML =
        '<div class="rogma-scan__capture-transition-card">' +
          '<span class="rogma-scan__capture-check" aria-hidden="true">✓</span>' +
          '<strong class="rogma-scan__capture-transition-title"></strong>' +
          '<span class="rogma-scan__capture-transition-detail"></span>' +
        '</div>';

      DOM.cameraWrap.appendChild(transition);
    }

    DOM.captureTransition = transition;
  }

  function hideCaptureTransition() {
    if (STATE.captureTransitionTimer) {
      clearTimeout(STATE.captureTransitionTimer);
      STATE.captureTransitionTimer = null;
    }

    if (!DOM.captureTransition) return;

    DOM.captureTransition.classList.remove('is-visible');
    DOM.captureTransition.hidden = true;
  }

  function getFinishedLabel(step) {
    if (!step) return 'Vista lista';

    if (step.key === 'frontal') return 'Frontal listo';
    if (step.key === 'perfil_izq') return 'Ángulo izquierdo listo';
    if (step.key === 'perfil_der') return 'Ángulo derecho listo';

    return step.title + ' listo';
  }

  function getNextStepLabel(step) {
    if (!step) return 'Preparando tu resumen visual';

    if (step.key === 'perfil_izq') {
      return 'Ahora gira suavemente hacia tu izquierda';
    }

    if (step.key === 'perfil_der') {
      return 'Ahora gira suavemente hacia tu derecha';
    }

    return 'Siguiente vista';
  }

  function showCaptureTransition(completedStep, nextStep, callback) {
    ensureCaptureTransitionUi();

    if (!DOM.captureTransition) {
      if (typeof callback === 'function') callback();
      return;
    }

    var title = DOM.captureTransition.querySelector(
      '.rogma-scan__capture-transition-title'
    );
    var detail = DOM.captureTransition.querySelector(
      '.rogma-scan__capture-transition-detail'
    );

    if (title) {
      title.textContent = getFinishedLabel(completedStep);
    }

    if (detail) {
      detail.textContent = nextStep
        ? getNextStepLabel(nextStep)
        : 'Escaneo completo, revisa tus capturas';
    }

    DOM.captureTransition.hidden = false;
    DOM.captureTransition.classList.remove('is-visible');
    void DOM.captureTransition.offsetWidth;
    DOM.captureTransition.classList.add('is-visible');

    if (STATE.captureTransitionTimer) {
      clearTimeout(STATE.captureTransitionTimer);
    }

    var callbackCalled = false;

    function finishTransition() {
      if (callbackCalled) return;
      callbackCalled = true;

      if (DOM.captureTransition) {
        DOM.captureTransition.classList.remove('is-visible');
        DOM.captureTransition.hidden = true;
      }

      STATE.captureTransitionTimer = null;

      if (typeof callback === 'function') {
        callback();
      }
    }

    STATE.captureTransitionTimer = setTimeout(
      finishTransition,
      nextStep ? 820 : 920
    );

    /*
     * Failsafe para Safari móvil: si por alguna razón el primer timer
     * queda pausado, el flujo no se queda atorado en “Capturando”.
     */
    setTimeout(
      finishTransition,
      nextStep ? 1450 : 1650
    );
  }

  function ensureLightingUi() {
    if (!DOM.cameraWrap) return;

    var dock = ensureCameraStatusDock();
    ensurePremiumCaptureStatusUi();

    var status = document.getElementById('rogma-light-status');
    if (!status) {
      status = document.createElement('div');
      status.id = 'rogma-light-status';
      status.className = 'rogma-scan__light-status is-checking';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.innerHTML =
        '<span class="rogma-scan__light-dot" aria-hidden="true"></span>' +
        '<span class="rogma-scan__light-label">' +
          escapeHtml(COPY.luzComprobando) +
        '</span>';
    }

    if (dock && status.parentNode !== dock) {
      dock.appendChild(status);
    }

    var hint = root.querySelector('.rogma-scan__luz-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'rogma-scan__luz-hint';
      hint.textContent = COPY.luzHint;

      if (DOM.cameraError && DOM.cameraError.parentNode) {
        DOM.cameraError.parentNode.insertBefore(hint, DOM.cameraError);
      } else {
        DOM.cameraWrap.insertAdjacentElement('afterend', hint);
      }
    }

    DOM.lightStatus = status;
    DOM.lightStatusLabel = status.querySelector('.rogma-scan__light-label');
    DOM.lightHint = hint;
  }

  function ensureFaceGuidanceUi() {
    if (!DOM.cameraWrap) return;

    var dock = ensureCameraStatusDock();
    ensurePremiumCaptureStatusUi();
    var status = document.getElementById('rogma-face-guide-status');

    if (!status) {
      status = document.createElement('div');
      status.id = 'rogma-face-guide-status';
      status.className = 'rogma-scan__face-guide-status is-loading';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.innerHTML =
        '<span class="rogma-scan__face-guide-icon" aria-hidden="true"></span>' +
        '<span class="rogma-scan__face-guide-label">' +
          escapeHtml(COPY.guiaCargando) +
        '</span>';
    }

    if (dock && status.parentNode !== dock) {
      dock.appendChild(status);
    }

    DOM.faceGuideStatus = status;
    DOM.faceGuideLabel = status.querySelector('.rogma-scan__face-guide-label');
  }

  function ensureCaptureGuideUi() {
    if (!DOM.stepHint || DOM.captureGuide) return;

    var guide = document.createElement('div');
    guide.id = 'rogma-capture-guide';
    guide.className = 'rogma-scan__angle-guide';
    guide.setAttribute('aria-live', 'polite');

    DOM.stepHint.insertAdjacentElement('afterend', guide);
    DOM.captureGuide = guide;
  }

  function renderCaptureGuide(step) {
    ensureCaptureGuideUi();

    if (!DOM.captureGuide || !step) return;

    var chips = (step.guideChips || []).map(function (chip) {
      return '<span class="rogma-scan__angle-chip">' +
        escapeHtml(chip) +
      '</span>';
    }).join('');

    DOM.captureGuide.innerHTML =
      '<div class="rogma-scan__angle-guide-main">' +
        '<span class="rogma-scan__angle-guide-kicker">' +
          escapeHtml(COPY.autoActivo) +
        '</span>' +
        '<strong>' + escapeHtml(step.guideTitle || step.title) + '</strong>' +
        '<p>' + escapeHtml(step.guideText || step.hint) + '</p>' +
      '</div>' +
      '<div class="rogma-scan__angle-guide-chips" aria-hidden="true">' +
        chips +
      '</div>';
  }

  function getFriendlyLightLabel() {
    if (!CONFIG.lightingValidation) return 'Luz lista';

    if (STATE.lightingStatus === 'good') return 'Luz ideal';
    if (STATE.lightingStatus === 'low') return COPY.luzAceptable;
    if (STATE.lightingStatus === 'uneven_soft') return COPY.luzDispareja;
    if (STATE.lightingStatus === 'dark') return 'Agrega luz frontal';
    if (STATE.lightingStatus === 'backlight') return COPY.luzContraluz;
    if (STATE.lightingStatus === 'overexposed') return COPY.luzSobreexpuesta;
    if (STATE.lightingStatus === 'uneven') return COPY.luzDisparejaFuerte;
    if (STATE.lightingStatus === 'unavailable') return 'Luz lista';

    return 'Preparando luz';
  }

  function getFriendlyLightDetail() {
    if (STATE.lightingStatus === 'dark') return COPY.luzOscuraDetalle;
    if (STATE.lightingStatus === 'backlight') return COPY.luzContraluzDetalle;
    if (STATE.lightingStatus === 'overexposed') return COPY.luzSobreexpuestaDetalle;
    if (STATE.lightingStatus === 'uneven') return COPY.luzDisparejaFuerteDetalle;
    if (STATE.lightingStatus === 'uneven_soft') return COPY.luzDisparejaDetalle;
    if (STATE.lightingStatus === 'low') return COPY.luzAceptableDetalle;
    return COPY.luzHint;
  }
  function getCaptureDeviceLabel() {
    if (STATE.deviceFamily === 'tablet') return 'la tablet';
    if (STATE.deviceFamily === 'desktop') return 'el dispositivo';
    return 'el celular';
  }

  function adaptCaptureDeviceCopy(message) {
    var text = String(message || '');

    if (STATE.deviceFamily === 'tablet') {
      return text
        .replace('Acerca un poco el celular', 'Acerca un poco la tablet')
        .replace('Mantén el celular estable', 'Mantén la tablet estable')
        .replace('Baja un poco el celular o aléjalo apenas', 'Ajusta un poco la distancia de la tablet');
    }

    if (STATE.deviceFamily === 'desktop') {
      return text
        .replace('Acerca un poco el celular', 'Acércate un poco al dispositivo')
        .replace('Mantén el celular estable', 'Mantén estable el dispositivo')
        .replace('Baja un poco el celular o aléjalo apenas', 'Ajusta un poco la distancia');
    }

    return text;
  }

  function getFriendlyFaceLabel() {
    if (!CONFIG.faceGuidance || STATE.faceFallback) {
      return 'Guía visual lista';
    }

    if (STATE.autoCaptureInProgress) return 'Capturando tu vista';
    if (STATE.faceGuideStatus === 'ready') return 'Listo, capturando en automático';
    if (STATE.faceGuideStatus === 'stabilizing') return 'Perfecto, mantente así';
    if (STATE.faceGuideStatus === 'loading') return 'Preparando guía facial';

    var message = STATE.faceMessage || COPY.guiaSinRostro;

    return adaptCaptureDeviceCopy(message)
      .replace('Debe aparecer solo una persona', 'Realiza tu escaneo individual')
      .replace('Baja un poco el celular o aléjalo apenas', 'Ajusta un poco la distancia');
  }

  function getPremiumCaptureTone() {
    if (STATE.autoCaptureInProgress) return 'capturing';
    if (STATE.autoCountdownValue > 0) return 'countdown';

    if (
      CONFIG.lightingValidation &&
      !STATE.lightingAllowed &&
      (
        STATE.lightingStatus === 'dark' ||
        STATE.lightingStatus === 'backlight' ||
        STATE.lightingStatus === 'overexposed' ||
        STATE.lightingStatus === 'uneven' ||
        STATE.lightingStatus === 'uneven_soft' ||
        STATE.lightingStatus === 'low'
      )
    ) {
      return 'warning';
    }

    if (
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      STATE.faceGuideStatus === 'warning'
    ) {
      return 'guiding';
    }

    if (
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      STATE.faceGuideStatus === 'stabilizing'
    ) {
      return 'stabilizing';
    }

    if (
      (
        !CONFIG.lightingValidation ||
        STATE.lightingAllowed
      ) &&
      (
        !CONFIG.faceGuidance ||
        STATE.faceFallback ||
        STATE.faceAllowed
      )
    ) {
      return 'ready';
    }

    return 'preparing';
  }

  function updatePremiumCaptureStatus() {
    ensurePremiumCaptureStatusUi();

    if (!DOM.premiumStatus) return;

    var tone = getPremiumCaptureTone();
    var title;
    var detail;

    if (tone === 'capturing') {
      title = 'Capturando tu vista';
      detail = 'Quédate así un instante';
    } else if (tone === 'countdown') {
      title = 'Capturando en ' + STATE.autoCountdownValue;
      detail = 'Perfecto, mantén tu pose';
    } else if (tone === 'ready') {
      title = 'Vista lista';
      detail = 'La captura se hará automáticamente';
    } else if (tone === 'stabilizing') {
      title = 'Perfecto, mantente así';
      detail = 'Estamos preparando la toma';
    } else if (tone === 'guiding') {
      title = getFriendlyFaceLabel();
      detail = STATE.deviceFamily === 'mobile'
        ? 'Pequeño ajuste para una mejor lectura'
        : 'Ajusta tu posición frente a la cámara';
    } else if (tone === 'warning') {
      title = getFriendlyLightLabel();
      detail = getFriendlyLightDetail();
    } else {
      title = 'Prepara tu vista';
      detail = 'Acomódate con calma en la silueta';
    }

    DOM.premiumStatus.className =
      'rogma-scan__premium-status is-' + tone;
    DOM.premiumStatus.setAttribute('data-premium-status', tone);

    if (DOM.premiumStatusTitle) {
      DOM.premiumStatusTitle.textContent = title;
    }

    if (DOM.premiumStatusDetail) {
      DOM.premiumStatusDetail.textContent = detail;
    }

    root.setAttribute('data-capture-premium-status', tone);
  }

  function updateCaptureButtonLabel() {
    if (!DOM.captureBtn) return;

    var step = CAPTURE_STEPS[STATE.stepIndex] || CAPTURE_STEPS[0];

    if (STATE.autoCaptureInProgress) {
      DOM.captureBtn.textContent = COPY.guiaCapturando;
      updatePremiumCaptureStatus();
      return;
    }

    if (
      CONFIG.lightingValidation &&
      !STATE.lightingAllowed
    ) {
      DOM.captureBtn.textContent = COPY.btnComprobandoLuz;
      updatePremiumCaptureStatus();
      return;
    }

    if (
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      !STATE.faceAllowed
    ) {
      DOM.captureBtn.textContent = COPY.btnAjustando;
      updatePremiumCaptureStatus();
      return;
    }

    if (
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      STATE.faceAllowed
    ) {
      DOM.captureBtn.textContent = COPY.btnCapturarAhora;
      updatePremiumCaptureStatus();
      return;
    }

    DOM.captureBtn.textContent =
      step && step.button
        ? step.button
        : COPY.btnCapturarAhora;

    updatePremiumCaptureStatus();
  }

  function getShopifyPreviewBarOffset() {
    var selectors = [
      '#preview-bar-iframe',
      '.shopify-preview-bar-iframe',
      'iframe[src*="preview_bar"]',
      'iframe[src*="preview-bar"]'
    ];
    var offset = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var visibleAtBottom =
          rect.height > 0 &&
          rect.bottom >= window.innerHeight - 6 &&
          rect.top < window.innerHeight;

        if (visibleAtBottom) {
          offset = Math.max(offset, Math.ceil(rect.height));
        }
      });
    });

    return offset;
  }

  function setStickyCtaVisibility() {
    if (!DOM.stickyCta) return;

    DOM.stickyCta.hidden = true;
    DOM.stickyCta.style.display = 'none';
    DOM.stickyCta.setAttribute('aria-hidden', 'true');
  }

  function updateStickyCtaVisibility() {
    stickyRaf = null;
    setStickyCtaVisibility(false);
  }

  function scheduleStickyCtaUpdate() {
    if (stickyRaf != null) return;
    stickyRaf = window.requestAnimationFrame(updateStickyCtaVisibility);
  }

  function setupStickyCtaBehavior() {
    var regularBtn = document.getElementById('rogma-add-routine');

    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }

    if (!regularBtn || !DOM.stickyCta) {
      setStickyCtaVisibility(false);
      return;
    }

    if ('IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(function () {
        scheduleStickyCtaUpdate();
      }, {
        root: null,
        threshold: [0, 0.01, 1],
      });
      stickyObserver.observe(regularBtn);
    }

    if (!stickyScrollBound) {
      window.addEventListener('scroll', scheduleStickyCtaUpdate, { passive: true });
      document.addEventListener('scroll', scheduleStickyCtaUpdate, true);
      window.addEventListener('resize', scheduleStickyCtaUpdate, { passive: true });
      window.addEventListener('orientationchange', scheduleStickyCtaUpdate);
      stickyScrollBound = true;
    }

    /*
     * Pequeño respaldo para Safari y previews embebidos. Solo permanece
     * activo mientras la página está abierta y la comprobación es mínima.
     */
    if (!window.__rogmaStickyWatch) {
      window.__rogmaStickyWatch = window.setInterval(function () {
        if (STATE.phase === 'result') {
          scheduleStickyCtaUpdate();
        }
      }, 350);
    }

    scheduleStickyCtaUpdate();
  }

  function isLikelyWhatsAppFloatingElement(el) {
    if (!el || !el.getBoundingClientRect) return false;
    if (root.contains(el)) return false;

    var text = [
      el.getAttribute('href'),
      el.getAttribute('src'),
      el.getAttribute('aria-label'),
      el.getAttribute('title'),
      el.id,
      el.className,
    ].join(' ').toLowerCase();

    if (text.indexOf('whatsapp') === -1 && text.indexOf('wa.me') === -1 && text.indexOf('api.whatsapp.com') === -1) {
      return false;
    }

    var style = window.getComputedStyle(el);
    var rect = el.getBoundingClientRect();
    var fixedLike = style.position === 'fixed' || style.position === 'sticky' || rect.bottom > window.innerHeight - 140;

    return fixedLike && rect.width >= 28 && rect.height >= 28;
  }

  function updateWhatsAppFloatingOffset(shouldLift) {
    var selectors = [
      'a[href*="wa.me"]',
      'a[href*="api.whatsapp.com"]',
      'a[href*="whatsapp"]',
      'iframe[src*="whatsapp"]',
      '[aria-label*="WhatsApp" i]',
      '[title*="WhatsApp" i]',
      '[id*="whatsapp" i]',
      '[class*="whatsapp" i]',
      '[id*="wa-widget" i]',
      '[class*="wa-widget" i]'
    ].join(',');

    document.querySelectorAll('.rogma-whatsapp-lifted').forEach(function (el) {
      if (!shouldLift || !isLikelyWhatsAppFloatingElement(el)) {
        el.classList.remove('rogma-whatsapp-lifted');
      }
    });

    if (!shouldLift) return;

    document.querySelectorAll(selectors).forEach(function (el) {
      if (isLikelyWhatsAppFloatingElement(el)) {
        el.classList.add('rogma-whatsapp-lifted');
      }
    });
  }

  function showPhase(name) {
    STATE.phase = name;
    root.setAttribute('data-current-phase', name);
    applyResponsiveDeviceMode();
    Object.keys(DOM.phases).forEach(function (key) {
      DOM.phases[key].hidden = key !== name;
    });

    /*
     * V1.2A.5.1.4:
     * El footer sticky se retira de resultados. El CTA principal vuelve a vivir
     * dentro del bloque de ritual recomendado y WhatsApp queda en su posición
     * original controlada por el theme.
     */
    root.classList.toggle('rogma-scan--has-sticky', false);
    document.body.classList.remove('rogma-scan-result-active');
    updateWhatsAppFloatingOffset(false);
    setStickyCtaVisibility(false);

    if (name === 'result' || name === 'prep') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (name === 'capture') {
      setTimeout(function () {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }, 80);
    }
  }

  function bindEvents() {
    DOM.consent.addEventListener('change', updatePrepButton);
    DOM.edad.addEventListener('input', function () {
      DOM.edad.value = DOM.edad.value.replace(/\D/g, '').slice(0, 2);
      DOM.prepError.hidden = true;
      updateAgeHint();
      updatePrepButton();
    });
    DOM.startCamera.addEventListener('click', startCaptureFlow);
    if (DOM.preCameraContinue) {
      DOM.preCameraContinue.addEventListener('click', beginCaptureAfterPreCameraConsent);
    }
    if (DOM.preCameraCancel) {
      DOM.preCameraCancel.addEventListener('click', closePreCameraModal);
    }
    if (DOM.preCameraClose) {
      DOM.preCameraClose.addEventListener('click', closePreCameraModal);
    }
    if (DOM.preCameraModal) {
      DOM.preCameraModal.addEventListener('click', function (event) {
        if (event.target === DOM.preCameraModal) closePreCameraModal();
      });
    }
    document.getElementById('rogma-back-prep').addEventListener('click', backToPrep);
    DOM.captureBtn.addEventListener('click', function () {
      onCaptureClick(false);
    });
    DOM.retakeCurrent.addEventListener('click', retakeCurrentStep);
    document.getElementById('rogma-redo-capture').addEventListener('click', resetCaptureFlow);
    DOM.sendAnalysis.addEventListener('click', sendAnalysis);
    document.getElementById('rogma-new-scan').addEventListener('click', resetCaptureFlow);
    document.getElementById('rogma-start-over').addEventListener('click', fullReset);
    document.getElementById('rogma-error-retry').addEventListener('click', resetCaptureFlow);

    root.querySelectorAll('[data-close-modal]').forEach(function (el) {
      el.addEventListener('click', closeProductModal);
    });
    DOM.modalAdd.addEventListener('click', addModalProductToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && DOM.modal && !DOM.modal.hidden) closeProductModal();
    });

    buildTimeline();
    buildLoaderUi();
    updatePrepButton();

    if (DOM.stickyRoutineBtn) {
      DOM.stickyRoutineBtn.addEventListener('click', function () {
        if (!STATE.normalized) return;
        addRoutineToCart(
          STATE.normalized.rutinaAm,
          STATE.normalized.rutinaPm,
          STATE.normalized.cuidadoFocalizado
        );
      });
    }
  }

  function updateAgeHint() {
    if (!DOM.edadHint || !DOM.edad) return;

    var trimmed = (DOM.edad.value || '').trim();
    var edad = parseInt(trimmed, 10);
    var showWarning = !!trimmed && !isNaN(edad) && edad < CONFIG.minAge;

    DOM.edadHint.hidden = !showWarning;
    DOM.edad.setAttribute(
      'aria-describedby',
      showWarning ? 'rogma-edad-hint' : ''
    );
  }

  function updatePrepButton() {
    updateAgeHint();
    DOM.startCamera.disabled = !DOM.consent.checked;
  }

  function buildTimeline() {
    DOM.timeline.innerHTML = CAPTURE_STEPS.map(function (_, i) {
      return '<span class="rogma-scan__timeline-dot" data-step="' + i + '"></span>';
    }).join('');
  }

  function updateTimeline() {
    DOM.timeline.querySelectorAll('.rogma-scan__timeline-dot').forEach(function (dot, i) {
      dot.classList.toggle('is-done', i < STATE.stepIndex);
      dot.classList.toggle('is-active', i === STATE.stepIndex);
    });
    if (DOM.stepCounter) {
      DOM.stepCounter.textContent = 'Paso ' + (STATE.stepIndex + 1) + ' de ' + CAPTURE_STEPS.length;
    }
  }

  function buildLoaderUi() {
    DOM.loaderSteps.innerHTML = LOADER_STEPS.map(function (s) {
      return '<li>' + escapeHtml(s) + '</li>';
    }).join('');
    DOM.loaderDots.innerHTML = LOADER_STEPS.map(function () {
      return '<span></span>';
    }).join('');
  }

  function paintLoader(activeIndex) {
    var lis = DOM.loaderSteps.querySelectorAll('li');
    var dots = DOM.loaderDots.querySelectorAll('span');
    lis.forEach(function (li, i) {
      li.classList.toggle('is-active', i === activeIndex);
      li.classList.toggle('is-done', i < activeIndex);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i <= activeIndex);
    });
  }

  /* ═══════════════════════════════════════════════════════════
     V1.1 — LIGHTING VALIDATION
     ═══════════════════════════════════════════════════════════ */

  function clearLightingTimer() {
    if (STATE.lightingTimer) {
      clearInterval(STATE.lightingTimer);
      STATE.lightingTimer = null;
    }
  }

  function resetLightingValidation() {
    STATE.lightingSamples = [];
    STATE.lightingStatus = 'checking';
    STATE.lightingStableSince = 0;
    STATE.lightingAllowed = false;
    STATE.lightingUnavailableSince = 0;

    if (DOM.captureBtn) DOM.captureBtn.disabled = true;
    paintLightingStatus('checking', COPY.luzComprobando, COPY.luzHint);
  }

  function paintLightingStatus(status, label, detail) {
    STATE.lightingStatus = status;

    if (DOM.lightStatus) {
      DOM.lightStatus.className =
        'rogma-scan__light-status is-' + status;
      DOM.lightStatus.setAttribute('data-light-status', status);
    }

    if (DOM.lightStatusLabel) {
      DOM.lightStatusLabel.textContent = label || '';
    }

    if (DOM.lightHint) {
      DOM.lightHint.textContent = detail || COPY.luzHint;
      DOM.lightHint.setAttribute('data-light-status', status);
    }

    if (DOM.cameraWrap) {
      DOM.cameraWrap.classList.remove(
        'is-light-checking',
        'is-light-dark',
        'is-light-low',
        'is-light-good',
        'is-light-unavailable',
        'is-light-backlight',
        'is-light-overexposed',
        'is-light-uneven'
      );
      DOM.cameraWrap.classList.add('is-light-' + status);
    }

    updatePremiumCaptureStatus();
  }

  function getLightingCanvasContext() {
    if (!STATE.lightingCanvas) {
      STATE.lightingCanvas = document.createElement('canvas');
      STATE.lightingCanvas.width = 48;
      STATE.lightingCanvas.height = 48;
      STATE.lightingCtx = STATE.lightingCanvas.getContext('2d', {
        willReadFrequently: true,
      });
    }
    return STATE.lightingCtx;
  }


  function clampNumber(value, min, max) {
    value = Number(value || 0);
    if (!isFinite(value)) return min;
    return Math.max(min, Math.min(max, value));
  }

  function measureVideoRegionStats(sx, sy, sw, sh, canvasSize) {
    if (!DOM.video || !DOM.video.videoWidth || !DOM.video.videoHeight) {
      return null;
    }

    var ctx = getLightingCanvasContext();
    if (!ctx || !STATE.lightingCanvas) return null;

    var vw = DOM.video.videoWidth;
    var vh = DOM.video.videoHeight;
    var size = canvasSize || 40;

    sx = Math.round(clampNumber(sx, 0, vw - 1));
    sy = Math.round(clampNumber(sy, 0, vh - 1));
    sw = Math.round(clampNumber(sw, 1, vw - sx));
    sh = Math.round(clampNumber(sh, 1, vh - sy));

    STATE.lightingCanvas.width = size;
    STATE.lightingCanvas.height = size;

    ctx.drawImage(DOM.video, sx, sy, sw, sh, 0, 0, size, size);

    var pixels = ctx.getImageData(0, 0, size, size).data;
    var total = 0;
    var totalSq = 0;
    var count = 0;
    var dark = 0;
    var bright = 0;

    for (var i = 0; i < pixels.length; i += 8) {
      var r = pixels[i];
      var g = pixels[i + 1];
      var b = pixels[i + 2];
      var y = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
      total += y;
      totalSq += y * y;
      count += 1;
      if (y < 58) dark += 1;
      if (y > 238) bright += 1;
    }

    if (!count) return null;

    var mean = total / count;
    var variance = Math.max(0, (totalSq / count) - (mean * mean));

    return {
      luma: mean,
      contrast: Math.sqrt(variance),
      darkRatio: dark / count,
      brightRatio: bright / count,
    };
  }

  function measureCaptureFrameQuality() {
    if (!DOM.video || !DOM.video.videoWidth || !DOM.video.videoHeight) return null;

    var vw = DOM.video.videoWidth;
    var vh = DOM.video.videoHeight;

    var face = measureVideoRegionStats(
      vw * 0.18,
      vh * 0.12,
      vw * 0.64,
      vh * 0.76,
      48
    );

    var background = measureVideoRegionStats(
      vw * 0.04,
      vh * 0.04,
      vw * 0.92,
      vh * 0.22,
      32
    );

    var left = measureVideoRegionStats(
      vw * 0.04,
      vh * 0.24,
      vw * 0.2,
      vh * 0.58,
      28
    );

    var right = measureVideoRegionStats(
      vw * 0.76,
      vh * 0.24,
      vw * 0.2,
      vh * 0.58,
      28
    );

    var faceLeft = measureVideoRegionStats(
      vw * 0.22,
      vh * 0.20,
      vw * 0.24,
      vh * 0.56,
      32
    );

    var faceRight = measureVideoRegionStats(
      vw * 0.54,
      vh * 0.20,
      vw * 0.24,
      vh * 0.56,
      32
    );

    if (!face) return null;

    var faceLeftLuma = faceLeft ? faceLeft.luma : face.luma;
    var faceRightLuma = faceRight ? faceRight.luma : face.luma;
    var frameLeftLuma = left ? left.luma : face.luma;
    var frameRightLuma = right ? right.luma : face.luma;
    var backgroundLuma = background ? background.luma : face.luma;

    return {
      face: face,
      background: background,
      faceSideDelta: Math.abs(faceLeftLuma - faceRightLuma),
      frameSideDelta: Math.abs(frameLeftLuma - frameRightLuma),
      sideDelta: Math.abs(faceLeftLuma - faceRightLuma),
      backlightDelta: backgroundLuma - face.luma,
    };
  }

  function measureCentralVideoLuma() {
    if (!DOM.video || !DOM.video.videoWidth || !DOM.video.videoHeight) {
      return null;
    }

    var ctx = getLightingCanvasContext();
    if (!ctx) return null;

    var vw = DOM.video.videoWidth;
    var vh = DOM.video.videoHeight;

    /*
     * Se analiza una región central parecida al área del óvalo.
     * Así una ventana brillante del fondo no compensa un rostro oscuro.
     */
    var sx = Math.round(vw * 0.18);
    var sy = Math.round(vh * 0.12);
    var sw = Math.max(1, Math.round(vw * 0.64));
    var sh = Math.max(1, Math.round(vh * 0.76));

    ctx.drawImage(
      DOM.video,
      sx,
      sy,
      sw,
      sh,
      0,
      0,
      STATE.lightingCanvas.width,
      STATE.lightingCanvas.height
    );

    var pixels = ctx.getImageData(
      0,
      0,
      STATE.lightingCanvas.width,
      STATE.lightingCanvas.height
    ).data;

    var total = 0;
    var count = 0;

    /*
     * Saltamos un píxel de cada dos para reducir trabajo en móvil.
     */
    for (var i = 0; i < pixels.length; i += 8) {
      var r = pixels[i];
      var g = pixels[i + 1];
      var b = pixels[i + 2];
      total += (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
      count += 1;
    }

    return count ? total / count : null;
  }

  function getSmoothedLuma(luma) {
    STATE.lightingSamples.push(luma);

    if (STATE.lightingSamples.length > 4) {
      STATE.lightingSamples.shift();
    }

    var total = STATE.lightingSamples.reduce(function (sum, value) {
      return sum + value;
    }, 0);

    return total / STATE.lightingSamples.length;
  }

  function updateCaptureAvailability() {
    if (!DOM.captureBtn) return;

    var hideManualCapture =
      CONFIG.autoCapture &&
      CONFIG.faceGuidance &&
      !STATE.faceFallback;

    DOM.captureBtn.hidden = hideManualCapture;

    var videoReady = Boolean(DOM.video && DOM.video.videoWidth);
    var lightReady =
      !CONFIG.lightingValidation ||
      STATE.lightingAllowed;

    var faceReady =
      !CONFIG.faceGuidance ||
      STATE.faceFallback ||
      STATE.faceAllowed;

    DOM.captureBtn.disabled =
      hideManualCapture ||
      !videoReady ||
      !lightReady ||
      !faceReady ||
      STATE.autoCaptureInProgress;

    updateCaptureButtonLabel();
    scheduleAutoCaptureIfReady();
  }

  function evaluateLightingSample() {
    if (
      STATE.phase !== 'capture' ||
      !STATE.stream ||
      !DOM.video ||
      !DOM.video.videoWidth
    ) {
      STATE.lightingAllowed = false;
      updateCaptureAvailability();
      return;
    }

    if (!CONFIG.lightingValidation) {
      STATE.lightingAllowed = true;
      paintLightingStatus('good', COPY.luzAdecuada, COPY.luzAdecuadaDetalle);
      updateCaptureAvailability();
      return;
    }

    var now = Date.now();
    var luma;
    var frameQuality = null;

    try {
      frameQuality = CONFIG.capturePremiumQa
        ? measureCaptureFrameQuality()
        : null;
      luma = frameQuality && frameQuality.face
        ? frameQuality.face.luma
        : measureCentralVideoLuma();
    } catch (err) {
      console.warn('[RŌGMA Light] No se pudo medir iluminación:', err);
      luma = null;
      frameQuality = null;
    }

    STATE.premiumLightQuality = frameQuality;

    if (luma == null || !isFinite(luma)) {
      if (!STATE.lightingUnavailableSince) {
        STATE.lightingUnavailableSince = now;
      }

      /*
       * No bloqueamos permanentemente al usuario si el navegador no permite
       * leer el frame. Tras un breve intento, se habilita captura con aviso.
       */
      if (now - STATE.lightingUnavailableSince >= 1600) {
        STATE.lightingAllowed = true;
        paintLightingStatus(
          'unavailable',
          COPY.luzNoDisponible,
          COPY.luzNoDisponibleDetalle
        );
      } else {
        STATE.lightingAllowed = false;
        paintLightingStatus('checking', COPY.luzComprobando, COPY.luzHint);
      }

      updateCaptureAvailability();
      return;
    }

    STATE.lightingUnavailableSince = 0;
    var smoothLuma = getSmoothedLuma(luma);

    if (root.dataset.debugLighting === 'true') {
      root.setAttribute('data-lighting-luma', String(Math.round(smoothLuma)));
      console.debug('[RŌGMA Light] luma:', Math.round(smoothLuma));
    }

    if (
      CONFIG.capturePremiumQa &&
      frameQuality &&
      frameQuality.face &&
      frameQuality.face.luma > CONFIG.lightingOverexposedThreshold
    ) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'overexposed',
        COPY.luzSobreexpuesta,
        COPY.luzSobreexpuestaDetalle
      );
      updateCaptureAvailability();
      return;
    }

    if (
      CONFIG.capturePremiumQa &&
      frameQuality &&
      frameQuality.backlightDelta > CONFIG.lightingBacklightDelta &&
      smoothLuma < CONFIG.lightingGoodThreshold + 30
    ) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'backlight',
        COPY.luzContraluz,
        COPY.luzContraluzDetalle
      );
      updateCaptureAvailability();
      return;
    }

    if (
      CONFIG.capturePremiumQa &&
      CONFIG.lightingUnevenValidation &&
      frameQuality &&
      frameQuality.sideDelta > CONFIG.lightingUnevenBlockDelta
    ) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'uneven',
        COPY.luzDisparejaFuerte,
        COPY.luzDisparejaFuerteDetalle
      );
      updateCaptureAvailability();
      return;
    }

    var hasUnevenSoftWarning = Boolean(
      CONFIG.capturePremiumQa &&
      CONFIG.lightingUnevenValidation &&
      frameQuality &&
      frameQuality.sideDelta > CONFIG.lightingUnevenWarnDelta
    );

    if (smoothLuma < CONFIG.lightingDarkThreshold) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'dark',
        COPY.luzOscura,
        COPY.luzOscuraDetalle
      );
      updateCaptureAvailability();
      return;
    }

    if (!STATE.lightingStableSince) {
      STATE.lightingStableSince = now;
    }

    var isStable =
      now - STATE.lightingStableSince >= CONFIG.lightingStableMs;

    if (!isStable) {
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'checking',
        COPY.luzEstabilizando,
        smoothLuma >= CONFIG.lightingGoodThreshold
          ? COPY.luzAdecuadaDetalle
          : COPY.luzAceptableDetalle
      );
      updateCaptureAvailability();
      return;
    }

    if (hasUnevenSoftWarning) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'uneven_soft',
        COPY.luzDispareja,
        COPY.luzDisparejaDetalle
      );
      updateCaptureAvailability();
      return;
    }

    if (smoothLuma < CONFIG.lightingGoodThreshold) {
      STATE.lightingStableSince = 0;
      STATE.lightingAllowed = false;
      paintLightingStatus(
        'low',
        COPY.luzAceptable,
        COPY.luzAceptableDetalle
      );
      updateCaptureAvailability();
      return;
    }

    STATE.lightingAllowed = true;

    paintLightingStatus(
      'good',
      COPY.luzAdecuada,
      COPY.luzAdecuadaDetalle
    );
    updateCaptureAvailability();
  }

  function startLightingMonitor() {
    clearLightingTimer();
    resetLightingValidation();

    evaluateLightingSample();

    STATE.lightingTimer = setInterval(
      evaluateLightingSample,
      CONFIG.lightingSampleMs
    );
  }

  function stopLightingMonitor() {
    clearLightingTimer();
    STATE.lightingAllowed = false;
    STATE.lightingStableSince = 0;
    STATE.lightingSamples = [];
  }

  /* ═══════════════════════════════════════════════════════════
     V1.2A — MEDIAPIPE FACE GUIDANCE
     Detección, centrado, distancia, inclinación, ángulo y estabilidad.
     No incluye todavía sonrisa, boca, ojos o cejas (V1.2B).
     ═══════════════════════════════════════════════════════════ */

  function paintFaceGuidanceStatus(status, label) {
    STATE.faceGuideStatus = status;
    STATE.faceMessage = label || '';

    root.setAttribute('data-face-guide-status', status || 'idle');

    if (status === 'warning' || status === 'loading' || status === 'fallback') {
      cancelAutoCapture();
    }

    if (DOM.faceGuideStatus) {
      DOM.faceGuideStatus.className =
        'rogma-scan__face-guide-status is-' + status;
      DOM.faceGuideStatus.setAttribute('data-face-status', status);
    }

    if (DOM.faceGuideLabel) {
      DOM.faceGuideLabel.textContent = label || '';
    }

    if (DOM.oval) {
      DOM.oval.classList.remove(
        'is-guide-loading',
        'is-guide-warning',
        'is-guide-stabilizing',
        'is-guide-ready',
        'is-guide-fallback'
      );

      var ovalClass = {
        loading: 'is-guide-loading',
        warning: 'is-guide-warning',
        stabilizing: 'is-guide-stabilizing',
        ready: 'is-guide-ready',
        fallback: 'is-guide-fallback',
      }[status];

      if (ovalClass) DOM.oval.classList.add(ovalClass);
    }

    updatePremiumCaptureStatus();
    updateCaptureAvailability();
  }

  function resetFaceGuidanceValidation() {
    cancelAutoCapture();
    STATE.autoCaptureInProgress = false;
    STATE.faceAllowed = false;
    STATE.faceStableSince = 0;
    STATE.faceStableAnchor = null;
    STATE.faceMetrics = null;
    STATE.faceMessage = '';

    if (!CONFIG.faceGuidance) {
      STATE.faceFallback = true;
      paintFaceGuidanceStatus('fallback', COPY.guiaFallback);
      return;
    }

    if (STATE.faceFallback) {
      paintFaceGuidanceStatus('fallback', COPY.guiaFallback);
      return;
    }

    if (!STATE.faceLandmarker) {
      paintFaceGuidanceStatus('loading', COPY.guiaCargando);
      return;
    }

    paintFaceGuidanceStatus('warning', COPY.guiaSinRostro);
  }

  function isShopifyPreviewHost() {
    return /(^|\.)shopifypreview\.com$/i.test(window.location.hostname);
  }

  function summarizeFaceLoadError(reason) {
    var text = String(reason || '').toLowerCase();

    if (/timeout|tiempo de carga|timed out/.test(text)) return 'tiempo';
    if (/wasm|webassembly/.test(text)) return 'WASM';
    if (/model|landmarker\.task|googleapis/.test(text)) return 'modelo';
    if (/content security|csp|refused/.test(text)) return 'CSP';
    if (/import|module|módulo|fetch dynamically/.test(text)) return 'módulo';

    return 'carga';
  }

  function activateFaceGuidanceFallback(reason) {
    STATE.faceFallback = true;
    STATE.faceFallbackReason = reason || 'unknown';
    STATE.faceAllowed = true;
    STATE.faceStableSince = 0;
    STATE.faceStableAnchor = null;

    stopFaceGuidanceLoop();

    var label = COPY.guiaFallback;
    if (isShopifyPreviewHost()) {
      label += ' · ' + summarizeFaceLoadError(reason);
    }

    paintFaceGuidanceStatus('fallback', label);

    root.setAttribute(
      'data-face-fallback-reason',
      String(reason || 'unknown').slice(0, 360)
    );

    console.warn(
      '[RŌGMA Face] Guía inteligente no disponible; se mantiene V1.1:',
      reason
    );
  }

  function uniqueNonEmptyUrls(urls) {
    var seen = {};

    return (urls || []).filter(function (url) {
      var clean = String(url || '').trim();
      if (!clean || seen[clean]) return false;
      seen[clean] = true;
      return true;
    });
  }

  function promiseWithTimeout(promise, timeoutMs, label) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error((label || 'Recurso') + ': tiempo de carga agotado.'));
      }, timeoutMs);

      Promise.resolve(promise).then(function (value) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(value);
      }).catch(function (error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        reject(error);
      });
    });
  }

  function normalizeVisionModule(moduleNamespace) {
    var candidates = [
      moduleNamespace,
      moduleNamespace && moduleNamespace.default,
      moduleNamespace && moduleNamespace.vision,
      window.__ROGMA_MEDIAPIPE_VISION__,
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];

      if (
        candidate &&
        candidate.FilesetResolver &&
        candidate.FaceLandmarker
      ) {
        return candidate;
      }
    }

    return null;
  }

  function waitForShopifyMediaPipeBridge(timeoutMs) {
    var immediate = normalizeVisionModule(
      window.__ROGMA_MEDIAPIPE_VISION__
    );

    if (immediate) {
      return Promise.resolve({
        vision: immediate,
        source:
          window.__ROGMA_MEDIAPIPE_SOURCE__ ||
          'shopify-module-loader',
      });
    }

    return new Promise(function (resolve, reject) {
      var settled = false;

      function cleanup() {
        window.removeEventListener(
          'rogma:mediapipe-ready',
          onReady
        );
        window.removeEventListener(
          'rogma:mediapipe-error',
          onError
        );
      }

      function finishWithVision() {
        var vision = normalizeVisionModule(
          window.__ROGMA_MEDIAPIPE_VISION__
        );

        if (!vision || settled) return false;

        settled = true;
        clearTimeout(timer);
        cleanup();
        resolve({
          vision: vision,
          source:
            window.__ROGMA_MEDIAPIPE_SOURCE__ ||
            'shopify-module-loader',
        });
        return true;
      }

      function onReady() {
        finishWithVision();
      }

      function onError() {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        cleanup();
        reject(
          new Error(
            window.__ROGMA_MEDIAPIPE_ERROR__ ||
            'El loader modular de Shopify no pudo cargar MediaPipe.'
          )
        );
      }

      window.addEventListener(
        'rogma:mediapipe-ready',
        onReady
      );
      window.addEventListener(
        'rogma:mediapipe-error',
        onError
      );

      var timer = setTimeout(function () {
        if (finishWithVision() || settled) return;

        settled = true;
        cleanup();
        reject(
          new Error(
            'El loader modular de Shopify no respondió a tiempo.'
          )
        );
      }, timeoutMs);
    });
  }

  function dynamicImportVisionFromUrl(url) {
    return promiseWithTimeout(
      import(url),
      CONFIG.faceModuleAttemptTimeoutMs,
      'Módulo MediaPipe'
    ).then(function (moduleNamespace) {
      var vision = normalizeVisionModule(moduleNamespace);

      if (!vision) {
        throw new Error(
          'El módulo MediaPipe no expuso FilesetResolver y FaceLandmarker.'
        );
      }

      return {
        vision: vision,
        source: url,
      };
    });
  }

  function trySequentially(items, attemptFn, contextLabel) {
    var errors = [];

    function run(index) {
      if (index >= items.length) {
        return Promise.reject(
          new Error(
            (contextLabel || 'Carga') +
            ' falló en todas las fuentes: ' +
            errors.join(' | ')
          )
        );
      }

      var item = items[index];

      return Promise.resolve()
        .then(function () {
          return attemptFn(item, index);
        })
        .catch(function (error) {
          errors.push(
            String(item) + ' → ' +
            String(
              error && error.message
                ? error.message
                : error
            )
          );
          return run(index + 1);
        });
    }

    return run(0);
  }

  function getMediaPipeModuleCandidates() {
    return uniqueNonEmptyUrls([
      CONFIG.mediapipeModuleUrl,
      CONFIG.mediapipeCdnModuleUrl,
      CONFIG.mediapipeUnpkgModuleUrl,
    ]);
  }

  function getMediaPipeWasmCandidates() {
    return uniqueNonEmptyUrls([
      CONFIG.mediapipeWasmUrl,
      CONFIG.mediapipeCdnWasmUrl,
      'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision/wasm',
      CONFIG.mediapipeUnpkgWasmUrl,
    ]);
  }

  function getFaceModelCandidates() {
    return uniqueNonEmptyUrls([
      CONFIG.faceModelUrl,
      CONFIG.faceGoogleModelUrl,
    ]);
  }

  function getHandModelCandidates() {
    return uniqueNonEmptyUrls([
      CONFIG.handModelUrl,
      CONFIG.handGoogleModelUrl,
    ]);
  }

  function addMediaPipePreconnects() {
    [
      'https://cdn.jsdelivr.net',
      'https://unpkg.com',
      'https://storage.googleapis.com',
    ].forEach(function (href) {
      if (
        document.querySelector(
          'link[rel="preconnect"][href="' + href + '"]'
        )
      ) {
        return;
      }

      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  function importMediaPipeVision() {
    var globalVision = normalizeVisionModule(
      window.__ROGMA_MEDIAPIPE_VISION__
    );

    if (globalVision) {
      STATE.faceModuleSource =
        window.__ROGMA_MEDIAPIPE_SOURCE__ ||
        'shopify-module-loader';

      return Promise.resolve(globalVision);
    }

    /*
     * Primero damos oportunidad al asset type="module" cargado por Shopify.
     * Si no está instalado o falla, usamos import() directo como respaldo.
     */
    return waitForShopifyMediaPipeBridge(4200)
      .then(function (result) {
        STATE.faceModuleSource = result.source;
        root.setAttribute(
          'data-face-module-source',
          result.source
        );
        return result.vision;
      })
      .catch(function (bridgeError) {
        console.warn(
          '[RŌGMA Face] Loader modular no disponible; probando CDN directo:',
          bridgeError
        );

        return trySequentially(
          getMediaPipeModuleCandidates(),
          dynamicImportVisionFromUrl,
          'Módulo MediaPipe'
        ).then(function (result) {
          STATE.faceModuleSource = result.source;
          root.setAttribute(
            'data-face-module-source',
            result.source
          );
          return result.vision;
        });
      });
  }

  function resolveVisionFiles(visionModule) {
    var FilesetResolver = visionModule.FilesetResolver;

    return trySequentially(
      getMediaPipeWasmCandidates(),
      function (wasmUrl) {
        return promiseWithTimeout(
          FilesetResolver.forVisionTasks(wasmUrl),
          CONFIG.faceWasmAttemptTimeoutMs,
          'WASM MediaPipe'
        ).then(function (visionFiles) {
          STATE.faceWasmSource = wasmUrl;
          root.setAttribute(
            'data-face-wasm-source',
            wasmUrl
          );
          return visionFiles;
        });
      },
      'WASM MediaPipe'
    );
  }

  function createLandmarkerWithModel(
    FaceLandmarker,
    visionFiles,
    modelUrl,
    delegate
  ) {
    return promiseWithTimeout(
      FaceLandmarker.createFromOptions(visionFiles, {
        baseOptions: {
          modelAssetPath: modelUrl,
          delegate: delegate,
        },
        runningMode: 'VIDEO',
        numFaces: 2,
        minFaceDetectionConfidence: 0.55,
        minFacePresenceConfidence: 0.55,
        minTrackingConfidence: 0.5,
        outputFaceBlendshapes: false,
        outputFacialTransformationMatrixes: false,
      }),
      CONFIG.faceModelAttemptTimeoutMs,
      'Modelo Face Landmarker'
    );
  }

  function createHandLandmarkerWithModel(
    HandLandmarker,
    visionFiles,
    modelUrl,
    delegate
  ) {
    return promiseWithTimeout(
      HandLandmarker.createFromOptions(visionFiles, {
        baseOptions: {
          modelAssetPath: modelUrl,
          delegate: delegate,
        },
        runningMode: 'VIDEO',
        numHands: 2,
        minHandDetectionConfidence: 0.55,
        minHandPresenceConfidence: 0.55,
        minTrackingConfidence: 0.5,
      }),
      CONFIG.handModelAttemptTimeoutMs,
      'Modelo Hand Landmarker'
    );
  }

  function startHandLandmarkerLoad(visionModule, visionFiles) {
    if (
      !CONFIG.handObstructionValidation ||
      !visionModule ||
      !visionFiles ||
      !visionModule.HandLandmarker ||
      STATE.handLandmarker ||
      STATE.handLandmarkerPromise
    ) {
      return;
    }

    var HandLandmarker = visionModule.HandLandmarker;

    STATE.handLandmarkerPromise = trySequentially(
      getHandModelCandidates(),
      function (modelUrl) {
        return createHandLandmarkerWithModel(
          HandLandmarker,
          visionFiles,
          modelUrl,
          'GPU'
        ).catch(function () {
          return createHandLandmarkerWithModel(
            HandLandmarker,
            visionFiles,
            modelUrl,
            'CPU'
          );
        }).then(function (landmarker) {
          STATE.handModelSource = modelUrl;
          root.setAttribute('data-hand-model-source', modelUrl);
          return landmarker;
        });
      },
      'Modelo Hand Landmarker'
    ).then(function (landmarker) {
      STATE.handLandmarker = landmarker;
      STATE.handLandmarkerPromise = null;
      root.setAttribute('data-hand-obstruction', 'ready');
      return landmarker;
    }).catch(function (error) {
      STATE.handLandmarkerPromise = null;
      root.setAttribute('data-hand-obstruction', 'unavailable');
      console.warn(
        '[RŌGMA Face] Detector de manos no disponible; continúa guía facial:',
        error
      );
    });
  }

  function createFaceLandmarker(visionModule) {
    var FaceLandmarker = visionModule.FaceLandmarker;

    if (
      !visionModule.FilesetResolver ||
      !FaceLandmarker
    ) {
      return Promise.reject(
        new Error(
          'El módulo MediaPipe no expone FaceLandmarker.'
        )
      );
    }

    return resolveVisionFiles(visionModule)
      .then(function (visionFiles) {
        startHandLandmarkerLoad(visionModule, visionFiles);
        return trySequentially(
          getFaceModelCandidates(),
          function (modelUrl) {
            return createLandmarkerWithModel(
              FaceLandmarker,
              visionFiles,
              modelUrl,
              'GPU'
            ).catch(function (gpuError) {
              console.warn(
                '[RŌGMA Face] GPU no disponible; probando CPU:',
                gpuError
              );

              return createLandmarkerWithModel(
                FaceLandmarker,
                visionFiles,
                modelUrl,
                'CPU'
              );
            }).then(function (landmarker) {
              STATE.faceModelSource = modelUrl;
              root.setAttribute(
                'data-face-model-source',
                modelUrl
              );
              return landmarker;
            });
          },
          'Modelo Face Landmarker'
        );
      });
  }

  function loadFaceLandmarker() {
    if (!CONFIG.faceGuidance) {
      return Promise.reject(
        new Error('Guía facial desactivada.')
      );
    }

    if (STATE.faceLandmarker) {
      return Promise.resolve(STATE.faceLandmarker);
    }

    if (STATE.faceLandmarkerPromise) {
      return STATE.faceLandmarkerPromise;
    }

    addMediaPipePreconnects();

    STATE.faceLandmarkerPromise = importMediaPipeVision()
      .then(function (visionModule) {
        return createFaceLandmarker(visionModule);
      })
      .then(function (landmarker) {
        STATE.faceLandmarker = landmarker;
        STATE.faceLandmarkerPromise = null;
        STATE.facePreloadError = '';
        return landmarker;
      })
      .catch(function (error) {
        STATE.faceLandmarkerPromise = null;
        STATE.facePreloadError =
          error && error.message
            ? error.message
            : String(error);
        throw error;
      });

    return STATE.faceLandmarkerPromise;
  }

  function preloadFaceGuidance() {
    if (
      STATE.facePreloadStarted ||
      !CONFIG.faceGuidance
    ) {
      return;
    }

    STATE.facePreloadStarted = true;
    addMediaPipePreconnects();

    var run = function () {
      loadFaceLandmarker()
        .then(function () {
          root.setAttribute(
            'data-face-preload',
            'ready'
          );
        })
        .catch(function (error) {
          root.setAttribute(
            'data-face-preload',
            'failed'
          );
          root.setAttribute(
            'data-face-preload-error',
            String(
              error && error.message
                ? error.message
                : error
            ).slice(0, 360)
          );

          /*
           * No activamos fallback todavía: al abrir cámara se reintenta.
           */
          console.warn(
            '[RŌGMA Face] Precarga no disponible; se reintentará con la cámara:',
            error
          );
        });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, {
        timeout: 1800,
      });
    } else {
      setTimeout(run, 350);
    }
  }

  function cancelAutoCapture() {
    if (STATE.autoCaptureTimer) {
      clearTimeout(STATE.autoCaptureTimer);
      STATE.autoCaptureTimer = null;
    }

    if (STATE.autoCountdownTimer) {
      clearInterval(STATE.autoCountdownTimer);
      STATE.autoCountdownTimer = null;
    }

    STATE.autoCountdownValue = 0;

    if (DOM.countdownBadge) {
      DOM.countdownBadge.hidden = true;
      DOM.countdownBadge.textContent = '';
      DOM.countdownBadge.classList.remove('is-ticking');
    }

    STATE.autoCaptureStepIndex = -1;
  }

  function releaseAutoCaptureLock() {
    STATE.autoCaptureInProgress = false;
    setCountdownBadge(0);
    updatePremiumCaptureStatus();
    updateCaptureAvailability();
  }

  function canAutoCaptureNow() {
    return Boolean(
      CONFIG.autoCapture &&
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      STATE.phase === 'capture' &&
      STATE.stream &&
      STATE.faceAllowed &&
      (
        !CONFIG.lightingValidation ||
        STATE.lightingAllowed
      ) &&
      !STATE.autoCaptureInProgress
    );
  }

  function scheduleAutoCaptureIfReady() {
    /*
     * V1.2A.4.6:
     * Cuando ya estamos en la ventana final de captura, los monitores de
     * luz/rostro siguen actualizando estado. Antes podían cancelar el timer
     * de disparo y dejar la UI atorada en “Capturando tu vista”.
     */
    if (STATE.autoCaptureInProgress) {
      updatePremiumCaptureStatus();
      return;
    }

    if (!canAutoCaptureNow()) {
      cancelAutoCapture();
      updatePremiumCaptureStatus();
      return;
    }

    if (
      (
        STATE.autoCaptureTimer ||
        STATE.autoCountdownTimer
      ) &&
      STATE.autoCaptureStepIndex === STATE.stepIndex
    ) {
      return;
    }

    cancelAutoCapture();
    STATE.autoCaptureStepIndex = STATE.stepIndex;
    setCountdownBadge(3);

    STATE.autoCountdownTimer = setInterval(function () {
      if (
        STATE.autoCaptureStepIndex !== STATE.stepIndex ||
        !canAutoCaptureNow()
      ) {
        cancelAutoCapture();
        updatePremiumCaptureStatus();
        return;
      }

      if (STATE.autoCountdownValue > 1) {
        setCountdownBadge(STATE.autoCountdownValue - 1);
        return;
      }

      clearInterval(STATE.autoCountdownTimer);
      STATE.autoCountdownTimer = null;
      setCountdownBadge(0);

      if (
        STATE.autoCaptureStepIndex !== STATE.stepIndex ||
        !canAutoCaptureNow()
      ) {
        cancelAutoCapture();
        updatePremiumCaptureStatus();
        return;
      }

      STATE.autoCaptureInProgress = true;
      paintFaceGuidanceStatus(
        'ready',
        COPY.guiaCapturando
      );

      if (DOM.captureBtn) {
        DOM.captureBtn.disabled = true;
      }

      STATE.autoCaptureTimer = setTimeout(function () {
        STATE.autoCaptureTimer = null;

        if (!STATE.autoCaptureInProgress) {
          return;
        }

        onCaptureClick(true);
      }, 140);
    }, 430);
  }

  function stopFaceGuidanceLoop() {
    cancelAutoCapture();

    if (STATE.faceRaf) {
      cancelAnimationFrame(STATE.faceRaf);
      STATE.faceRaf = null;
    }

    STATE.faceLastRunAt = 0;
    STATE.faceLastVideoTime = -1;
    STATE.faceAllowed = false;
    STATE.faceStableSince = 0;
    STATE.faceStableAnchor = null;
  }

  function startFaceGuidance() {
    stopFaceGuidanceLoop();
    resetFaceGuidanceValidation();

    if (!CONFIG.faceGuidance || STATE.faceFallback) {
      updateCaptureAvailability();
      return;
    }

    var settled = false;

    var timeoutId = setTimeout(function () {
      if (settled) return;
      settled = true;
      activateFaceGuidanceFallback('Tiempo de carga agotado.');
    }, CONFIG.faceLoadTimeoutMs);

    loadFaceLandmarker().then(function () {
      if (settled || STATE.faceFallback) return;
      settled = true;
      clearTimeout(timeoutId);

      if (
        STATE.phase !== 'capture' ||
        !STATE.stream
      ) {
        return;
      }

      STATE.faceRuntimeErrors = 0;
      root.removeAttribute('data-face-fallback-reason');
      resetFaceGuidanceValidation();
      STATE.faceRaf = requestAnimationFrame(faceGuidanceLoop);
    }).catch(function (error) {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      activateFaceGuidanceFallback(
        error && error.message
          ? error.message
          : 'Error al cargar MediaPipe.'
      );
    });
  }

  function mapLandmarkToDisplayedVideo(landmark) {
    if (!DOM.video || !DOM.cameraWrap || !landmark) return null;

    var vw = DOM.video.videoWidth;
    var vh = DOM.video.videoHeight;
    var wrapRect = DOM.cameraWrap.getBoundingClientRect();
    var cw = wrapRect.width;
    var ch = wrapRect.height;

    if (!vw || !vh || !cw || !ch) return null;

    /*
     * El video usa object-fit: cover y scaleX(-1).
     * Convertimos landmarks del video original a la imagen que el usuario ve.
     */
    var scale = Math.max(cw / vw, ch / vh);
    var drawnWidth = vw * scale;
    var drawnHeight = vh * scale;
    var offsetX = (cw - drawnWidth) / 2;
    var offsetY = (ch - drawnHeight) / 2;

    var xPx = (landmark.x * drawnWidth) + offsetX;
    var yPx = (landmark.y * drawnHeight) + offsetY;

    xPx = cw - xPx;

    return {
      x: xPx / cw,
      y: yPx / ch,
      z: Number(landmark.z || 0),
    };
  }

  function normalizeEyeAngle(angle) {
    while (angle > 90) angle -= 180;
    while (angle < -90) angle += 180;
    return angle;
  }

  function calculateFaceMetrics(landmarks) {
    if (!landmarks || landmarks.length < 455) return null;

    var mapped = [];
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    landmarks.forEach(function (landmark) {
      var point = mapLandmarkToDisplayedVideo(landmark);
      if (!point) return;

      mapped.push(point);
      minX = Math.min(minX, point.x);
      minY = Math.min(minY, point.y);
      maxX = Math.max(maxX, point.x);
      maxY = Math.max(maxY, point.y);
    });

    if (!mapped.length || !isFinite(minX) || !isFinite(minY)) return null;

    var nose = mapLandmarkToDisplayedVideo(landmarks[1]);
    var eyeA = mapLandmarkToDisplayedVideo(landmarks[33]);
    var eyeB = mapLandmarkToDisplayedVideo(landmarks[263]);
    var chin = mapLandmarkToDisplayedVideo(landmarks[152]);

    if (!nose || !eyeA || !eyeB || !chin) return null;

    var leftEye = eyeA.x <= eyeB.x ? eyeA : eyeB;
    var rightEye = eyeA.x <= eyeB.x ? eyeB : eyeA;
    var eyeMidY = (leftEye.y + rightEye.y) / 2;

    var leftDistance = Math.abs(nose.x - leftEye.x);
    var rightDistance = Math.abs(rightEye.x - nose.x);
    var eyeDistanceSum = Math.max(0.0001, leftDistance + rightDistance);

    var roll = Math.atan2(
      rightEye.y - leftEye.y,
      rightEye.x - leftEye.x
    ) * 180 / Math.PI;

    roll = normalizeEyeAngle(roll);

    var pitchDenominator = Math.max(0.0001, chin.y - eyeMidY);
    var pitchRatio = (nose.y - eyeMidY) / pitchDenominator;

    return {
      centerX: (minX + maxX) / 2,
      centerY: (minY + maxY) / 2,
      width: maxX - minX,
      height: maxY - minY,
      /*
       * V1.2A.4.2:
       * Safari/iPhone entrega la cámara frontal espejada visualmente.
       * La silueta está correcta, pero el signo de yaw quedaba invertido:
       * “izquierda” se aceptaba girando a la derecha y viceversa.
       * Invertimos solo la lectura de yaw, sin tocar siluetas ni layout.
       */
      yaw: (rightDistance - leftDistance) / eyeDistanceSum,
      roll: roll,
      pitchRatio: pitchRatio,
    };
  }

  function pointInsideBox(point, box) {
    return !!(
      point &&
      box &&
      point.x >= box.minX &&
      point.x <= box.maxX &&
      point.y >= box.minY &&
      point.y <= box.maxY
    );
  }

  function getFaceSafetyBoxes(metrics) {
    if (!metrics) return null;

    var minX = clampNumber(metrics.centerX - metrics.width * 0.46, 0, 1);
    var maxX = clampNumber(metrics.centerX + metrics.width * 0.46, 0, 1);
    var minY = clampNumber(metrics.centerY - metrics.height * 0.44, 0, 1);
    var maxY = clampNumber(metrics.centerY + metrics.height * 0.28, 0, 1);

    return {
      face: { minX: minX, maxX: maxX, minY: minY, maxY: maxY },
      upper: {
        minX: clampNumber(metrics.centerX - metrics.width * 0.4, 0, 1),
        maxX: clampNumber(metrics.centerX + metrics.width * 0.4, 0, 1),
        minY: clampNumber(metrics.centerY - metrics.height * 0.42, 0, 1),
        maxY: clampNumber(metrics.centerY - metrics.height * 0.02, 0, 1),
      },
      center: {
        minX: clampNumber(metrics.centerX - metrics.width * 0.28, 0, 1),
        maxX: clampNumber(metrics.centerX + metrics.width * 0.28, 0, 1),
        minY: clampNumber(metrics.centerY - metrics.height * 0.26, 0, 1),
        maxY: clampNumber(metrics.centerY + metrics.height * 0.18, 0, 1),
      },
    };
  }

  function evaluateHandObstruction(metrics, now) {
    if (
      !CONFIG.handObstructionValidation ||
      !STATE.handLandmarker ||
      !DOM.video ||
      !metrics
    ) {
      return { ok: true };
    }

    var result;

    try {
      result = STATE.handLandmarker.detectForVideo(DOM.video, now);
      STATE.handRuntimeErrors = 0;
    } catch (error) {
      STATE.handRuntimeErrors += 1;
      if (STATE.handRuntimeErrors > 6) {
        root.setAttribute('data-hand-obstruction', 'runtime-unavailable');
      }
      return { ok: true };
    }

    var hands = (result && (result.landmarks || result.handLandmarks)) || [];
    if (!hands.length) {
      root.setAttribute('data-hand-obstruction-active', 'false');
      return { ok: true };
    }

    var boxes = getFaceSafetyBoxes(metrics);
    var blocked = false;

    hands.forEach(function (hand) {
      var faceHits = 0;
      var upperHits = 0;
      var centerHits = 0;

      (hand || []).forEach(function (landmark) {
        var point = mapLandmarkToDisplayedVideo(landmark);
        if (pointInsideBox(point, boxes.face)) faceHits += 1;
        if (pointInsideBox(point, boxes.upper)) upperHits += 1;
        if (pointInsideBox(point, boxes.center)) centerHits += 1;
      });

      if (centerHits >= 1 || upperHits >= 2 || faceHits >= 4) {
        blocked = true;
      }
    });

    root.setAttribute('data-hand-obstruction-active', blocked ? 'true' : 'false');

    return blocked
      ? { ok: false, message: COPY.guiaObstruccion }
      : { ok: true };
  }


  function getLandmarkRegionBounds(landmarks, indexes, expandX, expandY) {
    if (!DOM.video || !DOM.video.videoWidth || !DOM.video.videoHeight) return null;
    if (!landmarks || !landmarks.length) return null;

    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;

    indexes.forEach(function (index) {
      var point = landmarks[index];
      if (!point) return;
      minX = Math.min(minX, point.x);
      minY = Math.min(minY, point.y);
      maxX = Math.max(maxX, point.x);
      maxY = Math.max(maxY, point.y);
    });

    if (!isFinite(minX) || !isFinite(minY) || !isFinite(maxX) || !isFinite(maxY)) {
      return null;
    }

    var vw = DOM.video.videoWidth;
    var vh = DOM.video.videoHeight;
    var width = Math.max(0.04, maxX - minX);
    var height = Math.max(0.035, maxY - minY);

    minX = clampNumber(minX - width * expandX, 0, 1);
    maxX = clampNumber(maxX + width * expandX, 0, 1);
    minY = clampNumber(minY - height * expandY, 0, 1);
    maxY = clampNumber(maxY + height * expandY, 0, 1);

    return {
      sx: minX * vw,
      sy: minY * vh,
      sw: Math.max(1, (maxX - minX) * vw),
      sh: Math.max(1, (maxY - minY) * vh),
    };
  }

  function measureLandmarkRegionStats(landmarks, indexes, expandX, expandY) {
    var bounds = getLandmarkRegionBounds(landmarks, indexes, expandX, expandY);
    if (!bounds) return null;

    return measureVideoRegionStats(
      bounds.sx,
      bounds.sy,
      bounds.sw,
      bounds.sh,
      36
    );
  }

  function eyeVisibilityScore(stats) {
    if (!stats) return 0;

    var contrastScore = clampNumber((stats.contrast - 14) / 48, 0, 1);
    var darkScore = clampNumber(stats.darkRatio / 0.16, 0, 1);
    var brightPenalty = clampNumber((stats.brightRatio - 0.16) / 0.22, 0, 1);

    return clampNumber((contrastScore * 0.55) + (darkScore * 0.45) - brightPenalty, 0, 1);
  }

  function eyeRegionLooksObstructed(eyeStats, leftEyeStats, rightEyeStats, upperFaceStats, midFaceStats) {
    if (!eyeStats || !leftEyeStats || !rightEyeStats || !midFaceStats) {
      return false;
    }

    var leftEyeScore = eyeVisibilityScore(leftEyeStats);
    var rightEyeScore = eyeVisibilityScore(rightEyeStats);
    var bothEyesMuted = leftEyeScore < 0.1 && rightEyeScore < 0.1;
    var eyesSkinLike = Math.abs(eyeStats.luma - midFaceStats.luma) < 30;
    var eyesTooFlat = eyeStats.contrast < 18 && midFaceStats.contrast > 22;
    var eyesTooTextured = eyeStats.contrast > midFaceStats.contrast + 32 && eyeStats.contrast > 72;
    var upperMismatch = upperFaceStats && (
      Math.abs(upperFaceStats.luma - midFaceStats.luma) > 44 ||
      upperFaceStats.contrast > midFaceStats.contrast + 26 ||
      upperFaceStats.brightRatio > 0.24
    );

    return (
      (bothEyesMuted && eyesSkinLike && upperMismatch && (eyesTooFlat || eyesTooTextured)) ||
      (
        upperFaceStats &&
        upperFaceStats.contrast > 78 &&
        eyeStats.darkRatio < 0.045 &&
        eyesSkinLike
      )
    );
  }

  function evaluateFaceCleanliness(landmarks, metrics, stepKey) {
    if (!CONFIG.capturePremiumQa || !CONFIG.obstructionValidation) {
      return { ok: true };
    }

    /*
     * Detección conservadora de obstrucciones. Evita mandar capturas con
     * frente, ojos, mejillas o boca claramente tapadas, sin bloquear por
     * pequeñas sombras normales del ángulo 3/4.
     */
    var isProfile = stepKey !== 'frontal';

    var eyeStats = measureLandmarkRegionStats(
      landmarks,
      [33, 133, 159, 263, 362, 386],
      1.35,
      1.55
    );

    var leftEyeStats = measureLandmarkRegionStats(
      landmarks,
      [33, 133, 159, 145, 153, 160],
      1.65,
      1.75
    );

    var rightEyeStats = measureLandmarkRegionStats(
      landmarks,
      [263, 362, 386, 374, 380, 387],
      1.65,
      1.75
    );

    if (eyeStats) {
      if (eyeStats.darkRatio > 0.62 && eyeStats.luma < 72) {
        return { ok: false, message: COPY.guiaLentes };
      }

      if (eyeStats.brightRatio > 0.18 && eyeStats.contrast > 78) {
        return { ok: false, message: COPY.guiaLentes };
      }

      if (
        leftEyeStats &&
        rightEyeStats &&
        (
          (
            leftEyeStats.brightRatio > 0.13 &&
            rightEyeStats.brightRatio > 0.13 &&
            eyeStats.contrast > 58
          ) ||
          (
            leftEyeStats.darkRatio > 0.34 &&
            rightEyeStats.darkRatio > 0.34 &&
            eyeStats.contrast > 46 &&
            eyeStats.luma < 128
          )
        )
      ) {
        return { ok: false, message: COPY.guiaLentes };
      }
    }

    var upperFaceStats = measureLandmarkRegionStats(
      landmarks,
      [9, 10, 55, 65, 70, 107, 151, 285, 295, 300, 336],
      isProfile ? 0.95 : 1.2,
      isProfile ? 1.1 : 1.65
    );

    var lowerFaceStats = measureLandmarkRegionStats(
      landmarks,
      [0, 13, 14, 17, 78, 308, 152],
      0.95,
      0.75
    );

    var midFaceStats = measureLandmarkRegionStats(
      landmarks,
      [1, 4, 48, 50, 205, 278, 280, 425],
      0.65,
      0.65
    );

    if (
      !isProfile &&
      eyeRegionLooksObstructed(
        eyeStats,
        leftEyeStats,
        rightEyeStats,
        upperFaceStats,
        midFaceStats
      )
    ) {
      return { ok: false, message: COPY.guiaObstruccion };
    }

    if (!isProfile && eyeStats && midFaceStats) {
      var eyesLookCovered = (
        (
          eyeStats.contrast < 20 &&
          midFaceStats.contrast > 18 &&
          Math.abs(eyeStats.luma - midFaceStats.luma) < 38
        ) ||
        (
          eyeStats.contrast > 62 &&
          eyeStats.contrast > midFaceStats.contrast + 20
        ) ||
        (
          eyeStats.darkRatio > 0.42 &&
          eyeStats.luma < midFaceStats.luma - 18
        )
      );

      if (eyesLookCovered) {
        return { ok: false, message: COPY.guiaObstruccion };
      }
    }

    if (upperFaceStats) {
      var upperContrastLimit = isProfile ? 78 : 82;
      var upperDarkLimit = isProfile ? 0.72 : 0.74;
      var upperLooksCovered = (
        (upperFaceStats.darkRatio > upperDarkLimit && upperFaceStats.luma < 96) ||
        (upperFaceStats.brightRatio > 0.3 && upperFaceStats.contrast > 70) ||
        (
          midFaceStats &&
          Math.abs(upperFaceStats.luma - midFaceStats.luma) > 48 &&
          upperFaceStats.contrast > 42
        ) ||
        (
          midFaceStats &&
          upperFaceStats.contrast > upperContrastLimit &&
          upperFaceStats.contrast > midFaceStats.contrast + 10
        )
      );

      if (upperLooksCovered) {
        return { ok: false, message: COPY.guiaObstruccion };
      }
    }

    if (
      lowerFaceStats &&
      lowerFaceStats.darkRatio > 0.72 &&
      lowerFaceStats.luma < 70
    ) {
      return { ok: false, message: COPY.guiaObstruccion };
    }

    return { ok: true };
  }

  function isLargeCaptureViewport() {
    var info = computeResponsiveMode();

    /*
     * V1.2A.5.2:
     * La captura grande ya no depende solo de medidas crudas.
     * Se activa en tablet/laptop reales, no en celular horizontal.
     */
    return (
      info.family === 'tablet' ||
      info.family === 'desktop' ||
      (info.viewport.maxSide >= 1000 && info.viewport.minSide >= 650)
    );
  }

  function isAndroidMobileCapture() {
    return STATE.deviceFamily === 'mobile' && STATE.devicePlatform === 'android';
  }

  function getFaceStepRules(stepKey) {
    var largeCapture = isLargeCaptureViewport();
    var androidMobile = isAndroidMobileCapture();

    if (stepKey === 'frontal') {
      if (largeCapture) {
        return {
          /*
           * V1.2A.5.1.9:
           * El backend seguía rechazando iPad con CALIDAD_IMAGEN_INSUFICIENTE.
           * La resolución era buena, así que el problema era rostro con poco
           * detalle útil. Pedimos el rostro apenas más protagonista, sin volver
           * a la cercanía incómoda de versiones anteriores.
           */
          minWidth: 0.30,
          maxWidth: 1.04,
          minHeight: 0.40,
          maxHeight: 1.12,
          centerToleranceX: 0.23,
          centerToleranceY: 0.23,
        };
      }

      if (androidMobile) {
        return {
          /*
           * V1.2A.5.3.3 — SOLO Android Chrome:
           * Android suele mostrar el preview con más sensación de zoom y el
           * usuario termina pegando el teléfono al rostro. Bajamos el mínimo
           * y damos más tolerancia de centro para permitir una distancia más
           * cómoda sin afectar iPhone, iPad, tablet ni desktop.
           */
          minWidth: 0.22,
          maxWidth: 1.18,
          minHeight: 0.30,
          maxHeight: 1.30,
          centerToleranceX: 0.24,
          centerToleranceY: 0.26,
        };
      }

      return {
        /*
         * Móvil iOS / otros:
         * Conservamos la calibración que ya funcionaba bien en iPhone/celular.
         */
        minWidth: 0.34,
        maxWidth: 1.08,
        minHeight: 0.44,
        maxHeight: 1.16,
        centerToleranceX: 0.16,
        centerToleranceY: 0.18,
      };
    }

    if (largeCapture) {
      return {
        /*
         * V1.2A.5.1.9:
         * Perfiles 3/4 con más detalle útil. Acepta distancia cómoda,
         * pero evita mandar mejillas/ojos demasiado pequeños al backend.
         */
        minWidth: 0.26,
        maxWidth: 1.0,
        minHeight: 0.38,
        maxHeight: 1.1,
        centerToleranceX: 0.25,
        centerToleranceY: 0.24,
      };
    }

    if (androidMobile) {
      return {
        /*
         * V1.2A.5.3.2 — SOLO Android Chrome / perfiles:
         * Misma idea que frontal: permitir más distancia física en Android,
         * pero manteniendo suficiente rostro para lectura cosmética.
         */
        minWidth: 0.20,
        maxWidth: 1.12,
        minHeight: 0.30,
        maxHeight: 1.24,
        centerToleranceX: 0.28,
        centerToleranceY: 0.26,
      };
    }

    return {
      minWidth: 0.27,
      maxWidth: 1.02,
      minHeight: 0.42,
      maxHeight: 1.14,
      centerToleranceX: 0.2,
      centerToleranceY: 0.19,
    };
  }

  function evaluateFacePose(metrics, stepKey) {
    var rules = getFaceStepRules(stepKey);

    if (
      metrics.width < rules.minWidth ||
      metrics.height < rules.minHeight
    ) {
      return { ok: false, message: COPY.guiaAcercate };
    }

    if (
      metrics.width > rules.maxWidth ||
      metrics.height > rules.maxHeight
    ) {
      return { ok: false, message: COPY.guiaAlejate };
    }

    if (
      Math.abs(metrics.centerX - 0.5) > rules.centerToleranceX ||
      Math.abs(metrics.centerY - 0.51) > rules.centerToleranceY
    ) {
      return { ok: false, message: COPY.guiaCentra };
    }

    if (Math.abs(metrics.roll) > 8.5) {
      return { ok: false, message: COPY.guiaEndereza };
    }

    if (
      metrics.pitchRatio < 0.24 ||
      metrics.pitchRatio > 0.72
    ) {
      return { ok: false, message: COPY.guiaMiraFrente };
    }

    if (stepKey === 'frontal') {
      if (Math.abs(metrics.yaw) > 0.22) {
        return { ok: false, message: COPY.guiaFrontal };
      }

      return { ok: true };
    }

    if (stepKey === 'perfil_izq') {
      if (metrics.yaw > 0.1) {
        return { ok: false, message: COPY.guiaDireccionIzquierda };
      }

      /*
       * Buscamos vista 3/4, no perfil completo:
       * - muy cerca de 0: sigue demasiado frontal
       * - demasiado extremo: parece 90° y pierde información útil
       */
      if (metrics.yaw > -0.18) {
        return { ok: false, message: COPY.guiaIzquierda };
      }

      if (metrics.yaw < -0.62) {
        return { ok: false, message: COPY.guiaRegresaCentro };
      }

      return { ok: true };
    }

    if (stepKey === 'perfil_der') {
      if (metrics.yaw < -0.1) {
        return { ok: false, message: COPY.guiaDireccionDerecha };
      }

      /*
       * Buscamos vista 3/4, no perfil completo:
       * - muy cerca de 0: sigue demasiado frontal
       * - demasiado extremo: parece 90° y pierde información útil
       */
      if (metrics.yaw < 0.18) {
        return { ok: false, message: COPY.guiaDerecha };
      }

      if (metrics.yaw > 0.62) {
        return { ok: false, message: COPY.guiaRegresaCentro };
      }

      return { ok: true };
    }

    return { ok: true };
  }

  function isFaceStableAgainstAnchor(metrics, anchor) {
    if (!anchor) return false;

    return (
      Math.abs(metrics.centerX - anchor.centerX) <= 0.025 &&
      Math.abs(metrics.centerY - anchor.centerY) <= 0.025 &&
      Math.abs(metrics.width - anchor.width) <= 0.035 &&
      Math.abs(metrics.height - anchor.height) <= 0.035 &&
      Math.abs(metrics.yaw - anchor.yaw) <= 0.09 &&
      Math.abs(metrics.roll - anchor.roll) <= 4.2 &&
      Math.abs(metrics.pitchRatio - anchor.pitchRatio) <= 0.08
    );
  }

  function processFaceLandmarkerResult(result, now) {
    var faces =
      (result && (result.faceLandmarks || result.face_landmarks)) ||
      [];

    if (!faces.length) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', COPY.guiaSinRostro);
      updateAndroidCameraDebugPanel('no-face');
      return;
    }

    if (faces.length > 1) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', COPY.guiaUnRostro);
      updateAndroidCameraDebugPanel('multi-face');
      return;
    }

    var metrics = calculateFaceMetrics(faces[0]);

    if (!metrics) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', COPY.guiaSinRostro);
      return;
    }

    STATE.faceMetrics = metrics;
    updateAndroidCameraDebugPanel('face-metrics');

    if (root.dataset.debugFace === 'true') {
      root.setAttribute(
        'data-face-metrics',
        JSON.stringify({
          x: Number(metrics.centerX.toFixed(3)),
          y: Number(metrics.centerY.toFixed(3)),
          w: Number(metrics.width.toFixed(3)),
          h: Number(metrics.height.toFixed(3)),
          yaw: Number(metrics.yaw.toFixed(3)),
          roll: Number(metrics.roll.toFixed(1)),
          pitch: Number(metrics.pitchRatio.toFixed(3)),
        })
      );
    }

    var step = CAPTURE_STEPS[STATE.stepIndex];
    var handBlock = evaluateHandObstruction(metrics, now);

    if (!handBlock.ok) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', handBlock.message || COPY.guiaObstruccion);
      updateAndroidCameraDebugPanel('hand-obstruction');
      return;
    }

    var clean = evaluateFaceCleanliness(faces[0], metrics, step ? step.key : 'frontal');

    if (!clean.ok) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', clean.message || COPY.guiaRostroDespejado);
      return;
    }

    var pose = evaluateFacePose(metrics, step ? step.key : 'frontal');

    if (!pose.ok) {
      STATE.faceAllowed = false;
      STATE.faceStableSince = 0;
      STATE.faceStableAnchor = null;
      paintFaceGuidanceStatus('warning', pose.message);
      return;
    }

    if (
      !STATE.faceStableAnchor ||
      !isFaceStableAgainstAnchor(metrics, STATE.faceStableAnchor)
    ) {
      STATE.faceStableAnchor = {
        centerX: metrics.centerX,
        centerY: metrics.centerY,
        width: metrics.width,
        height: metrics.height,
        yaw: metrics.yaw,
        roll: metrics.roll,
        pitchRatio: metrics.pitchRatio,
      };
      STATE.faceStableSince = now;
      STATE.faceAllowed = false;
      paintFaceGuidanceStatus('stabilizing', COPY.guiaEstable);
      return;
    }

    if (now - STATE.faceStableSince < CONFIG.faceStableMs) {
      STATE.faceAllowed = false;
      paintFaceGuidanceStatus('stabilizing', COPY.guiaEstable);
      return;
    }

    STATE.faceAllowed = true;
    paintFaceGuidanceStatus('ready', COPY.guiaLista);
  }

  function runFaceDetection(now) {
    if (
      !STATE.faceLandmarker ||
      !DOM.video ||
      !DOM.video.videoWidth ||
      DOM.video.readyState < 2
    ) {
      return;
    }

    if (DOM.video.currentTime === STATE.faceLastVideoTime) {
      return;
    }

    var result;

    try {
      result = STATE.faceLandmarker.detectForVideo(DOM.video, now);
    } catch (firstError) {
      /*
       * Compatibilidad con builds que infieren el timestamp internamente.
       */
      result = STATE.faceLandmarker.detectForVideo(DOM.video);
    }

    STATE.faceLastVideoTime = DOM.video.currentTime;
    STATE.faceRuntimeErrors = 0;
    processFaceLandmarkerResult(result, now);
  }

  function faceGuidanceLoop(now) {
    STATE.faceRaf = null;

    if (
      STATE.phase !== 'capture' ||
      !STATE.stream ||
      STATE.faceFallback ||
      !CONFIG.faceGuidance
    ) {
      return;
    }

    if (
      document.visibilityState === 'visible' &&
      now - STATE.faceLastRunAt >= CONFIG.faceSampleMs
    ) {
      STATE.faceLastRunAt = now;

      try {
        runFaceDetection(now);
      } catch (error) {
        STATE.faceRuntimeErrors += 1;
        console.warn('[RŌGMA Face] Error de inferencia:', error);

        if (STATE.faceRuntimeErrors >= 3) {
          activateFaceGuidanceFallback(
            error && error.message
              ? error.message
              : 'Errores repetidos durante la detección.'
          );
          return;
        }
      }
    }

    STATE.faceRaf = requestAnimationFrame(faceGuidanceLoop);
  }

  /* ═══════════════════════════════════════════════════════════
     CAMERA
     ═══════════════════════════════════════════════════════════ */

  function stopCamera() {
    stopLightingMonitor();
    stopFaceGuidanceLoop();
    stopAndroidDebugTimer();

    if (STATE.stream) {
      STATE.stream.getTracks().forEach(function (track) {
        track.stop();
      });
      STATE.stream = null;
    }
    if (DOM.video) DOM.video.srcObject = null;
  }


  function rogmaApplyAndroidCameraComfort(stream) {
    try {
      var isAndroidMobile =
        STATE.deviceFamily === 'mobile' &&
        STATE.devicePlatform === 'android';

      if (!isAndroidMobile || !stream) return;

      var tracks = stream.getVideoTracks ? stream.getVideoTracks() : [];
      var track = tracks && tracks[0];
      if (!track || !track.getCapabilities || !track.applyConstraints) return;

      var caps = track.getCapabilities();
      if (!caps || !caps.zoom) return;

      var minZoom = typeof caps.zoom.min === 'number' ? caps.zoom.min : 1;

      track.applyConstraints({
        advanced: [{ zoom: minZoom }],
      }).then(function () {
        console.info('[RŌGMA] Android camera zoom adjusted:', minZoom);
      }).catch(function (error) {
        console.warn('[RŌGMA] Android camera zoom adjustment skipped:', error);
      });
    } catch (error) {
      console.warn('[RŌGMA] Android camera comfort skipped:', error);
    }
  }

  function startCamera() {
    hideCaptureTransition();
    setCountdownBadge(0);
    stopCamera();

    /*
     * El fallback solo pertenece a la sesión anterior. Cada nuevo escaneo
     * puede reintentar MediaPipe, por ejemplo si la red ya se recuperó.
     */
    STATE.faceFallback = false;
    STATE.faceFallbackReason = '';
    root.removeAttribute('data-face-fallback-reason');

    DOM.cameraError.hidden = true;

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      showCameraError('Tu navegador no admite acceso a la cámara. Prueba con Safari o Chrome actualizado.');
      return Promise.reject(new Error('no getUserMedia'));
    }

    var largeCapture = isLargeCaptureViewport();
    var androidMobileCamera = STATE.deviceFamily === 'mobile' && STATE.devicePlatform === 'android';

    var constraints = {
      audio: false,
      video: {
        facingMode: { ideal: 'user' },

        /*
         * V1.2A.5.3.7:
         * Android Chrome puede devolver la cámara frontal en 4:3 aunque el UI
         * móvil pida 3:4. Si el marco visual se queda vertical, object-fit: cover
         * recorta los lados y el rostro se ve demasiado cerca. En Android móvil
         * pedimos 4:3 desde el inicio para empatar stream + preview + captura.
         * iPhone, iPad, tablet y desktop conservan su comportamiento anterior.
         */
        width: { ideal: androidMobileCamera ? 2560 : (largeCapture ? 2560 : 1920) },
        height: { ideal: androidMobileCamera ? 1920 : (largeCapture ? 1920 : 2560) },
        aspectRatio: { ideal: androidMobileCamera ? 4 / 3 : (largeCapture ? 4 / 3 : 3 / 4) },
        frameRate: { ideal: 30, max: 30 },
      },
    };

    return navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
      STATE.stream = stream;
      DOM.video.srcObject = stream;
      DOM.video.setAttribute('playsinline', '');
      DOM.video.setAttribute('webkit-playsinline', 'true');
      DOM.video.muted = true;
      rogmaApplyAndroidCameraComfort(stream);
      if (isRogmaDebugEnabled() && STATE.deviceFamily === 'mobile' && STATE.devicePlatform === 'android') {
        root.setAttribute('data-android-camera-debug-mode', 'true');
        DOM.video.addEventListener('loadedmetadata', function () {
          updateAndroidCameraDebugPanel('loadedmetadata');
        }, { once: true });
      }
      return DOM.video.play().then(function () {
        startLightingMonitor();
        startFaceGuidance();
        startAndroidDebugTimer();
        updateAndroidCameraDebugPanel('play');
      });
    }).catch(function (err) {
      var msg = 'No pudimos acceder a la cámara.';
      if (err && err.name === 'NotAllowedError') {
        msg = 'Permiso de cámara denegado. Actívalo en Ajustes del navegador e inténtalo de nuevo.';
      } else if (err && err.name === 'NotFoundError') {
        msg = 'No encontramos una cámara en este dispositivo.';
      } else if (err && err.name === 'NotReadableError') {
        msg = 'La cámara está en uso por otra aplicación. Ciérrala e inténtalo de nuevo.';
      }
      showCameraError(msg);
      throw err;
    });
  }

  function showCameraError(msg) {
    DOM.cameraError.textContent = msg;
    DOM.cameraError.hidden = false;
  }

  /* ═══════════════════════════════════════════════════════════
     CAPTURE_FLOW
     ═══════════════════════════════════════════════════════════ */


  function setPreCameraModalVisible(visible) {
    if (!DOM.preCameraModal) return;
    DOM.preCameraModal.hidden = !visible;
    DOM.preCameraModal.setAttribute('aria-hidden', visible ? 'false' : 'true');
    root.classList.toggle('rogma-scan--pre-camera-open', !!visible);

    if (visible && DOM.preCameraContinue) {
      setTimeout(function () {
        try { DOM.preCameraContinue.focus({ preventScroll: true }); } catch (error) { DOM.preCameraContinue.focus(); }
      }, 60);
    }
  }

  function openPreCameraModal() {
    if (!DOM.preCameraModal || !DOM.preCameraContinue) {
      beginCaptureAfterPreCameraConsent();
      return;
    }
    setPreCameraModalVisible(true);
  }

  function closePreCameraModal() {
    setPreCameraModalVisible(false);
  }

  function beginCaptureAfterPreCameraConsent() {
    STATE.preCameraConsentSeen = true;
    closePreCameraModal();
    DOM.prepError.hidden = true;
    STATE.stepIndex = 0;
    STATE.captures = { frontal: null, perfil_izq: null, perfil_der: null };
    STATE.previewUrls = {};
    STATE.captureDebugFrames = {};
    STATE.captureDebugFramesFallback = {};
    STATE.capturesQualityFallback = { frontal: null, perfil_izq: null, perfil_der: null };
    STATE.qualityRetryUsed = false;
    STATE.lastAttemptMode = 'smart-face-crop';
    STATE.lastCaptureDebug = null;
    STATE.lastApiError = null;
    STATE.lastApiErrorMessage = '';
    STATE.lastResponseStatus = null;
    showPhase('capture');
    renderCaptureStep();
    trackRogmaEvent('camera_started', {
      step: getCurrentCaptureStepKey(),
    });
    startCamera();
  }

  function validatePrep() {
    var trimmed = (DOM.edad.value || '').trim();
    if (!trimmed) return 'Introduce tu edad para continuar.';
    var edad = parseInt(trimmed, 10);
    if (isNaN(edad)) return 'Introduce una edad válida.';
    if (edad < CONFIG.minAge) {
      return 'Debes tener al menos ' + CONFIG.minAge + ' años para realizar la evaluación.';
    }
    if (edad > CONFIG.maxAge) {
      return 'La edad máxima permitida es ' + CONFIG.maxAge + ' años.';
    }
    if (!DOM.consent.checked) {
      return 'Debes aceptar el procesamiento de imágenes para continuar.';
    }
    STATE.edad = edad;
    STATE.displayName = sanitizeName(DOM.nombre.value);
    STATE.consent = true;
    return null;
  }

  function startCaptureFlow() {
    var err = validatePrep();
    if (err) {
      DOM.prepError.textContent = err;
      DOM.prepError.hidden = false;
      return;
    }
    DOM.prepError.hidden = true;
    resetAnalyticsScanId();
    trackRogmaEvent('age_submitted', {
      edad: STATE.edad,
      nombre_capturado: STATE.displayName ? 'true' : 'false',
      consentimiento: STATE.consent ? 'true' : 'false',
    }, { forceScanId: true });
    openPreCameraModal();
  }
  function backToPrep() {
    stopCamera();
    showPhase('prep');
  }

  function renderCaptureStep() {
    hideCaptureTransition();
    setCountdownBadge(0);

    var step = CAPTURE_STEPS[STATE.stepIndex];
    DOM.stepTitle.textContent = step.title;
    DOM.stepHint.textContent = step.hint;
    renderCaptureGuide(step);
    DOM.captureBtn.textContent = step.button;

    if (DOM.retakeCurrent) {
      DOM.retakeCurrent.hidden = !STATE.previewUrls[step.key];
    }

    DOM.oval.className = 'rogma-scan__oval ' + step.ovalClass;
    DOM.retakeCurrent.hidden = !STATE.captures[step.key];
    updateTimeline();

    /*
     * Cada vista requiere una iluminación estable nueva. El cambio de perfil
     * puede alterar la exposición automática de la cámara.
     */
    resetLightingValidation();
    resetFaceGuidanceValidation();
    if (STATE.deviceFamily === 'mobile' && STATE.devicePlatform === 'android') {
      STATE.androidDebugFrozen = false;
      STATE.androidDebugFrozenAt = 0;
      STATE.androidDebugFrozenReason = '';
    }
    updatePremiumCaptureStatus();
    updateAndroidCameraDebugPanel('render-step', true);
  }

  async function onCaptureClick(autoTriggered) {
    var isAuto = autoTriggered === true;
    var step = CAPTURE_STEPS[STATE.stepIndex];

    if (STATE.autoCaptureInProgress && !isAuto) {
      return;
    }

    cancelAutoCapture();
    if (!DOM.video.videoWidth) {
      releaseAutoCaptureLock();
      showCameraError('Espera a que la cámara esté lista.');
      return;
    }

    if (CONFIG.lightingValidation && !STATE.lightingAllowed) {
      releaseAutoCaptureLock();

      showCameraError(getFriendlyLightDetail() || 'Espera un momento mientras comprobamos la iluminación.');
      return;
    }

    if (
      CONFIG.faceGuidance &&
      !STATE.faceFallback &&
      !STATE.faceAllowed
    ) {
      releaseAutoCaptureLock();

      showCameraError(
        STATE.faceMessage ||
        'Ajusta tu rostro dentro de la guía antes de capturar.'
      );
      return;
    }

    DOM.cameraError.hidden = true;
    STATE.autoCaptureInProgress = true;

    try {
      var packed = await captureBestVideoFrame(DOM.video, step.key);
      STATE.captureDebugFrames[step.key] = packed.debug;
      STATE.lastCaptureDebug = packed.debug;
      STATE.captures[step.key] = packed.base64;
      STATE.previewUrls[step.key] = packed.dataUrl;

      var captureEventName = step.key === 'frontal'
        ? 'front_captured'
        : (step.key === 'perfil_izq' ? 'left_profile_captured' : 'right_profile_captured');
      trackRogmaEvent(captureEventName, {
        step: step.key,
        auto_triggered: isAuto ? 'true' : 'false',
        attempt_mode: STATE.lastAttemptMode || '',
        lighting_status: STATE.lightingStatus || '',
        face_fallback: STATE.faceFallback ? 'true' : 'false',
      });

      if (isLargeCaptureViewport()) {
        try {
          var fallbackPacked = await captureBestFullDetailVideoFrame(DOM.video, step.key);
          STATE.capturesQualityFallback[step.key] = fallbackPacked.base64;
          STATE.captureDebugFramesFallback[step.key] = fallbackPacked.debug;
        } catch (fallbackError) {
          console.warn('[ROGMA Capture] No pudimos preparar fallback de calidad:', fallbackError);
        }
      }
      triggerFlash();

      if (DOM.retakeCurrent) {
        DOM.retakeCurrent.hidden = true;
      }

      if (STATE.stepIndex < CAPTURE_STEPS.length - 1) {
        var completedStep = step;
        var nextStepIndex = STATE.stepIndex + 1;
        var nextStep = CAPTURE_STEPS[nextStepIndex];

        showCaptureTransition(completedStep, nextStep, function () {
          STATE.autoCaptureInProgress = false;
          STATE.stepIndex = nextStepIndex;
          renderCaptureStep();
        });
      } else {
        showCaptureTransition(step, null, function () {
          STATE.autoCaptureInProgress = false;
          stopCamera();
          sendAnalysis();
        });
      }
    } catch (e) {
      console.error('[RŌGMA Capture] No pudimos completar la captura:', e);
      releaseAutoCaptureLock();
      showCameraError('No pudimos capturar la imagen. Inténtalo de nuevo.');
    }
  }

  function retakeCurrentStep() {
    hideCaptureTransition();
    setCountdownBadge(0);

    var step = CAPTURE_STEPS[STATE.stepIndex];
    STATE.captures[step.key] = null;
    delete STATE.previewUrls[step.key];
    DOM.retakeCurrent.hidden = true;
    resetLightingValidation();
    resetFaceGuidanceValidation();
  }

  function triggerFlash() {
    DOM.flash.hidden = false;
    setTimeout(function () {
      DOM.flash.hidden = true;
    }, 450);
  }

  function renderReview() {
    DOM.previews.innerHTML = CAPTURE_STEPS.map(function (step) {
      var url = STATE.previewUrls[step.key] || '';
      return (
        '<div class="rogma-scan__preview">' +
          '<img src="' + escapeAttr(url) + '" alt="' + escapeAttr(step.label) + '">' +
          '<span>' + escapeHtml(step.label) + '</span>' +
        '</div>'
      );
    }).join('');
    DOM.reviewError.hidden = true;
  }

  function resetCaptureFlow() {
    stopCamera();
    STATE.stepIndex = 0;
    STATE.captures = { frontal: null, perfil_izq: null, perfil_der: null };
    STATE.previewUrls = {};
    STATE.rawResult = null;
    STATE.normalized = null;
    showPhase('capture');
    renderCaptureStep();
    startCamera();
  }

  function fullReset() {
    stopCamera();
    STATE.edad = null;
    STATE.displayName = '';
    STATE.captures = { frontal: null, perfil_izq: null, perfil_der: null };
    STATE.previewUrls = {};
    STATE.rawResult = null;
    STATE.normalized = null;
    DOM.edad.value = '';
    DOM.nombre.value = '';
    DOM.consent.checked = false;
    DOM.prepError.hidden = true;
    updatePrepButton();
    showPhase('prep');
  }

  /* ═══════════════════════════════════════════════════════════
     API
     ═══════════════════════════════════════════════════════════ */

  function isLandscapeViewport() {
    var width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      root.clientWidth ||
      0;
    var height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      0;

    return width > height;
  }

  function getCaptureFrameAspectRatio(video) {
    /*
     * V1.2A.5.1.7:
     * En iPad/tablet/laptop la cámara nativa suele entregar landscape 4:3.
     * Si forzamos crop vertical, tiramos mucha resolución y el backend puede
     * rechazar por poco detalle. En pantallas grandes capturamos más parecido
     * al sensor real.
     */
    if (isLargeCaptureViewport() && isLandscapeViewport()) {
      if (video && video.videoWidth && video.videoHeight) {
        var sourceAspect = video.videoWidth / video.videoHeight;
        if (sourceAspect >= 1) {
          return Math.min(1.45, Math.max(1.15, sourceAspect));
        }
      }
      return 4 / 3;
    }

    if (
      DOM.cameraWrap &&
      DOM.cameraWrap.clientWidth &&
      DOM.cameraWrap.clientHeight
    ) {
      return (
        DOM.cameraWrap.clientWidth /
        DOM.cameraWrap.clientHeight
      );
    }

    return 4 / 5;
  }

  function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function mapDisplayedPointToSource(video, xNorm, yNorm) {
    if (!DOM.cameraWrap || !video || !video.videoWidth || !video.videoHeight) {
      return null;
    }

    var vw = video.videoWidth;
    var vh = video.videoHeight;
    var wrapRect = DOM.cameraWrap.getBoundingClientRect();
    var cw = wrapRect.width;
    var ch = wrapRect.height;

    if (!cw || !ch) return null;

    var scale = Math.max(cw / vw, ch / vh);
    var drawnWidth = vw * scale;
    var drawnHeight = vh * scale;
    var offsetX = (cw - drawnWidth) / 2;
    var offsetY = (ch - drawnHeight) / 2;

    /*
     * La vista está espejada con CSS. Invertimos X para regresar al frame real.
     */
    var displayedX = clampNumber(xNorm, 0, 1) * cw;
    var displayedY = clampNumber(yNorm, 0, 1) * ch;
    var sourceDrawnX = cw - displayedX;

    return {
      x: (sourceDrawnX - offsetX) / scale,
      y: (displayedY - offsetY) / scale,
    };
  }

  function clampSourceCrop(crop, vw, vh, targetAspect) {
    var sw = clampNumber(crop.width, 1, vw);
    var sh = clampNumber(crop.height, 1, vh);

    if (targetAspect) {
      var currentAspect = sw / sh;
      if (currentAspect > targetAspect) {
        sw = sh * targetAspect;
      } else {
        sh = sw / targetAspect;
      }
    }

    sw = Math.min(sw, vw);
    sh = Math.min(sh, vh);

    var cx = crop.x + (crop.width / 2);
    var cy = crop.y + (crop.height / 2);

    var sx = clampNumber(cx - (sw / 2), 0, vw - sw);
    var sy = clampNumber(cy - (sh / 2), 0, vh - sh);

    return {
      x: Math.round(sx),
      y: Math.round(sy),
      width: Math.round(sw),
      height: Math.round(sh),
    };
  }

  function buildLargeCaptureFaceCrop(video, stepKey, targetAspect) {
    /*
     * V1.2A.5.1.8:
     * En iPad/tablet/laptop capturamos un recorte inteligente alrededor del
     * rostro. Visualmente se puede usar 4:3 para comodidad, pero al backend
     * le mandamos una imagen vertical con rostro más protagonista y más detalle.
     */
    if (!isLargeCaptureViewport() || !STATE.faceMetrics || !DOM.cameraWrap) {
      return null;
    }

    var metrics = STATE.faceMetrics;
    var wrapRect = DOM.cameraWrap.getBoundingClientRect();
    var cw = wrapRect.width;
    var ch = wrapRect.height;

    if (!cw || !ch || !metrics.width || !metrics.height) return null;

    var desiredFill = stepKey === 'frontal' ? 0.74 : 0.70;
    var cropDisplayHeight = clampNumber(metrics.height / desiredFill, 0.58, 0.94);
    var cropDisplayWidth = targetAspect * cropDisplayHeight * (ch / cw);

    /*
     * Evitamos cortar orejas/mejillas en 3/4. Si el ancho calculado queda muy
     * estrecho, lo abrimos y ajustamos alto para respetar el aspecto final.
     */
    var minWidthFromFace = metrics.width * (stepKey === 'frontal' ? 1.42 : 1.62);
    cropDisplayWidth = Math.max(cropDisplayWidth, minWidthFromFace);
    cropDisplayWidth = clampNumber(cropDisplayWidth, 0.42, 0.98);
    cropDisplayHeight = clampNumber((cropDisplayWidth * (cw / ch)) / targetAspect, cropDisplayHeight, 0.98);

    var centerX = clampNumber(metrics.centerX, 0.18, 0.82);
    var centerY = clampNumber(metrics.centerY + (metrics.height * 0.04), 0.20, 0.82);

    var x1 = centerX - (cropDisplayWidth / 2);
    var y1 = centerY - (cropDisplayHeight / 2);
    var x2 = centerX + (cropDisplayWidth / 2);
    var y2 = centerY + (cropDisplayHeight / 2);

    if (x1 < 0) { x2 -= x1; x1 = 0; }
    if (x2 > 1) { x1 -= (x2 - 1); x2 = 1; }
    if (y1 < 0) { y2 -= y1; y1 = 0; }
    if (y2 > 1) { y1 -= (y2 - 1); y2 = 1; }

    x1 = clampNumber(x1, 0, 1);
    x2 = clampNumber(x2, 0, 1);
    y1 = clampNumber(y1, 0, 1);
    y2 = clampNumber(y2, 0, 1);

    var p1 = mapDisplayedPointToSource(video, x1, y1);
    var p2 = mapDisplayedPointToSource(video, x2, y2);

    if (!p1 || !p2) return null;

    var sx1 = clampNumber(Math.min(p1.x, p2.x), 0, video.videoWidth);
    var sx2 = clampNumber(Math.max(p1.x, p2.x), 0, video.videoWidth);
    var sy1 = clampNumber(Math.min(p1.y, p2.y), 0, video.videoHeight);
    var sy2 = clampNumber(Math.max(p1.y, p2.y), 0, video.videoHeight);

    var crop = clampSourceCrop(
      {
        x: sx1,
        y: sy1,
        width: sx2 - sx1,
        height: sy2 - sy1,
      },
      video.videoWidth,
      video.videoHeight,
      targetAspect
    );

    /*
     * Si Safari entrega baja resolución, ampliamos el área fuente de forma
     * controlada para no mandar recortes demasiado pequeños al backend.
     */
    var minSourceWidth = Math.min(video.videoWidth, 720);
    if (crop.width < minSourceWidth) {
      var expandedHeight = minSourceWidth / targetAspect;
      crop = clampSourceCrop(
        {
          x: crop.x + crop.width / 2 - minSourceWidth / 2,
          y: crop.y + crop.height / 2 - expandedHeight / 2,
          width: minSourceWidth,
          height: expandedHeight,
        },
        video.videoWidth,
        video.videoHeight,
        targetAspect
      );
    }

    crop.mode = 'smart-face-crop';
    crop.display = {
      x1: Number(x1.toFixed(4)),
      y1: Number(y1.toFixed(4)),
      x2: Number(x2.toFixed(4)),
      y2: Number(y2.toFixed(4)),
      faceWidth: Number(metrics.width.toFixed(4)),
      faceHeight: Number(metrics.height.toFixed(4)),
    };

    return crop;
  }


  function estimateBase64Bytes(base64) {
    if (!base64) return 0;
    return Math.round((String(base64).length * 3) / 4);
  }

  function getDebugViewportInfo() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || 0,
      height: window.innerHeight || document.documentElement.clientHeight || 0,
      devicePixelRatio: window.devicePixelRatio || 1,
      userAgent: navigator.userAgent || '',
      largeCapture: isLargeCaptureViewport(),
      landscape: isLandscapeViewport(),
      cameraWrap: DOM.cameraWrap
        ? {
          width: DOM.cameraWrap.clientWidth,
          height: DOM.cameraWrap.clientHeight,
        }
        : null,
    };
  }

  function getCaptureDebugReport() {
    return {
      version: CONFIG.trackingVersion,
      time: new Date().toISOString(),
      viewport: getDebugViewportInfo(),
      faceGuidance: {
        status: STATE.faceGuideStatus,
        allowed: STATE.faceAllowed,
        fallback: STATE.faceFallback,
        fallbackReason: STATE.faceFallbackReason,
        message: STATE.faceMessage,
        metrics: STATE.faceMetrics,
        moduleSource: STATE.faceModuleSource,
        wasmSource: STATE.faceWasmSource,
        modelSource: STATE.faceModelSource,
        preloadError: STATE.facePreloadError,
      },
      lighting: {
        status: STATE.lightingStatus,
        allowed: STATE.lightingAllowed,
        lastSamples: STATE.lightingSamples.slice(-6),
      },
      captures: STATE.captureDebugFrames,
      capturesFallback: STATE.captureDebugFramesFallback,
      api: {
        status: STATE.lastResponseStatus,
        attemptMode: STATE.lastAttemptMode,
        qualityRetryUsed: STATE.qualityRetryUsed,
        errorMessage: STATE.lastApiErrorMessage,
        body: STATE.lastApiError,
      },
    };
  }

  function getCompactDebugCode() {
    var report = getCaptureDebugReport();
    var caps = report.captures || {};
    var keys = ['frontal', 'perfil_izq', 'perfil_der'];

    var parts = [
      'VER=' + report.version,
      'VP=' + report.viewport.width + 'x' + report.viewport.height,
      'LC=' + (report.viewport.largeCapture ? '1' : '0'),
      'LAND=' + (report.viewport.landscape ? '1' : '0'),
      'API=' + (report.api.status || 'NA'),
      'ATT=' + (report.api.attemptMode || 'NA'),
      'RETRY=' + (report.api.qualityRetryUsed ? '1' : '0'),
      'ERR=' + ((report.api.body && report.api.body.error) || report.api.errorMessage || 'NA'),
      'VLM=' + String(report.api.body && report.api.body.vlm_activo),
    ];

    keys.forEach(function (key) {
      var cap = caps[key];
      var fallback = report.capturesFallback && report.capturesFallback[key];
      if (!cap) return;
      parts.push(
        key + '=' +
        (cap.video ? cap.video.width + 'x' + cap.video.height : 'NA') +
        '/crop:' +
        (cap.crop ? cap.crop.width + 'x' + cap.crop.height : 'NA') +
        '/out:' +
        (cap.output ? cap.output.width + 'x' + cap.output.height : 'NA') +
        '/kb:' +
        (cap.output ? Math.round((cap.output.estimatedBytes || 0) / 1024) : 'NA') +
        '/mode:' +
        (cap.cropMode || 'NA') +
        (
          fallback
            ? '/fb:' +
              (fallback.output ? fallback.output.width + 'x' + fallback.output.height : 'NA') +
              '/' +
              (fallback.output ? Math.round((fallback.output.estimatedBytes || 0) / 1024) + 'kb' : 'NA')
            : ''
        )
      );
    });

    return parts.join(' | ');
  }


  function renderCaptureDebugPanel() {
    if (!CONFIG.captureDebug || !DOM.globalErrorMsg) return;

    var card = DOM.globalErrorMsg.closest('.rogma-card') || DOM.globalErrorMsg.parentNode;
    if (!card) return;

    var existing = document.getElementById('rogma-debug-panel');
    if (existing) existing.remove();

    var details = document.createElement('details');
    details.id = 'rogma-debug-panel';
    details.className = 'rogma-debug-panel';
    details.open = true;

    var summary = document.createElement('summary');
    summary.textContent = 'Diagnóstico técnico del escaneo';
    details.appendChild(summary);

    var help = document.createElement('p');
    help.className = 'rogma-debug-panel__help';
    help.textContent = 'Toma captura de este código corto o copia el diagnóstico completo para revisar tamaño, recorte, resolución y respuesta del backend.';
    details.appendChild(help);

    var compact = document.createElement('div');
    compact.className = 'rogma-debug-panel__compact';
    compact.textContent = getCompactDebugCode();
    details.appendChild(compact);

    var textarea = document.createElement('textarea');
    textarea.className = 'rogma-debug-panel__textarea';
    textarea.readOnly = true;
    textarea.value = JSON.stringify(getCaptureDebugReport(), null, 2);
    details.appendChild(textarea);

    card.appendChild(details);
  }

  function waitCaptureFrame(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms || 0);
    });
  }

  function measureCanvasCaptureQuality(canvas) {
    var fallback = {
      score: 0,
      sharpness: 0,
      contrast: 0,
      luma: 0,
      samples: 0,
    };

    if (!canvas || !canvas.width || !canvas.height) return fallback;

    try {
      var sampleSize = 72;
      var sample = document.createElement('canvas');
      sample.width = sampleSize;
      sample.height = sampleSize;
      var sctx = sample.getContext('2d', { willReadFrequently: true });
      if (!sctx) return fallback;

      sctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, sampleSize, sampleSize);

      var image = sctx.getImageData(0, 0, sampleSize, sampleSize);
      var data = image.data;
      var lum = new Array(sampleSize * sampleSize);
      var sum = 0;
      var sumSq = 0;

      for (var i = 0, p = 0; i < data.length; i += 4, p += 1) {
        var y = (data[i] * 0.299) + (data[i + 1] * 0.587) + (data[i + 2] * 0.114);
        lum[p] = y;
        sum += y;
        sumSq += y * y;
      }

      var count = lum.length || 1;
      var mean = sum / count;
      var variance = Math.max(0, (sumSq / count) - (mean * mean));
      var contrast = Math.sqrt(variance);
      var sharpness = 0;
      var edges = 0;

      for (var yIdx = 1; yIdx < sampleSize - 1; yIdx += 1) {
        for (var xIdx = 1; xIdx < sampleSize - 1; xIdx += 1) {
          var idx = yIdx * sampleSize + xIdx;
          var gx = Math.abs(lum[idx + 1] - lum[idx - 1]);
          var gy = Math.abs(lum[idx + sampleSize] - lum[idx - sampleSize]);
          sharpness += gx + gy;
          edges += 1;
        }
      }

      sharpness = edges ? sharpness / edges : 0;

      return {
        score: Number(((sharpness * 0.72) + (contrast * 0.28)).toFixed(4)),
        sharpness: Number(sharpness.toFixed(4)),
        contrast: Number(contrast.toFixed(4)),
        luma: Number(mean.toFixed(4)),
        samples: count,
      };
    } catch (error) {
      return fallback;
    }
  }

  async function captureBestVideoFrame(video, stepKey) {
    var frames = [];
    var totalFrames = 3;
    var gapMs = 90;

    for (var i = 0; i < totalFrames; i += 1) {
      if (i > 0) await waitCaptureFrame(gapMs);
      frames.push(compressVideoFrame(video, stepKey));
    }

    frames.sort(function (a, b) {
      var qa = a && a.debug && a.debug.frameQuality ? a.debug.frameQuality.score : 0;
      var qb = b && b.debug && b.debug.frameQuality ? b.debug.frameQuality.score : 0;
      return qb - qa;
    });

    var best = frames[0];
    if (best && best.debug) {
      best.debug.burstCapture = {
        enabled: true,
        frames: frames.length,
        gapMs: gapMs,
        selectedScore: best.debug.frameQuality ? best.debug.frameQuality.score : null,
        scores: frames.map(function (frame) {
          return frame && frame.debug && frame.debug.frameQuality
            ? frame.debug.frameQuality.score
            : null;
        }),
      };
    }

    return best;
  }

  async function captureBestFullDetailVideoFrame(video, stepKey) {
    var frames = [];
    var totalFrames = 2;
    var gapMs = 80;

    for (var i = 0; i < totalFrames; i += 1) {
      if (i > 0) await waitCaptureFrame(gapMs);
      frames.push(compressFullDetailVideoFrame(video, stepKey));
    }

    frames.sort(function (a, b) {
      var qa = a && a.debug && a.debug.frameQuality ? a.debug.frameQuality.score : 0;
      var qb = b && b.debug && b.debug.frameQuality ? b.debug.frameQuality.score : 0;
      return qb - qa;
    });

    var best = frames[0];
    if (best && best.debug) {
      best.debug.burstCapture = {
        enabled: true,
        frames: frames.length,
        gapMs: gapMs,
        selectedScore: best.debug.frameQuality ? best.debug.frameQuality.score : null,
        scores: frames.map(function (frame) {
          return frame && frame.debug && frame.debug.frameQuality
            ? frame.debug.frameQuality.score
            : null;
        }),
      };
    }

    return best;
  }

  function compressVideoFrame(video, stepKey) {
    var largeCapture = isLargeCaptureViewport();

    var maxW = largeCapture
      ? Math.max(CONFIG.maxWidthDesktop, 1920)
      : (
        window.innerWidth < 768
          ? Math.max(CONFIG.maxWidthMobile, 1600)
          : Math.max(CONFIG.maxWidthDesktop, 1920)
      );

    var vw = video.videoWidth;
    var vh = video.videoHeight;

    if (!vw || !vh) {
      throw new Error('video not ready');
    }

    /*
     * Móvil: mantenemos recorte según el marco visual.
     * iPad/tablet/laptop: mandamos al backend un recorte vertical inteligente
     * alrededor del rostro para evitar “poco detalle”.
     */
    var targetAspect = largeCapture ? 0.78 : getCaptureFrameAspectRatio(video);
    var sourceAspect = vw / vh;

    var smartCrop = buildLargeCaptureFaceCrop(video, stepKey, targetAspect);

    var sx = 0;
    var sy = 0;
    var sw = vw;
    var sh = vh;
    var cropMode = 'frame-crop';

    if (smartCrop) {
      sx = smartCrop.x;
      sy = smartCrop.y;
      sw = smartCrop.width;
      sh = smartCrop.height;
      cropMode = smartCrop.mode || 'smart-face-crop';
    } else if (sourceAspect > targetAspect) {
      sw = Math.round(vh * targetAspect);
      sx = Math.round((vw - sw) / 2);
    } else if (sourceAspect < targetAspect) {
      sh = Math.round(vw / targetAspect);
      sy = Math.round((vh - sh) / 2);
    }

    var scale = Math.min(1, Math.SQRT1_2);

    /*
     * Modo 3: 50% lossless. Conserva PNG sin perdida, pero reduce
     * aproximadamente a la mitad el presupuesto de pixeles para comparar
     * calidad real vs peso del payload.
     *
     * V1.2A.5.1.9:
     * No hacemos upscaling artificial. Si el recorte fuente es pequeño,
     * agrandar el canvas produce dimensiones bonitas pero no agrega detalle
     * real; eso puede mantener el rechazo de calidad. Preferimos enviar
     * píxeles reales y exigir un rostro ligeramente más grande antes de capturar.
     */
    if (largeCapture && smartCrop) {
      scale = Math.min(1, Math.SQRT1_2);
    }

    var cw = Math.max(1, Math.round(sw * scale));
    var ch = Math.max(1, Math.round(sh * scale));

    var canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(
      video,
      sx,
      sy,
      sw,
      sh,
      0,
      0,
      cw,
      ch
    );

    var frameQuality = measureCanvasCaptureQuality(canvas);

    var dataUrl = canvas.toDataURL('image/png');
    var base64 = dataUrl.replace(
      /^data:image\/png;base64,/,
      ''
    );

    var debug = {
      stepKey: stepKey || '',
      largeCapture: largeCapture,
      viewport: getDebugViewportInfo(),
      video: {
        width: vw,
        height: vh,
        aspect: Number((vw / vh).toFixed(4)),
      },
      targetAspect: Number(targetAspect.toFixed(4)),
      sourceAspect: Number(sourceAspect.toFixed(4)),
      cropMode: cropMode,
      smartCropDisplay: smartCrop && smartCrop.display ? smartCrop.display : null,
      frameQuality: frameQuality,
      crop: {
        x: sx,
        y: sy,
        width: sw,
        height: sh,
      },
      output: {
        width: cw,
        height: ch,
        mimeType: 'image/png',
        lossless: true,
        losslessScale: 0.5,
        jpegQuality: null,
        estimatedBytes: estimateBase64Bytes(base64),
      },
    };

    return {
      base64: base64,
      dataUrl: dataUrl,
      width: cw,
      height: ch,
      crop: {
        x: sx,
        y: sy,
        width: sw,
        height: sh,
      },
      debug: debug,
    };
  }

  function compressFullDetailVideoFrame(video, stepKey) {
    /*
     * V1.2A.5.1.10:
     * Fallback automático para iPad/tablet/laptop cuando el backend rechaza
     * el smart crop por CALIDAD_IMAGEN_INSUFICIENTE.
     *
     * En lugar de enviar un recorte del rostro, guardamos también una versión
     * del frame completo del sensor con máxima calidad. Esto conserva pelo,
     * contorno, orejas, cuello y textura contextual que algunos filtros de
     * calidad usan para decidir nitidez/detalle.
     */
    var vw = video.videoWidth;
    var vh = video.videoHeight;

    if (!vw || !vh) {
      throw new Error('video not ready');
    }

    var scale = Math.min(1, Math.SQRT1_2);
    var cw = Math.max(1, Math.round(vw * scale));
    var ch = Math.max(1, Math.round(vh * scale));

    var canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(
      video,
      0,
      0,
      vw,
      vh,
      0,
      0,
      cw,
      ch
    );

    var frameQuality = measureCanvasCaptureQuality(canvas);

    var dataUrl = canvas.toDataURL('image/png');
    var base64 = dataUrl.replace(/^data:image\/png;base64,/, '');

    return {
      base64: base64,
      dataUrl: dataUrl,
      width: cw,
      height: ch,
      crop: {
        x: 0,
        y: 0,
        width: vw,
        height: vh,
      },
      debug: {
        stepKey: stepKey || '',
        largeCapture: isLargeCaptureViewport(),
        viewport: getDebugViewportInfo(),
        video: {
          width: vw,
          height: vh,
          aspect: Number((vw / vh).toFixed(4)),
        },
        targetAspect: Number((vw / vh).toFixed(4)),
        sourceAspect: Number((vw / vh).toFixed(4)),
        cropMode: 'full-frame-quality-fallback',
        smartCropDisplay: null,
        frameQuality: frameQuality,
        crop: {
          x: 0,
          y: 0,
          width: vw,
          height: vh,
        },
        output: {
          width: cw,
          height: ch,
          mimeType: 'image/png',
          lossless: true,
          losslessScale: 0.5,
          jpegQuality: null,
          estimatedBytes: estimateBase64Bytes(base64),
        },
      },
    };
  }

  function hasQualityFallbackCaptures() {
    return !!(
      STATE.capturesQualityFallback.frontal &&
      STATE.capturesQualityFallback.perfil_izq &&
      STATE.capturesQualityFallback.perfil_der
    );
  }

  function getCapturesForPayload(useQualityFallback) {
    if (useQualityFallback && hasQualityFallbackCaptures()) {
      return STATE.capturesQualityFallback;
    }

    return STATE.captures;
  }

  function buildApiPayload(useQualityFallback) {
    var captures = getCapturesForPayload(useQualityFallback);

    var payload = {
      edad: STATE.edad,
      rostro: captures.frontal,
      imagenes_multivista: {
        frontal: captures.frontal,
        perfil_izq: captures.perfil_izq,
        perfil_der: captures.perfil_der,
      },
    };

    if (CONFIG.controlSubjectMode) {
      payload.es_sujeto_control = true;
    }

    return payload;
  }

  function startLoaderAnimation(onComplete) {
    var stepIndex = 0;
    var startTime = Date.now();
    STATE.loaderFinished = false;
    paintLoader(0);

    if (STATE.loaderTimer) clearInterval(STATE.loaderTimer);

    STATE.loaderTimer = setInterval(function () {
      if (stepIndex < LOADER_STEPS.length - 1) {
        stepIndex += 1;
        paintLoader(stepIndex);
      } else {
        clearInterval(STATE.loaderTimer);
        STATE.loaderTimer = null;
        var wait = Math.max(0, CONFIG.loaderMinTotalMs - (Date.now() - startTime));
        setTimeout(function () {
          STATE.loaderFinished = true;
          onComplete();
        }, wait + 350);
      }
    }, CONFIG.loaderStepMs);
  }

  function tryFinishLoading() {
    if (!STATE.loaderFinished || !STATE.apiDone || !STATE.normalized) return;
    renderResult(STATE.normalized);
    showPhase('result');
  }

  function requestAnalysis(useQualityFallback) {
    STATE.lastAttemptMode = useQualityFallback
      ? 'full-frame-quality-fallback'
      : 'smart-face-crop';

    var controller = new AbortController();
    var timeoutId = setTimeout(function () {
      controller.abort();
    }, CONFIG.apiTimeoutMs);

    return fetch(CONFIG.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache',
      },
      body: JSON.stringify(buildApiPayload(useQualityFallback)),
      signal: controller.signal,
    }).then(function (res) {
      clearTimeout(timeoutId);
      STATE.lastResponseStatus = res.status;

      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          STATE.lastApiError = body;
          STATE.lastApiErrorMessage = body.detail || body.mensaje || mapHttpError(res.status);
          var detail = body.detail || body.mensaje || mapHttpError(res.status);
          throw new Error(typeof detail === 'string' ? detail : mapHttpError(res.status));
        });
      }

      return res.json();
    }).catch(function (error) {
      clearTimeout(timeoutId);
      throw error;
    });
  }

  function isQualityInsufficientResponse(data) {
    return !!(data && data.error === 'CALIDAD_IMAGEN_INSUFICIENTE');
  }

  function getBackendRegionalSummary(data) {
    if (!data) return null;

    return (
      data.regional_summary ||
      (
        data.vlm_resultado_raw &&
        data.vlm_resultado_raw.gemini_2_5 &&
        data.vlm_resultado_raw.gemini_2_5.resultado &&
        data.vlm_resultado_raw.gemini_2_5.resultado.regional_summary
      ) ||
      null
    );
  }

  function isBackendReescanRequiredResponse(data) {
    if (!data) return false;

    var regionalSummary = getBackendRegionalSummary(data);

    return Boolean(
      data.requiere_reescaneo ||
      data.resultado_limitado_por_calidad ||
      (regionalSummary && regionalSummary.requiere_reescaneo)
    );
  }

  function getBackendReescanMessage(data) {
    var regionalSummary = getBackendRegionalSummary(data);

    return (
      (data && data.motivo_reescaneo) ||
      (regionalSummary && regionalSummary.motivo_reescaneo) ||
      'Necesitamos repetir el escaneo con luz frontal uniforme para darte una evaluación más confiable.'
    );
  }
  function handleAnalysisResponse(data, usedQualityFallback) {
    window.rogmaLastResult = data;

    if (isQualityInsufficientResponse(data)) {
      STATE.lastApiError = data;
      STATE.lastApiErrorMessage = mapRechazoToUserMessage(data.mensaje, data.quality_report);

      /*
       * V1.2A.5.1.10:
       * Si el smart crop falla en iPad/tablet/laptop, reintentamos una sola vez
       * con frame completo del sensor. Esto no cambia la experiencia visible,
       * pero le da al backend una imagen con más contexto y textura real.
       */
      if (
        !usedQualityFallback &&
        !STATE.qualityRetryUsed &&
        hasQualityFallbackCaptures()
      ) {
        STATE.qualityRetryUsed = true;
        return requestAnalysis(true).then(function (fallbackData) {
          return handleAnalysisResponse(fallbackData, true);
        });
      }

      throw new Error(STATE.lastApiErrorMessage);
    }

    if (isBackendReescanRequiredResponse(data)) {
      STATE.rawResult = data;
      STATE.normalized = {
        raw: data,
        scanId: data.scan_id || null,
        requiereReescaneo: true,
        resultadoLimitadoPorCalidad: data.resultado_limitado_por_calidad === true,
        motivoReescaneo: getBackendReescanMessage(data),
      };
      STATE.apiDone = true;
      tryFinishLoading();
      return data;
    }

    if (data.error) {
      STATE.lastApiError = data;
      STATE.lastApiErrorMessage = 'No pudimos completar tu evaluación. Intenta de nuevo con buena luz y rostro centrado.';
      throw new Error(STATE.lastApiErrorMessage);
    }

    STATE.rawResult = data;
    STATE.normalized = normalizeResult(data);
    if (STATE.normalized && STATE.normalized.scanId) {
      STATE.lastScanId = String(STATE.normalized.scanId);
    }
    trackRogmaEvent('analysis_success', {
      backend_scan_id: STATE.lastScanId || '',
      tipo_piel: STATE.normalized && STATE.normalized.tipoPiel ? STATE.normalized.tipoPiel : '',
      aspecto_principal: STATE.normalized && STATE.normalized.prioridadTratamiento ? STATE.normalized.prioridadTratamiento.sintoma || '' : '',
      prioridad_rutina: STATE.normalized && STATE.normalized.prioridad ? STATE.normalized.prioridad : '',
      rutina_am_count: STATE.normalized && STATE.normalized.rutinaAm ? STATE.normalized.rutinaAm.length : 0,
      rutina_pm_count: STATE.normalized && STATE.normalized.rutinaPm ? STATE.normalized.rutinaPm.length : 0,
      focal_count: STATE.normalized && STATE.normalized.cuidadoFocalizado ? STATE.normalized.cuidadoFocalizado.length : 0,
      evaluacion_limitada: STATE.normalized && STATE.normalized.evaluacionLimitada ? 'true' : 'false',
    });
    STATE.apiDone = true;
    tryFinishLoading();
    return data;
  }

  function sendAnalysis() {
    if (!STATE.captures.frontal || !STATE.captures.perfil_izq || !STATE.captures.perfil_der) {
      if (DOM.reviewError) {
        DOM.reviewError.textContent = COPY.multivistaIncompleta;
        DOM.reviewError.hidden = false;
      }
      DOM.globalErrorMsg.textContent = COPY.multivistaIncompleta;
      showPhase('error');
      return;
    }

    STATE.apiDone = false;
    STATE.normalized = null;
    STATE.lastApiError = null;
    STATE.lastApiErrorMessage = '';
    STATE.lastResponseStatus = null;
    STATE.qualityRetryUsed = false;
    STATE.lastAttemptMode = 'smart-face-crop';
    showPhase('loading');
    trackRogmaEvent('analysis_started', {
      attempt_mode: STATE.lastAttemptMode || 'smart-face-crop',
      edad: STATE.edad,
      quality_retry_used: STATE.qualityRetryUsed ? 'true' : 'false',
    });

    startLoaderAnimation(function () {
      tryFinishLoading();
    });

    requestAnalysis(false)
      .then(function (data) {
        return handleAnalysisResponse(data, false);
      })
      .catch(function (err) {
        if (STATE.loaderTimer) {
          clearInterval(STATE.loaderTimer);
          STATE.loaderTimer = null;
        }
        STATE.apiDone = true;
        var msg = err && err.name === 'AbortError'
          ? COPY.timeout
          : (err.message || 'No se pudo conectar con el servidor.');
        DOM.globalErrorMsg.textContent = msg;
        trackRogmaEvent('analysis_error', {
          message: msg,
          error_name: err && err.name ? err.name : '',
          response_status: STATE.lastResponseStatus || '',
          attempt_mode: STATE.lastAttemptMode || '',
          quality_retry_used: STATE.qualityRetryUsed ? 'true' : 'false',
        });
        showPhase('error');
        renderCaptureDebugPanel();
      });
  }

  function mapHttpError(status) {
    if (status === 400 || status === 422) {
      return 'La captura no pudo procesarse. Repite con mejor luz y rostro centrado.';
    }
    if (status >= 500) {
      return 'El servicio no está disponible en este momento. Inténtalo más tarde.';
    }
    return 'No pudimos completar tu evaluación.';
  }

  function mapRechazoToUserMessage(mensaje, qualityReport) {
    var texto = [mensaje]
      .concat((qualityReport && qualityReport.warnings) || [])
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    if (/borros|blur|nitidez|desenfoq/.test(texto)) {
      return 'La imagen llegó con poco detalle. Mantén el teléfono estable e inténtalo nuevamente.';
    }
    if (/tres vistas|vistas faciales|multivista|perfil_izq|perfil_der/.test(texto)) {
      return COPY.multivistaIncompleta;
    }
    if (/oscura|oscuro|brillo|ilumin|luz|sobreexpuesta/.test(texto)) {
      return 'Necesitamos un poco más de luz uniforme sobre tu rostro.';
    }
    if (/filtro de belleza|beauty|filtro/.test(texto)) {
      return 'Desactiva filtros de cámara para obtener una evaluación más precisa.';
    }
    return 'La captura presenta desenfoque o iluminación irregular. Toma una nueva fotografía con luz natural uniforme y tu rostro centrado.';
  }

  function normalizeLecturaCliente(raw) {
    if (!raw || typeof raw !== 'object') return null;

    function cleanText(value) {
      return sanitizeCopy(String(value || '').replace(/\s+/g, ' ').trim());
    }

    function cleanFinding(item) {
      if (!item || typeof item !== 'object') return null;
      var label = cleanText(item.label || item.hallazgo || item.nombre || (item.sintoma ? labelSintoma(item.sintoma) : ''));
      if (!label) return null;
      return {
        clave: cleanText(item.clave || item.key || item.categoria || label).toLowerCase(),
        label: label,
        nivel: cleanText(item.nivel || item.nivel_visible || item.confianza_visible || ''),
        score: Number(item.score || item.confianza || 0) || 0,
        categoria: cleanText(item.categoria || ''),
        prioridad: Number(item.prioridad || 99) || 99,
      };
    }

    var visibles = Array.isArray(raw.hallazgos_visibles)
      ? raw.hallazgos_visibles.map(cleanFinding).filter(Boolean)
      : [];
    var secundarios = Array.isArray(raw.hallazgos_secundarios)
      ? raw.hallazgos_secundarios.map(cleanFinding).filter(Boolean)
      : [];

    return {
      hallazgoPrincipal: cleanText(raw.hallazgo_principal || raw.principal || ''),
      nivelPrincipal: cleanText(raw.nivel_principal || ''),
      enfoqueRutina: cleanText(raw.enfoque_rutina || ''),
      resumen: cleanText(raw.resumen || ''),
      hallazgosVisibles: visibles,
      hallazgosSecundarios: secundarios,
      lenguaje: cleanText(raw.lenguaje || ''),
    };
  }

  function normalizeTipoPielEstimado(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var valor = String(raw.valor || '').trim().toLowerCase();
    var label = sanitizeCopy(String(raw.label || labelTipoPiel(valor) || '').replace(/\s+/g, ' ').trim());
    var confianza = sanitizeCopy(String(raw.confianza || '').replace(/\s+/g, ' ').trim());
    var advertencia = sanitizeCopy(String(raw.advertencia || '').replace(/\s+/g, ' ').trim());

    if (!valor && !label) return null;
    return {
      valor: valor || null,
      label: label || labelTipoPiel(valor),
      confianza: confianza,
      advertencia: advertencia,
    };
  }

  function severityFromLecturaNivel(nivel, score) {
    var txt = String(nivel || '').toLowerCase();
    var num = Number(score || 0) || 0;

    if (/notable|alto|marcado/.test(txt) || num >= 0.55) return 'moderado_severo';
    if (/medio/.test(txt) || num >= 0.32) return 'moderado';
    if (/bajo\s*a\s*medio|leve\s*a\s*medio/.test(txt) || num >= 0.16) return 'leve_moderado';
    if (/bajo|leve/.test(txt) || num > 0) return 'leve';
    return 'ninguno';
  }

  function canonicalAspectKey(item) {
    var rawKey = String((item && item.key) || (item && item.clave) || '').toLowerCase();
    var rawLabel = String((item && item.label) || labelSintoma(rawKey) || '').toLowerCase();
    var text = (rawKey + ' ' + rawLabel)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    if (/granito|brote|acne|imperfeccion activa|imperfecciones activas/.test(text)) return 'granitos';
    if (/post.?imperfeccion|post.?acne|cicatriz|cicatrices|marca/.test(text)) return 'marcas_post_imperfeccion';
    if (/textura|relieve|poro dilatado|poros dilatados/.test(text)) return 'textura_irregular';
    if (/poro/.test(text)) return 'poros_visibles';
    if (/ojo|ojera|contorno/.test(text)) return 'zona_ojos';
    if (/mancha|tono|pigment/.test(text)) return 'manchas_visibles';
    if (/arruga|linea|edad|pata/.test(text)) return 'lineas_expresion';
    if (/rojez|rojec|sensib/.test(text)) return 'sensibilidad_visible';
    if (/opacidad|luminos/.test(text)) return 'luminosidad';
    if (/equilibr/.test(text)) return 'piel_equilibrada';
    return text;
  }

  function iconKeyFromLecturaFinding(item) {
    var clave = String((item && item.clave) || '').toLowerCase();
    var label = String((item && item.label) || '').toLowerCase();
    var text = clave + ' ' + label;

    if (/post.?imperfeccion|post.?imperfección|cicatriz|cicatrices|textura|marca/.test(text)) return 'textura';
    if (/granito|brote|acne|acné|imperfeccion activa|imperfección activa/.test(text)) return 'granito';
    if (/mancha|tono|pigment/.test(text)) return 'mancha';
    if (/ojo|ojera|contorno/.test(text)) return 'ojos';
    if (/arruga|linea|línea|edad|pata/.test(text)) return 'lineas';
    if (/poro/.test(text)) return 'poros';
    if (/rojez|rojec|sensib/.test(text)) return 'rojez';
    if (/opacidad|luminos/.test(text)) return 'luminosidad';
    return 'equilibrio';
  }

  function lecturaClienteAspectItems(norm, limit) {
    var lectura = norm && norm.lecturaCliente ? norm.lecturaCliente : null;
    var source = lectura && Array.isArray(lectura.hallazgosVisibles) ? lectura.hallazgosVisibles : [];
    var seen = {};
    var items = [];

    source.forEach(function (item, index) {
      var label = item && item.label ? item.label : '';
      var key = (item && item.clave) || label || ('lectura_' + index);
      var unique = String(label || key).toLowerCase();
      if (!label || seen[unique]) return;
      seen[unique] = true;
      items.push({
        key: key,
        label: label,
        nivelLabel: item.nivel || '',
        score: Number(item.score || 0) || 0,
        sev: severityFromLecturaNivel(item.nivel, item.score),
        iconKey: iconKeyFromLecturaFinding(item),
        isPrincipal: lectura.hallazgoPrincipal && label.toLowerCase() === lectura.hallazgoPrincipal.toLowerCase(),
      });
    });

    if (!items.length) return [];
    return items.slice(0, limit || 4);
  }

  function lecturaClienteListLabels(items, limit) {
    var seen = {};
    return (items || [])
      .map(function (item) { return sanitizeCopy(item && item.label ? item.label : ''); })
      .filter(function (label) {
        var key = String(label || '').toLowerCase();
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      })
      .slice(0, limit || 3);
  }
  /* ═══════════════════════════════════════════════════════════
     NORMALIZE_RESULT
     ═══════════════════════════════════════════════════════════ */

  function normalizeResult(raw) {
    var sintomas = getSintomas(raw);
    var rec = getRecomendaciones(raw);
    var prioridad = raw.prioridad_rutina || 'ninguno';
    var tipoPielEstimado = normalizeTipoPielEstimado(raw.tipo_piel_estimado || rec.tipo_piel_estimado || null);
    var tipoPielVisual = tipoPielEstimado && tipoPielEstimado.valor && tipoPielEstimado.valor !== 'no_concluyente'
      ? tipoPielEstimado.valor
      : (raw.tipo_piel && raw.tipo_piel.valor ? raw.tipo_piel.valor : null);
    var tipoPiel = tipoPielVisual;
    var lecturaCliente = normalizeLecturaCliente(rec.lectura_cliente || raw.lectura_cliente || null);
    var visiblesRaw = Array.isArray(raw.hallazgos_visibles)
      ? raw.hallazgos_visibles
      : (lecturaCliente && lecturaCliente.hallazgosVisibles ? lecturaCliente.hallazgosVisibles : []);
    var hallazgosVisibles = normalizeVisibleFindings(visiblesRaw, sintomas);
    var reglasRutina = rec.reglas_rutina || raw.reglas_rutina || {};
    var prioridadTratamiento = raw.prioridad_tratamiento_detalle || rec.prioridad_tratamiento_detalle || reglasRutina.prioridad_tratamiento_detalle || null;
    var observadoNoTratado = raw.observado_no_tratado_esta_semana || reglasRutina.observado_no_tratado_esta_semana || [];
    var cuidadoFocal = raw.cuidado_focal || reglasRutina.cuidado_focal || (prioridadTratamiento && prioridadTratamiento.cuidado_focal) || [];

    return {
      raw: raw,
      scanId: raw.scan_id || null,
      sintomas: sintomas,
      recomendaciones: rec,
      prioridad: prioridad,
      tipoPiel: tipoPiel,
      tipoPielFuente: 'visual',
      tipoPielEstimado: tipoPielEstimado,
      evaluacionLimitada: raw.evaluacion_limitada === true || raw.vlm_activo === false,
      heroTitulo: buildHeroTitulo(STATE.displayName),
      focusLine: buildRutinaFocusLine(raw),
      rutinaAm: rec.rutina_am || [],
      rutinaPm: rec.rutina_pm || [],
      cuidadoFocalizado: rec.cuidado_focalizado || rec.aplicacion_localizada || [],
      perfilRutina: rec.perfil_rutina || null,
      explicacionCosmetica: sanitizeCopy(
        rec.explicacion_cosmetica_personalizada ||
        rec.explicacion_comercial ||
        raw.explicacion_comercial ||
        ''
      ),
      confianzaPorHallazgo: Array.isArray(rec.confianza_por_hallazgo)
        ? rec.confianza_por_hallazgo
        : [],
      modoTolerancia: rec.modo_tolerancia || null,
      lecturaCliente: lecturaCliente,
      hallazgosVisibles: hallazgosVisibles,
      prioridadTratamiento: prioridadTratamiento && typeof prioridadTratamiento === 'object' ? prioridadTratamiento : null,
      cuidadoFocal: Array.isArray(cuidadoFocal) ? cuidadoFocal : (cuidadoFocal && typeof cuidadoFocal === 'object' ? [cuidadoFocal] : []),
      observadoNoTratado: Array.isArray(observadoNoTratado) ? observadoNoTratado : [],
      limitacionTopica: raw.limitacion_topica_informada || rec.limitacion_topica_informada || reglasRutina.limitacion_topica_informada || null,
      reglasRutina: reglasRutina,
      requiereReescaneo: raw.requiere_reescaneo === true,
      resultadoLimitadoPorCalidad: raw.resultado_limitado_por_calidad === true,
      motivoReescaneo: raw.motivo_reescaneo || '',
    };
  }


  /* ═══════════════════════════════════════════════════════════
     RENDER_RESULT
     ═══════════════════════════════════════════════════════════ */

  function renderResult(norm) {
    ensureResultsPremiumStyle();
    if (!DOM.resultMount || !norm) return;
    root.setAttribute('data-result-state', norm.requiereReescaneo ? 'rescan' : 'ready');
    if (norm.requiereReescaneo) {
      renderReescanRequired(norm);
      return;
    }

    STATE.lastScanId = norm.scanId ? String(norm.scanId) : '';
    trackRogmaEvent('results_viewed', {
      backend_scan_id: STATE.lastScanId || '',
      tipo_piel: norm.tipoPiel || '',
      aspecto_principal: norm.prioridadTratamiento ? norm.prioridadTratamiento.sintoma || '' : '',
      prioridad_rutina: norm.prioridad || '',
    });
    resetRoutineButtonVisualState();

    var html = '<div class="rogma-result-hero rogma-result-hero--compact">' +
      '<div class="rogma-result-headline-row"><span class="rogma-result-headline-check" aria-hidden="true">' + checkIconSvg() + '</span>' +
      '<h2>' + resultHeroTitleHtml(norm.heroTitulo) + '</h2></div></div>';

    html += '<section class="rogma-result-section rogma-findings" aria-labelledby="rogma-findings-title">' +
      '<h3 class="rogma-section-title" id="rogma-findings-title">Lo que observamos</h3>' +
      renderVisibleFindingsHtml(norm.hallazgosVisibles) + '</section>';
    html += '<section class="rogma-result-section rogma-priority-section" aria-label="Prioridad de cuidado">' +
      renderPriorityAndFocalHtml(norm) + '</section>';
    html += '<section class="rogma-result-section" id="rogma-ritual">' +
      '<h3 class="rogma-section-title">' + escapeHtml(COPY.ritualTitulo) + '</h3>' +
      '<p class="rogma-section-subtitle">' + escapeHtml(COPY.ritualSub) + '</p>' +
      '<div id="rogma-ritual-mount"></div></section>';
    html += renderObservedNotTreatedHtml(norm.observadoNoTratado);
    html += renderTopicalLimitationHtml(norm.limitacionTopica);
    DOM.resultMount.innerHTML = html;
    if (DOM.feedbackMount) DOM.feedbackMount.innerHTML = '';
    setStickyCtaVisibility(false);
    renderProducts(norm);
    setupStickyCtaBehavior();
    if (CONFIG.showFeedback && DOM.feedbackMount && norm.scanId) renderFeedback(norm.scanId);
  }

  function renderReescanRequired(norm) {
    root.setAttribute('data-result-state', 'rescan');
    var message = sanitizeCopy(norm.motivoReescaneo || 'Necesitamos repetir el escaneo con luz frontal uniforme para darte una evaluación más confiable.');
    DOM.resultMount.innerHTML = '<section class="rogma-quality-rescan" role="status" aria-live="polite">' +
      '<span class="rogma-quality-rescan__icon" aria-hidden="true">↻</span>' +
      '<p class="rogma-quality-rescan__eyebrow">Cuidemos la precisión de tu lectura</p>' +
      '<h2>Necesitamos repetir el escaneo</h2>' +
      '<p class="rogma-quality-rescan__message">' + escapeHtml(message) + '</p>' +
      '<button type="button" class="rogma-btn-primary" id="rogma-quality-rescan-new">Repetir escaneo</button>' +
      '</section>';
    if (DOM.feedbackMount) DOM.feedbackMount.innerHTML = '';
    setStickyCtaVisibility(false);
    var retry = document.getElementById('rogma-quality-rescan-new');
    if (retry) retry.addEventListener('click', fullReset);
  }

  function normalizeVisibleFindings(items, symptoms) {
    var seen = {};
    var normalized = (items || []).map(function (item) {
      if (!item || typeof item !== 'object') return null;
      var key = String(item.sintoma || item.clave || item.key || item.categoria || '').toLowerCase();
      var label = sanitizeCopy(item.label || item.hallazgo || item.nombre || labelSintoma(key));
      if (!key && label) key = canonicalAspectKey({ label: label });
      var symptom = symptoms[key] || {};
      var severity = String(item.severidad_v8 || item.severidad || item.nivel || '').toLowerCase();
      if (!SEVERIDAD[severity]) severity = resolveSeveridad(symptom);
      if (!label || !severity || severity === 'ninguno') return null;
      var id = key || label.toLowerCase();
      if (seen[id]) return null;
      seen[id] = true;
      return { key: key, label: label, severity: severity, score: Number(item.score || symptom.score || 0) || 0 };
    }).filter(Boolean);

    if (!normalized.length) {
      Object.keys(SINTOMA_LABELS).forEach(function (key) {
        var dato = symptoms && symptoms[key];
        var severity = resolveSeveridad(dato);
        if (!dato || !dato.presente || severity === 'ninguno') return;
        normalized.push({ key: key, label: labelSintoma(key), severity: severity, score: Number(dato.score || 0) || 0 });
      });
    }
    return normalized;
  }

  function severityIndicatorHtml(severity) {
    var key = SEVERIDAD[severity] ? severity : 'leve';
    var meta = SEVERIDAD[key] || SEVERIDAD.leve;
    var level = Math.max(1, Math.min(4, (SEV_ORDER[key] || 1)));
    return '<span class="rogma-severity rogma-severity--' + escapeAttr(SEV_COLOR[key] || 'low') + '" aria-label="Nivel observado: ' + escapeAttr(meta.label) + '">' +
      '<span class="rogma-severity__scale" aria-hidden="true">' +
      [1, 2, 3, 4].map(function (n) { return '<i' + (n <= level ? ' class="is-on"' : '') + '></i>'; }).join('') +
      '</span><span class="rogma-severity__label">' + escapeHtml(meta.label) + '</span></span>';
  }

  function renderVisibleFindingsHtml(items) {
    if (!items || !items.length) return '<p class="rogma-findings__empty">No se identificaron hallazgos visibles que requieran atención.</p>';
    return '<div class="rogma-findings__grid">' + items.map(function (item) {
      var visual = SINTOMA_VISUAL[item.key] || SINTOMA_VISUAL.ninguno;
      return '<article class="rogma-finding-card">' +
        '<span class="rogma-finding-card__icon" aria-hidden="true">' + sintomaIconSvg(visual.icon) + '</span>' +
        '<span class="rogma-finding-card__name">' + escapeHtml(item.label) + '</span>' +
        severityIndicatorHtml(item.severity) + '</article>';
    }).join('') + '</div>';
  }

  function renderPriorityAndFocalHtml(norm) {
    var priority = norm.prioridadTratamiento;
    var html = '';
    if (priority && priority.sintoma) {
      var key = String(priority.sintoma);
      var item = (norm.hallazgosVisibles || []).filter(function (finding) { return finding.key === key; })[0];
      var severity = item ? item.severity : resolveSeveridad(norm.sintomas[key]);
      html += '<article class="rogma-priority-card"><div class="rogma-priority-card__title-row">' +
        '<span class="rogma-priority-card__icon" aria-hidden="true">!</span><div><p class="rogma-priority-card__eyebrow">Atención principal esta semana</p>' +
        '<h3>' + escapeHtml(item ? item.label : labelSintoma(key)) + '</h3></div></div>' +
        (severity && severity !== 'ninguno' ? severityIndicatorHtml(severity) : '') +
        (priority.razon_cliente ? '<p>' + escapeHtml(sanitizeCopy(priority.razon_cliente)) + '</p>' : '') + '</article>';
    }
    var focal = norm.cuidadoFocal || [];
    if (focal.length) {
      html += '<aside class="rogma-focal-card"><p class="rogma-focal-card__eyebrow">En paralelo</p><h3>Cuidado focal</h3>' +
        '<ul>' + focal.map(function (entry) {
          var name = typeof entry === 'string' ? labelSintoma(entry) : (entry.sintoma ? labelSintoma(entry.sintoma) : (entry.producto ? labelSintoma(entry.producto) : (entry.label || entry.nombre || 'Cuidado localizado')));
          return '<li>' + escapeHtml(sanitizeCopy(name)) + '</li>';
        }).join('') + '</ul></aside>';
    }
    return html || '<p class="rogma-section-subtitle">Tu rutina acompaña los aspectos visibles observados.</p>';
  }

  function observedReasonCopy(item) {
    var reason = String(item && item.motivo || '').toLowerCase();
    if (reason === 'excluido_por_limite_comercial') return 'Esta semana cuidamos el equilibrio de la rutina y reservamos espacio para los pasos con mayor prioridad. Este aspecto queda registrado para retomarlo después.';
    if (reason === 'deferido_por_inflamacion_activa') return 'Primero damos calma a la piel. Cuando la inflamación esté más tranquila, podremos retomar este aspecto de forma gradual.';
    if (reason === 'sin_slot_activo_esta_semana') return 'Lo tenemos presente. Esta semana mantuvimos una rutina más sencilla y podremos retomarlo en el siguiente paso.';
    return sanitizeCopy(item && item.razon_cliente || 'Lo tenemos presente y lo retomaremos cuando la piel esté lista para sumar otro paso.');
  }

  function renderObservedNotTreatedHtml(items) {
    if (!items || !items.length) return '';
    return '<section class="rogma-result-section rogma-observed-section"><h3 class="rogma-section-title">Lo dejamos para después</h3>' +
      '<p class="rogma-section-subtitle">Algunos aspectos quedan registrados mientras cuidamos la tolerancia y el ritmo de tu piel.</p>' +
      '<div class="rogma-observed-list">' + items.map(function (item) {
        var label = labelSintoma(item.sintoma || item.producto || '');
        return '<article class="rogma-observed-card"><span class="rogma-observed-card__mark" aria-hidden="true">↗</span><div><h4>' +
          escapeHtml(label) + '</h4><p>' + escapeHtml(observedReasonCopy(item)) + '</p></div></article>';
      }).join('') + '</div></section>';
  }

  function renderTopicalLimitationHtml(limitation) {
    if (!limitation) return '';
    var message = typeof limitation === 'string' ? limitation : (limitation.mensaje_cliente || limitation.mensaje || 'La rutina tópica puede apoyar la apariencia superficial; algunos cambios estructurales pueden requerir valoración profesional.');
    return '<aside class="rogma-topical-note"><span class="rogma-topical-note__icon" aria-hidden="true">i</span><p>' + escapeHtml(sanitizeCopy(message)) + '</p></aside>';
  }

  function checkIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 12 9 17 20 6"/></svg>';
  }

  function resultHeroTitleHtml(title) {
    var name = STATE.displayName ? String(STATE.displayName).trim() : '';
    var hasRealName = name && /[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9]/.test(name);

    if (hasRealName) {
      return '<span class="name">' +
        escapeHtml(name) +
      '</span>, tu ritual personalizado está listo.';
    }

    return 'Tu ritual personalizado está listo.';
  }

  function sintomaIconSvg(iconKey) {
    var icons = {
      granito: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="8" cy="10" r="1.6"/><circle cx="14" cy="8" r="1.2"/><circle cx="17" cy="13" r="1.4"/><circle cx="11" cy="15" r="1.1"/></svg>',
      mancha: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M7 14c2-4 6-6 10-4 2 1 3 4 2 7-1 3-4 5-8 4-3-1-5-4-4-7z" stroke-linecap="round"/></svg>',
      poros: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="8" cy="9" r="1.3"/><circle cx="13" cy="8" r="1.3"/><circle cx="16" cy="12" r="1.3"/><circle cx="10" cy="14" r="1.3"/><circle cx="14" cy="16" r="1.3"/></svg>',
      ojos: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6z"/><circle cx="12" cy="12" r="2.2"/></svg>',
      textura: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M5 8c3 0 5 2 7 2s4-2 7-2M5 12c3 0 5 2 7 2s4-2 7-2M5 16c3 0 5 2 7 2s4-2 7-2" stroke-linecap="round"/></svg>',
      luminosidad: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 3v2M12 19v2M5 12H3M21 12h-2M6.3 6.3l-1.4-1.4M19.1 19.1l-1.4-1.4M6.3 17.7l-1.4 1.4M19.1 4.9l-1.4 1.4"/><circle cx="12" cy="12" r="3.5"/></svg>',
      rojez: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M6 14c2-3 5-4 8-3 2 1 3 3 2 5-1 2-3 3-6 2" stroke-linecap="round"/><path d="M8 10c1-1 2.5-1.5 4-1" stroke-linecap="round" opacity="0.5"/></svg>',
      lineas: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M5 10c4-2 8-2 12 0M6 14c3-1.5 7-1.5 10 0" stroke-linecap="round"/></svg>',
      equilibrio: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="12" cy="12" r="7"/><path d="M8 12h8" stroke-linecap="round"/></svg>',
    };
    return icons[iconKey] || icons.equilibrio;
  }

  /* ═══════════════════════════════════════════════════════════
     RENDER_PRODUCTS
     ═══════════════════════════════════════════════════════════ */

  function buildCuratedRoutineEntries(am, pm, focal) {
    var entries = [];
    var seen = {};

    function productKey(producto) {
      return String(
        producto.variant_id ||
        producto.id ||
        producto.handle ||
        producto.sku ||
        producto.clave ||
        producto.title ||
        entries.length
      );
    }

    function pushAll(productos, periodo) {
      (productos || []).forEach(function (producto) {
        if (!producto) return;
        var key = productKey(producto);
        if (seen[key]) return;

        seen[key] = true;
        entries.push({
          producto: producto,
          periodo: periodo,
        });
      });
    }

    pushAll(am, 'am');
    pushAll(pm, 'pm');
    pushAll(focal, 'focalizado');

    return entries;
  }

  function numericProductPrice(producto) {
    if (!producto || producto.price == null || producto.price === '') return 0;
    var num = Number(String(producto.price).replace(/,/g, '').replace(/[^\d.]/g, ''));
    return isNaN(num) ? 0 : num;
  }

  function routineTotalPrice(productos) {
    return (productos || []).reduce(function (sum, producto) {
      return sum + numericProductPrice(producto);
    }, 0);
  }

  function updateRoutineTotalUi(productos) {
    var total = routineTotalPrice(productos);
    var label = total > 0 ? formatPrecioProducto(total) : '—';

    STATE.routineTotalLabel = label;

    ['rogma-routine-total', 'rogma-sticky-total'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = label;
    });
  }

  function routineBuyStripHtml(productos, am, pm, focal) {
    var total = routineTotalPrice(productos);
    var price = total > 0 ? formatPrecioProducto(total) : '—';
    var count = (productos || []).length;
    var countLabel = count === 1 ? '1 producto' : count + ' productos';
    var moments = [];

    if ((am || []).length) moments.push('AM');
    if ((pm || []).length) moments.push('PM');
    if ((focal || []).length) moments.push('Focal');

    return '<div class="rogma-ritual-buy-strip" aria-label="Resumen de compra del ritual">' +
      '<div>' +
        '<span class="rogma-ritual-buy-strip__label">Ritual completo</span>' +
        '<span class="rogma-ritual-buy-strip__value">' +
          escapeHtml(countLabel + (moments.length ? ' · ' + moments.join(' + ') : '')) +
        '</span>' +
      '</div>' +
      '<strong class="rogma-ritual-buy-strip__price" id="rogma-routine-total">' +
        escapeHtml(price) +
      '</strong>' +
    '</div>';
  }

  function periodoLabelForProduct(periodo) {
    if (periodo === 'am') return 'AM';
    if (periodo === 'pm') return 'PM';
    if (periodo === 'focalizado') return 'Focal';
    return 'RŌGMA';
  }

  function buildRitualGroups(am, pm, focal) {
    var groups = [];

    if (am && am.length) {
      groups.push({
        key: 'am',
        label: '☀ AM',
        periodLabel: 'AM',
        periodo: 'am',
        productos: am,
      });
    }

    if (pm && pm.length) {
      groups.push({
        key: 'pm',
        label: '☾ PM',
        periodLabel: 'PM',
        periodo: 'pm',
        productos: pm,
      });
    }

    if (focal && focal.length) {
      groups.push({
        key: 'focalizado',
        label: '◎ Focal',
        periodLabel: 'Focal',
        periodo: 'focalizado',
        productos: focal,
      });
    }

    return groups;
  }

  function productoEsDuneFrontend(producto) {
    if (!producto || typeof producto !== 'object') return false;

    var blob = [
      producto.sku,
      producto.clave,
      producto.handle,
      producto.title,
      producto.nombre,
      producto.name,
      producto.variant_id,
      producto.shopify_variant_id,
      producto.id,
    ].filter(Boolean).join(' ').toLowerCase();

    return (
      blob.indexOf('42279281000503') !== -1 ||
      blob.indexOf('dune') !== -1 ||
      blob.indexOf('solar defense') !== -1 ||
      blob.indexOf('spf50') !== -1 ||
      blob.indexOf('spf 50') !== -1
    );
  }

  function getProductImageUrl(producto) {
    if (!producto || typeof producto !== 'object') return '';

    var direct =
      producto.imagen ||
      producto.image ||
      producto.image_url ||
      producto.featured_image ||
      producto.featuredImage ||
      producto.src ||
      '';

    if (direct) return direct;

    if (productoEsDuneFrontend(producto)) {
      return 'https://cdn.shopify.com/s/files/1/0059/4503/2768/files/IMAGEDECKDUNE.png?v=1781973835';
    }

    return '';
  }

  function productInlineImageHtml(producto, titulo, compact) {
    var imageUrl = getProductImageUrl(producto);

    if (imageUrl) {
      return '<img src="' + escapeAttr(imageUrl) + '" alt="' + escapeAttr(titulo) + '">';
    }

    return '<span class="' + (compact ? 'rogma-product-compact-placeholder' : 'rogma-product-thumb-placeholder') + '" aria-hidden="true">' +
      sintomaIconSvg('equilibrio') +
    '</span>';
  }

  function renderCycleCalendarHtml(producto, norm) {
    var cycles = norm && norm.reglasRutina && Array.isArray(norm.reglasRutina.ciclado) ? norm.reglasRutina.ciclado : [];
    var sku = String(producto && (producto.sku || producto.clave || producto.handle) || '').toLowerCase();
    if (!sku || !cycles.length) return '';
    var dayLabels = [
      { key: 'lunes', short: 'L' }, { key: 'martes', short: 'M' }, { key: 'miércoles', alt: 'miercoles', short: 'X' },
      { key: 'jueves', short: 'J' }, { key: 'viernes', short: 'V' }, { key: 'sábado', alt: 'sabado', short: 'S' }, { key: 'domingo', short: 'D' },
    ];
    var matching = [];
    cycles.forEach(function (cycle) {
      var days = cycle && cycle.dias && (cycle.dias[sku] || cycle.dias[sku.replace(/-/g, '_')]);
      if (days) matching.push(String(days).toLowerCase());
    });
    if (!matching.length) return '';
    var activeDays = matching.join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return '<div class="rogma-cycle-calendar" aria-label="Calendario semanal de uso"><span class="rogma-cycle-calendar__title">Esta semana</span><div class="rogma-cycle-calendar__days">' +
      dayLabels.map(function (day) {
        var token = day.key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        var active = new RegExp('(?:^|[^a-z])' + token + '(?:$|[^a-z])').test(activeDays) || (day.alt && new RegExp('(?:^|[^a-z])' + day.alt + '(?:$|[^a-z])').test(activeDays));
        return '<span class="rogma-cycle-calendar__day' + (active ? ' is-active' : '') + '"' + (active ? ' aria-current="true"' : '') + '>' + day.short + '</span>';
      }).join('') + '</div></div>';
  }

  function productInlineAccordionHtml(producto, periodo, norm, isOpen, isPrimary) {
    var titulo = tituloProductoCosmetico(producto);
    var precio = formatPrecioProducto(producto.price);
    var aspecto = buildProductAspectLabel(producto, norm);
    var benefitLine = buildProductBenefitLine(producto, aspecto);
    var imgHtml = productInlineImageHtml(producto, titulo, false);
    var expanded = isOpen ? 'true' : 'false';
    var openClass = isOpen ? ' is-open' : '';
    var primaryClass = isPrimary ? ' is-primary' : '';

    var panelHtml =
      '<div class="rogma-product-inline-panel__image">' + imgHtml + '</div>' +
      '<div class="rogma-product-inline-panel__copy">' +
        '<p class="rogma-product-accordion__benefit">' + escapeHtml(benefitLine) + '</p>' +
        '<p class="rogma-product-accordion__section-title">' + escapeHtml(COPY.accordionPorQue) + '</p>' +
        '<p class="rogma-product-accordion__muted">' + escapeHtml(porQueEnRutina(producto)) + '</p>' +
        '<p class="rogma-product-accordion__section-title">' + escapeHtml(COPY.accordionComoUsar) + '</p>' +
        '<p class="rogma-product-accordion__usage">' + escapeHtml(comoUsarProducto(producto, periodo)) + '</p>' +
        renderCycleCalendarHtml(producto, norm) +
      '</div>';

    return (
      '<div class="rogma-product-accordion rogma-product-inline-accordion' + openClass + primaryClass + '" data-accordion>' +
        '<button type="button" class="rogma-product-accordion__trigger" aria-expanded="' + expanded + '">' +
          '<div class="rogma-product-thumb">' + imgHtml + '</div>' +
          '<div class="rogma-product-info">' +
            '<div class="rogma-product-periodo">' + escapeHtml(periodoLabelForProduct(periodo)) + (isPrimary ? ' · Producto clave' : '') + '</div>' +
            '<div class="rogma-product-name">' + escapeHtml(titulo) + '</div>' +
            (precio ? '<div class="rogma-product-price">' + escapeHtml(precio) + '</div>' : '') +
          '</div>' +
          '<span class="rogma-product-accordion__action" aria-hidden="true">' +
            '<span class="rogma-product-accordion__action-label">' + (isOpen ? 'Ocultar' : 'Detalle') + '</span>' +
            '<span class="rogma-product-accordion__chevron"></span>' +
          '</span>' +
        '</button>' +
        '<div class="rogma-product-accordion__panel"' + (isOpen ? '' : ' hidden') + '>' + panelHtml + '</div>' +
      '</div>'
    );
  }

  function renderRitualModeTabs(groups, activeKey) {
    if (!groups.length) return '';

    return '<div class="rogma-ritual-tabs" aria-label="Momentos del ritual" role="tablist">' +
      groups.map(function (group) {
        var active = group.key === activeKey;
        return '<button type="button" class="rogma-ritual-tab' + (active ? ' is-active' : '') + '" data-ritual-tab="' + escapeAttr(group.key) + '" role="tab" aria-selected="' + (active ? 'true' : 'false') + '">' +
          escapeHtml(group.label) +
        '</button>';
      }).join('') +
    '</div>';
  }

  function renderCuratedRoutineHtml(groups, norm, activeKey) {
    if (!groups.length) return '';

    var html = '<div class="rogma-ritual-curated">';
    html += renderRitualModeTabs(groups, activeKey);

    groups.forEach(function (group) {
      var isActive = group.key === activeKey;
      html += '<div class="rogma-ritual-panel' + (isActive ? ' is-active' : '') + '" data-ritual-panel="' + escapeAttr(group.key) + '"' + (isActive ? '' : ' hidden') + '>';
      group.productos.forEach(function (producto, index) {
        html += productInlineAccordionHtml(
          producto,
          group.periodo,
          norm,
          index === 0,
          index === 0
        );
      });
      html += '</div>';
    });

    html += '</div>';

    return html;
  }

  function bindRitualTabs(mount) {
    var tabs = mount.querySelectorAll('[data-ritual-tab]');
    var panels = mount.querySelectorAll('[data-ritual-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-ritual-tab');

        tabs.forEach(function (other) {
          var isActive = other === tab;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-ritual-panel') === key;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);

          if (isActive && !panel.querySelector('[data-accordion].is-open')) {
            var first = panel.querySelector('[data-accordion]');
            if (first) {
              setProductAccordionUi(first, true);
            }
          }
        });
      });
    });
  }

  function renderProducts(norm) {
    var mount = document.getElementById('rogma-ritual-mount');
    if (!mount) return;

    var am = norm.rutinaAm;
    var pm = norm.rutinaPm;
    var focal = norm.cuidadoFocalizado;
    var groups = buildRitualGroups(am, pm, focal);

    if (!groups.length) {
      mount.innerHTML = '<p class="rogma-section-subtitle" style="margin-top:16px">' + escapeHtml(COPY.sinRitual) + '</p>';
      updateRoutineTotalUi([]);
      return;
    }

    var entries = buildCuratedRoutineEntries(am, pm, focal);
    var currentRoutineProducts = entries.map(function (entry) {
      return entry.producto;
    });

    STATE.routineItems = buildRoutineCartItems(currentRoutineProducts);
    STATE.routineVariantIds = STATE.routineItems.map(function (item) {
      return Number(item.id);
    }).filter(function (id) {
      return isFinite(id) && id > 0;
    });

    var activeKey = groups[0].key;
    var html = '<div class="rogma-ritual-shell rogma-ritual-shell--curated rogma-ritual-shell--inline">';
    html += routineBuyStripHtml(currentRoutineProducts, am, pm, focal);
    html += renderCuratedRoutineHtml(groups, norm, activeKey);
    html += '</div>';

    html += '<div class="rogma-routine-cta-wrap rogma-routine-cta-wrap--inline">';
    html += '<button type="button" class="rogma-btn-primary rogma-btn-primary--routine" id="rogma-add-routine">' + escapeHtml(COPY.cartAgregar) + '</button>';
    html += '<p class="rogma-routine-cta-note">El detalle final de productos y precio aparecerá en tu carrito.</p>';
    html += '</div>';

    mount.innerHTML = html;

    bindRitualTabs(mount);
    bindProductAccordions(mount);
    updateRoutineTotalUi(currentRoutineProducts);

    var onAddRoutine = function () {
      addRoutineToCart(am, pm, focal);
    };

    var routineBtn = document.getElementById('rogma-add-routine');
    if (routineBtn) {
      routineBtn.addEventListener('click', onAddRoutine);
    }

    syncRoutineCartState();
    observeCartDrawerChanges();
  }

  function periodoHeadHtml(label, icon, sub) {
    return (
      '<div class="rogma-periodo-head">' +
        '<div class="rogma-periodo-icon" aria-hidden="true">' + icon + '</div>' +
        '<div><h4>' + escapeHtml(label) + '</h4>' +
        (sub ? '<p class="sub">' + escapeHtml(sub) + '</p>' : '') +
        '</div>' +
      '</div>'
    );
  }

  function periodoSectionHtml(label, icon, sub, productos, periodo, norm, accordionState) {
    var html = '<div class="rogma-periodo">';
    html += periodoHeadHtml(label, icon, sub);
    productos.forEach(function (p, i) {
      var isOpen = accordionState.openDefault && i === 0;
      if (isOpen) accordionState.openDefault = false;
      html += productAccordionHtml(p, periodo, norm, isOpen);
    });
    html += '</div>';
    return html;
  }

  function productAccordionHtml(producto, periodo, norm, isOpen) {
    var titulo = tituloProductoCosmetico(producto);
    var precio = formatPrecioProducto(producto.price);
    var aspecto = buildProductAspectLabel(producto, norm);
    var benefitLine = buildProductBenefitLine(producto, aspecto);
    var imageUrl = getProductImageUrl(producto);
    var imgHtml = imageUrl
      ? '<img src="' + escapeAttr(imageUrl) + '" alt="' + escapeAttr(titulo) + '">'
      : '<span class="rogma-product-thumb-placeholder" aria-hidden="true">◻</span>';
    var expanded = isOpen ? 'true' : 'false';
    var openClass = isOpen ? ' is-open' : '';

    var panelHtml =
      '<div class="rogma-product-accordion__hero">' + imgHtml + '</div>' +
      '<p class="rogma-product-accordion__benefit">' + escapeHtml(benefitLine) + '</p>' +
      '<p class="rogma-product-accordion__section-title">' + escapeHtml(COPY.accordionPorQue) + '</p>' +
      '<p class="rogma-product-accordion__muted">' + escapeHtml(porQueEnRutina(producto)) + '</p>' +
      '<p class="rogma-product-accordion__section-title">' + escapeHtml(COPY.accordionComoUsar) + '</p>' +
      '<p class="rogma-product-accordion__usage">' + escapeHtml(comoUsarProducto(producto, periodo)) + '</p>';

    if (producto.handle) {
      panelHtml += '<a class="rogma-product-accordion__link" href="/products/' + encodeURIComponent(producto.handle) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(COPY.accordionVerProducto) + '</a>';
    }

    return (
      '<div class="rogma-product-accordion' + openClass + '" data-accordion>' +
        '<button type="button" class="rogma-product-accordion__trigger" aria-expanded="' + expanded + '">' +
          '<div class="rogma-product-thumb">' + imgHtml + '</div>' +
          '<div class="rogma-product-info">' +
            '<div class="rogma-product-name">' + escapeHtml(titulo) + '</div>' +
            (precio ? '<div class="rogma-product-price">' + escapeHtml(precio) + '</div>' : '') +
          '</div>' +
          '<span class="rogma-product-accordion__chevron" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="rogma-product-accordion__panel"' + (isOpen ? '' : ' hidden') + '>' + panelHtml + '</div>' +
      '</div>'
    );
  }

  function setProductAccordionUi(accordion, isOpen) {
    var trigger = accordion.querySelector('.rogma-product-accordion__trigger');
    var panel = accordion.querySelector('.rogma-product-accordion__panel');
    var label = accordion.querySelector('.rogma-product-accordion__action-label');

    accordion.classList.toggle('is-open', isOpen);

    if (trigger) {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (panel) {
      panel.hidden = !isOpen;
    }

    if (label) {
      label.textContent = isOpen ? 'Ocultar' : 'Detalle';
    }
  }

  function bindProductAccordions(mount) {
    mount.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var trigger = accordion.querySelector('.rogma-product-accordion__trigger');
      var panel = accordion.querySelector('.rogma-product-accordion__panel');
      if (!trigger || !panel) return;

      setProductAccordionUi(accordion, accordion.classList.contains('is-open'));

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        mount.querySelectorAll('[data-accordion].is-open').forEach(function (other) {
          if (other === accordion) return;
          setProductAccordionUi(other, false);
        });

        setProductAccordionUi(accordion, !isOpen);
      });
    });
  }

  function buildProductAspectLabel(producto, norm) {
    if (norm.prioridadTratamiento && norm.prioridadTratamiento.sintoma) {
      return labelSintoma(norm.prioridadTratamiento.sintoma).toLowerCase();
    }
    if (norm.prioridad && norm.prioridad !== 'ninguno') {
      return labelSintoma(norm.prioridad).toLowerCase();
    }
    return 'tu evaluación';
  }

  function buildProductBenefitLine(producto, aspecto) {
    var tipo = detectarTipoProducto(producto);
    var tipoLabel = {
      salicilico: 'Cuidado focalizado',
      blemish: 'Gel crema',
      niacinamida: 'Serúm',
      vit_c: 'Serúm',
      night_repair: 'Crema nocturna',
      hialuronico: 'Serúm',
      contorno_ojos: 'Contorno de ojos',
      pca: 'Cuidado intensivo',
      generico: 'Producto',
    };
    var productoTipo = tipoLabel[tipo] || tipoLabel.generico;
    return productoTipo + ' formulado para acompañar la apariencia de ' + aspecto + '.';
  }

  function openProductModal(producto, periodo) {
    STATE.modalProduct = producto;
    STATE.modalPeriodo = periodo;

    var titulo = tituloProductoCosmetico(producto);
    var precio = formatPrecioProducto(producto.price);
    var etiqueta = etiquetaUsoProducto(periodo);

    DOM.modalTitle.textContent = titulo;
    DOM.modalMeta.textContent = [etiqueta, precio].filter(Boolean).join(' · ');

    var imageUrl = getProductImageUrl(producto);
    DOM.modalImage.innerHTML = imageUrl
      ? '<img src="' + escapeAttr(imageUrl) + '" alt="' + escapeAttr(titulo) + '">'
      : '<span style="color:var(--rg-muted);font-size:2rem">◻</span>';

    DOM.modalBody.innerHTML =
      '<p class="rogma-modal__benefit">' + escapeHtml(queAportaPiel(producto)) + '</p>' +
      '<p class="rogma-modal__section-title">' + escapeHtml(COPY.modalPorQue) + '</p>' +
      '<p class="rogma-modal__muted">' + escapeHtml(porQueEnRutina(producto)) + '</p>' +
      '<p class="rogma-modal__section-title">' + escapeHtml(COPY.modalComoUsar) + '</p>' +
      '<p>' + escapeHtml(comoUsarProducto(producto, periodo)) + '</p>';

    DOM.modalAdd.textContent = COPY.ctaAgregar;
    DOM.modalAdd.classList.remove('rogma-btn-state-success', 'rogma-btn-state-error');

    if (producto.handle) {
      DOM.modalProductLink.href = '/products/' + encodeURIComponent(producto.handle);
      DOM.modalProductLink.textContent = COPY.modalVerPagina;
      DOM.modalProductLink.hidden = false;
    } else {
      DOM.modalProductLink.hidden = true;
    }

    DOM.modal.hidden = false;
    DOM.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeProductModal() {
    DOM.modal.hidden = true;
    DOM.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    STATE.modalProduct = null;
    STATE.modalPeriodo = null;
  }

  /* ═══════════════════════════════════════════════════════════
     CART
     ═══════════════════════════════════════════════════════════ */

  function resolveVariantId(producto) {
    return producto.variant_id || producto.variantId || producto.shopifyVariantId || null;
  }

  function dedupeProductsByVariantId(productos) {
    var seen = {};
    var out = [];
    (productos || []).forEach(function (p) {
      var id = resolveVariantId(p);
      if (id == null || id === '') {
        console.warn('[ROGMA Cart] Producto sin variant_id omitido:', p.title || p.clave || p);
        return;
      }
      var key = String(id);
      if (seen[key]) return;
      seen[key] = true;
      out.push(p);
    });
    return out;
  }

  function productosUnicos(am, pm, focal) {
    return dedupeProductsByVariantId([].concat(am || [], pm || [], focal || []));
  }

  function buildRoutineCartItems(productos) {
    return dedupeProductsByVariantId(productos).map(function (p) {
      var id = Number(resolveVariantId(p));
      if (!isFinite(id) || id <= 0) {
        console.warn('[ROGMA Cart] variant_id inválido omitido:', p.title || p.clave || p);
        return null;
      }
      return {
        id: id,
        quantity: 1,
        properties: {
          _source: 'rogma_ia',
          _routine: 'ai_recommendation',
          _view: 'shopify_scan_v1',
          _rogma_source: 'escaner',
          _rogma_ia_source: 'rogma_ia_scan',
          _rogma_scan_id: STATE.lastScanId || 'sin_scan_id',
          _rogma_version: CONFIG.trackingVersion,
        },
      };
    }).filter(Boolean);
  }

  function buildTestCheckoutCartItems() {
    if (!CONFIG.testCheckoutMode) return null;

    var variantId = Number(CONFIG.testProductVariantId);
    if (!isFinite(variantId) || variantId <= 0) {
      console.warn('[ROGMA Test Checkout] Falta data-test-product-variant-id válido.');
      return [];
    }

    return [
      {
        id: variantId,
        quantity: 1,
        properties: {
          _source: 'rogma_ia',
          _routine: 'ai_recommendation',
          _view: 'shopify_scan_v1',
          _rogma_source: 'escaner',
          _rogma_ia_source: 'rogma_ia_scan',
          _rogma_scan_id: STATE.lastScanId || 'sin_scan_id',
          _rogma_version: CONFIG.trackingVersion,

          /*
           * Marcadores temporales para que el pedido de prueba sea fácil
           * de identificar y no se confunda con venta real de producto.
           */
          _rogma_test_mode: 'true',
          _rogma_test_product_id: CONFIG.testProductId || '',
          _rogma_test_variant_id: String(variantId),
          _rogma_test_product_title: CONFIG.testProductTitle || 'RŌGMA IA Test Product',
          _rogma_test_product_price: CONFIG.testProductPrice || '1.00',
        },
      },
    ];
  }

  function getShopifyRootRoute() {
    var route =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return route.charAt(route.length - 1) === '/' ? route : route + '/';
  }

  function getCartSectionsToRender(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender()
        .map(function (section) { return section && section.id; })
        .filter(Boolean);
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function getCurrentCart() {
    return fetch(getShopifyRootRoute() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || 'No pudimos leer el carrito.');
        }
        return data;
      });
    });
  }

  function getCartVariantMap(cart) {
    var map = {};

    ((cart && cart.items) || []).forEach(function (item) {
      var id = Number(item.variant_id || item.id);
      if (isFinite(id) && id > 0) {
        map[id] = (map[id] || 0) + Number(item.quantity || 0);
      }
    });

    return map;
  }

  function getMissingRoutineItems(items, cart) {
    var map = getCartVariantMap(cart);

    return (items || []).filter(function (item) {
      var id = Number(item.id);
      return isFinite(id) && id > 0 && !map[id];
    });
  }

  function buildRogmaCartAttributionAttributes() {
    return {
      rogma_ia_source: 'escaner',
      rogma_ia_flow: 'rogma_ia_scan',
      rogma_ia_version: CONFIG.trackingVersion,
      rogma_scan_id: STATE.lastScanId || 'sin_scan_id',
    };
  }

  function updateCartAttributionAttributes() {
    return fetch(getShopifyRootRoute() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: buildRogmaCartAttributionAttributes(),
      }),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || 'No pudimos etiquetar el carrito.');
        }
        return data;
      });
    });
  }

  function addItemsToShopifyCart(items) {
    var drawer = document.querySelector('cart-drawer');
    var payload = {
      items: items,
      sections: getCartSectionsToRender(drawer),
      sections_url: window.location.pathname,
    };

    return fetch(getShopifyRootRoute() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || COPY.cartError);
        }
        return data;
      });
    });
  }

  function fetchCartDrawerSections() {
    var drawer = document.querySelector('cart-drawer');
    var ids = getCartSectionsToRender(drawer);
    var path = window.location.pathname || getShopifyRootRoute();
    var sep = path.indexOf('?') >= 0 ? '&' : '?';
    var url =
      path +
      sep +
      'sections=' +
      encodeURIComponent(ids.join(',')) +
      '&sections_url=' +
      encodeURIComponent(window.location.pathname || '/');

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          throw new Error('No pudimos refrescar el drawer del carrito.');
        }

        return {
          id: null,
          sections: data,
        };
      });
    });
  }

  function cartResponseHasDrawerSections(parsedState) {
    return Boolean(
      parsedState &&
      parsedState.sections &&
      typeof parsedState.sections['cart-drawer'] === 'string' &&
      parsedState.sections['cart-drawer'].trim()
    );
  }

  function renderAndOpenShopifyCart(parsedState, triggeredBy) {
    var drawer = document.querySelector('cart-drawer');

    if (
      !drawer ||
      typeof drawer.renderContents !== 'function' ||
      !cartResponseHasDrawerSections(parsedState)
    ) {
      return false;
    }

    drawer.classList.remove('is-empty');

    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    var drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.remove('is-empty');

    if (triggeredBy && typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(triggeredBy);
    }

    drawer.renderContents(parsedState);
    return true;
  }

  function openDrawerDirectly(triggeredBy) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    try {
      if (triggeredBy && typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(triggeredBy);
      }

      if (typeof drawer.open === 'function') {
        drawer.open(triggeredBy || document.activeElement);
        return true;
      }

      drawer.classList.add('active');
      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');

      document.body.classList.add('overflow-hidden');
      return true;
    } catch (error) {
      console.warn('[ROGMA Cart] No pudimos abrir el drawer directamente:', error);
      return false;
    }
  }

  function clickCartIconFallback() {
    var selectors = [
      '#cart-icon-bubble',
      'a#cart-icon-bubble',
      '.header__icon--cart',
      'a[href="/cart"]',
      'a[href$="/cart"]',
      'a[href*="/cart"]',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;

      try {
        el.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        return true;
      } catch (error) {
        try {
          el.click();
          return true;
        } catch (innerError) {
          console.warn('[ROGMA Cart] Fallback click falló:', innerError);
        }
      }
    }

    return false;
  }

  function openCartOrFallback(parsedState, triggeredBy) {
    try {
      if (renderAndOpenShopifyCart(parsedState, triggeredBy)) {
        return Promise.resolve(true);
      }
    } catch (err) {
      console.error('[ROGMA Cart] No pudimos renderizar el drawer:', err);
    }

    return fetchCartDrawerSections()
      .then(function (freshState) {
        if (renderAndOpenShopifyCart(freshState, triggeredBy)) {
          return true;
        }

        return openDrawerDirectly(triggeredBy) || clickCartIconFallback();
      })
      .catch(function (error) {
        console.warn('[ROGMA Cart] Refresco del drawer falló:', error);
        return openDrawerDirectly(triggeredBy) || clickCartIconFallback();
      })
      .then(function (opened) {
        if (!opened) {
          console.warn('[ROGMA Cart] No se pudo abrir el drawer. No se redirige para conservar la experiencia.');
        }
        return opened;
      });
  }

  function appendCartTracking(path) {
    if (!path) return '/cart';
    var sep = path.indexOf('?') >= 0 ? '&' : '?';
    return path + sep + CONFIG.cartUtm;
  }

  function setRoutineButtonState(state) {
    var labels = {
      idle: COPY.cartAgregar,
      partial: COPY.cartAgregarFaltantes,
      loading: COPY.cartAgregando,
      complete: COPY.cartAnadida,
      success: COPY.cartAnadida,
      opening: COPY.cartAbriendo,
      error: COPY.cartError,
    };
    var text = labels[state] || labels.idle;
    var isLoading = state === 'loading' || state === 'opening';
    var isComplete = state === 'complete' || state === 'success';
    var isError = state === 'error';

    STATE.routineCartStatus = state;

    ['rogma-add-routine', 'rogma-add-routine-sticky'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      btn.textContent = text;
      btn.classList.toggle('rogma-btn-state-success', isComplete);
      btn.classList.toggle('rogma-btn-state-error', isError);
      btn.classList.toggle('rogma-btn-state-partial', state === 'partial');
      btn.classList.toggle('rogma-btn-state-loading', isLoading);
      btn.disabled = isLoading;
    });

    if (DOM.stickyCta) {
      DOM.stickyCta.classList.toggle('is-success', isComplete);
      DOM.stickyCta.classList.toggle('is-hidden-after-add', false);
    }

    scheduleStickyCtaUpdate();
  }

  function updateRoutineButtonFromCart(cart) {
    if (!STATE.routineItems || !STATE.routineItems.length) {
      setRoutineButtonState('idle');
      return;
    }

    var missing = getMissingRoutineItems(STATE.routineItems, cart);
    var total = STATE.routineItems.length;
    var missingCount = missing.length;

    if (missingCount === 0) {
      setRoutineButtonState('complete');
    } else if (missingCount < total) {
      setRoutineButtonState('partial');
    } else {
      setRoutineButtonState('idle');
    }
  }

  function syncRoutineCartState() {
    if (!STATE.routineItems || !STATE.routineItems.length) return Promise.resolve(null);

    if (
      STATE.routineCartStatus === 'loading' ||
      STATE.routineCartStatus === 'opening'
    ) {
      return Promise.resolve(null);
    }

    return getCurrentCart()
      .then(function (cart) {
        updateRoutineButtonFromCart(cart);
        return cart;
      })
      .catch(function (error) {
        console.warn('[ROGMA Cart] No pudimos sincronizar carrito:', error);
        return null;
      });
  }

  function scheduleRoutineCartSync(delay) {
    if (STATE.cartSyncTimer) {
      clearTimeout(STATE.cartSyncTimer);
    }

    STATE.cartSyncTimer = setTimeout(function () {
      STATE.cartSyncTimer = null;
      syncRoutineCartState();
    }, delay || 450);
  }

  function observeCartDrawerChanges() {
    if (STATE.cartObserver) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    STATE.cartObserver = new MutationObserver(function () {
      scheduleRoutineCartSync(650);
    });

    STATE.cartObserver.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden'],
    });
  }

  function resetRoutineButtonVisualState() {
    STATE.routineItems = [];
    STATE.routineVariantIds = [];
    setRoutineButtonState('idle');
    if (DOM.stickyCta) {
      DOM.stickyCta.classList.remove('is-success', 'is-hidden-after-add');
    }
  }

  function bindRoutineButtonHistoryRestore() {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        scheduleRoutineCartSync(250);
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      scheduleRoutineCartSync(250);
    });

    ['cart:updated', 'cart:change', 'cart:update', 'ajaxCart:updated', 'shopify:cart:update'].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleRoutineCartSync(250);
      });
      window.addEventListener(eventName, function () {
        scheduleRoutineCartSync(250);
      });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (
        target.closest('cart-remove-button') ||
        target.closest('.cart-remove-button') ||
        target.closest('[data-cart-remove]') ||
        target.closest('[href*="/cart/change"]') ||
        target.closest('[name="updates[]"]') ||
        target.closest('quantity-input') ||
        target.closest('.quantity')
      ) {
        scheduleRoutineCartSync(900);
      }
    });
  }

  function addRoutineToCart(am, pm, focal) {
    var productos = productosUnicos(am, pm, focal);
    var testItems = buildTestCheckoutCartItems();
    var allItems = CONFIG.testCheckoutMode ? testItems : buildRoutineCartItems(productos);
    var triggeredBy = document.activeElement;

    trackRogmaEvent('add_routine_clicked', {
      test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
      productos_count: productos.length,
      cart_items_count: allItems.length,
      rutina_am_count: am && am.length ? am.length : 0,
      rutina_pm_count: pm && pm.length ? pm.length : 0,
      focal_count: focal && focal.length ? focal.length : 0,
    });

    if (CONFIG.testCheckoutMode) {
      console.info('[ROGMA Test Checkout] Activo: se agregará solo el producto de prueba.', {
        product_id: CONFIG.testProductId || '',
        variant_id: CONFIG.testProductVariantId || '',
        title: CONFIG.testProductTitle || '',
        price: CONFIG.testProductPrice || '',
      });
    }

    if (!allItems.length) {
      trackRogmaEvent('cart_add_error', {
        reason: 'no_items',
        test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
      });
      setRoutineButtonState('error');
      setTimeout(function () { syncRoutineCartState(); }, 3000);
      return;
    }

    STATE.routineItems = allItems;
    STATE.routineVariantIds = allItems.map(function (item) {
      return Number(item.id);
    }).filter(function (id) {
      return isFinite(id) && id > 0;
    });

    setRoutineButtonState('loading');

    updateCartAttributionAttributes()
      .catch(function (error) {
        console.warn('[ROGMA Attribution] No pudimos etiquetar el carrito:', error);
        return null;
      })
      .then(function () {
        return getCurrentCart();
      })
      .then(function (cart) {
        var missingItems = getMissingRoutineItems(allItems, cart);

        if (!missingItems.length) {
          trackRogmaEvent('cart_add_success', {
            status: 'already_in_cart',
            items_count: allItems.length,
            test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
          });
          setRoutineButtonState('opening');
          return openCartOrFallback(null, triggeredBy).then(function () {
            updateRoutineButtonFromCart(cart);
            return null;
          });
        }

        return addItemsToShopifyCart(missingItems)
          .then(function (parsedState) {
            return openCartOrFallback(parsedState, triggeredBy)
              .then(function () {
                return getCurrentCart();
              })
              .then(function (updatedCart) {
                trackRogmaEvent('cart_add_success', {
                  status: 'added',
                  items_count: missingItems.length,
                  total_items_count: allItems.length,
                  test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
                });
                updateRoutineButtonFromCart(updatedCart);
              });
          });
      })
      .catch(function (err) {
        console.error('[ROGMA Cart]', err);
        trackRogmaEvent('cart_add_error', {
          message: err && err.message ? err.message : 'cart_error',
          test_checkout_mode: CONFIG.testCheckoutMode ? 'true' : 'false',
        });
        setRoutineButtonState('error');
        setTimeout(function () { syncRoutineCartState(); }, 3000);
      });
  }

  function addModalProductToCart() {
    if (!STATE.modalProduct) return;

    var items = buildRoutineCartItems([STATE.modalProduct]);
    var triggeredBy = document.activeElement;

    if (!items.length) {
      DOM.modalAdd.textContent = COPY.ctaError;
      DOM.modalAdd.classList.add('rogma-btn-state-error');
      setTimeout(function () {
        DOM.modalAdd.textContent = COPY.ctaAgregar;
        DOM.modalAdd.classList.remove('rogma-btn-state-error');
      }, 2500);
      return;
    }

    DOM.modalAdd.textContent = COPY.ctaAgregando;
    DOM.modalAdd.disabled = true;

    addItemsToShopifyCart(items).then(function (parsedState) {
      DOM.modalAdd.textContent = COPY.ctaAnadido;
      DOM.modalAdd.classList.add('rogma-btn-state-success');
      DOM.modalAdd.disabled = false;

      /*
       * Cerramos primero el modal de producto para no dejar dos overlays
       * ni dos bloqueos de scroll compitiendo entre sí.
       */
      closeProductModal();
      openCartOrFallback(parsedState, triggeredBy).then(function () {
        scheduleRoutineCartSync(500);
      });
    }).catch(function (err) {
      console.error('[ROGMA Cart]', err);
      DOM.modalAdd.textContent = COPY.ctaError;
      DOM.modalAdd.classList.add('rogma-btn-state-error');
      DOM.modalAdd.disabled = false;
      setTimeout(function () {
        DOM.modalAdd.textContent = COPY.ctaAgregar;
        DOM.modalAdd.classList.remove('rogma-btn-state-error');
      }, 2500);
    });
  }

  /* ═══════════════════════════════════════════════════════════
     FEEDBACK
     ═══════════════════════════════════════════════════════════ */

  function renderFeedback(scanId) {
    if (!DOM.feedbackMount) return;

    DOM.feedbackMount.innerHTML =
      '<div class="rogma-feedback">' +
        '<button type="button" class="rogma-feedback__toggle" id="rogma-feedback-toggle" aria-expanded="false">' +
          '<span class="rogma-feedback__toggle-text">' +
            '<span class="rogma-feedback__toggle-title">' + escapeHtml(COPY.feedbackTitulo) + '</span>' +
            '<span class="rogma-feedback__toggle-sub">' + escapeHtml(COPY.feedbackSub) + '</span>' +
          '</span>' +
          '<span class="rogma-feedback__action" aria-hidden="true">' +
            '<span class="rogma-feedback__action-label">Responder</span>' +
            '<span class="rogma-feedback__chevron"></span>' +
          '</span>' +
        '</button>' +
        '<div class="rogma-feedback__body" id="rogma-feedback-body" hidden>' +
          '<p class="rogma-feedback__label">' + escapeHtml(COPY.feedbackPercepcion) + '</p>' +
          '<div class="rogma-feedback__perception" id="rogma-feedback-perception"></div>' +
          '<label class="rogma-feedback__comment-label" for="rogma-feedback-comment">Comentarios</label>' +
          '<textarea id="rogma-feedback-comment" class="rogma-feedback__comment" rows="3" maxlength="500" placeholder="' + escapeAttr(COPY.feedbackComentarioPlaceholder) + '"></textarea>' +
          '<button type="button" class="rogma-btn-secondary" id="rogma-feedback-send" disabled>Enviar</button>' +
        '</div>' +
      '</div>';

    var rating = 0;

    var perceptionEl = document.getElementById('rogma-feedback-perception');
    FEEDBACK_PERCEPCION.forEach(function (opcion) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rogma-feedback__perception-btn';
      btn.textContent = COPY[opcion.labelKey];
      btn.dataset.value = String(opcion.value);
      btn.setAttribute('aria-label', COPY[opcion.labelKey]);
      btn.addEventListener('click', function () {
        rating = parseInt(this.dataset.value, 10);
        perceptionEl.querySelectorAll('.rogma-feedback__perception-btn').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        updateFeedbackSend();
      });
      perceptionEl.appendChild(btn);
    });

    var commentEl = document.getElementById('rogma-feedback-comment');
    var sendBtn = document.getElementById('rogma-feedback-send');

    function updateFeedbackSend() {
      sendBtn.disabled = !(rating >= 1);
    }

    document.getElementById('rogma-feedback-toggle').addEventListener('click', function () {
      var body = document.getElementById('rogma-feedback-body');
      var expanded = !body.hidden;
      var nextOpen = expanded ? false : true;
      var actionLabel = this.querySelector('.rogma-feedback__action-label');

      body.hidden = !nextOpen;
      this.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      this.classList.toggle('is-open', nextOpen);

      if (actionLabel) {
        actionLabel.textContent = nextOpen ? 'Ocultar' : 'Responder';
      }
    });

    sendBtn.addEventListener('click', function () {
      if (sendBtn.disabled) return;
      sendBtn.disabled = true;
      sendBtn.textContent = 'Enviando…';

      var comentario = commentEl ? String(commentEl.value || '').trim().slice(0, 500) : '';

      fetch(CONFIG.feedbackUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          scan_id: scanId,
          rating: rating,
          aspecto_mas_util: 'El orden de mi rutina personalizada',
          comentario: comentario,
        }),
      }).then(function () {
        trackRogmaEvent('feedback_submitted', {
          rating: rating,
          comentario: comentario ? 'true' : 'false',
          feedback_status: 'sent',
        }, { scanId: scanId, forceScanId: true });
      }).catch(function () {
        trackRogmaEvent('feedback_submitted', {
          rating: rating,
          comentario: comentario ? 'true' : 'false',
          feedback_status: 'fire_and_forget_error',
        }, { scanId: scanId, forceScanId: true });
      });

      DOM.feedbackMount.innerHTML = '<div class="rogma-feedback"><p class="rogma-feedback__thanks">' + escapeHtml(COPY.feedbackGracias) + '</p></div>';
    });
  }

  /* ═══════════════════════════════════════════════════════════
     UTILS
     ═══════════════════════════════════════════════════════════ */

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function escapeAttr(str) {
    return escapeHtml(str);
  }

  function sanitizeName(raw) {
    return String(raw || '')
      .replace(/[\u0000-\u001F\u007F]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 40);
  }

  function sanitizeCopy(text) {
    if (!text || typeof text !== 'string') return text;
    return text
      .replace(/es una orientaci[oó]n cosm[eé]tica,?\s*no\s+un\s+diagn[oó]stico\s+ni\s+tratamiento\s+dermatol[oó]gico\.?/gi, 'Es una orientación cosmética y no sustituye una valoración profesional.')
      .replace(/no\s+un\s+evaluaci[oó]n\s+cosm[eé]tica\s+ni\s+cuidado\s+profesional\.?/gi, 'no sustituye una valoración profesional.')
      .replace(/\bdiagnóstico\b/gi, 'evaluación cosmética')
      .replace(/\bdiagnostico\b/gi, 'evaluación cosmética')
      .replace(/\bacne\b/gi, 'granitos visibles')
      .replace(/\bdermatológico\b/gi, 'profesional')
      .replace(/\bdermatologico\b/gi, 'profesional')
      .replace(/\bacné\b/gi, 'granitos visibles')
      .replace(/\btratamiento\b/gi, 'cuidado')
      .replace(/\bseveridad\b/gi, 'nivel observado')
      .replace(/\bsevero\b/gi, 'marcado')
      .replace(/\blesión\b/gi, 'marca visible')
      .replace(/\bcura\b/gi, 'cuidado')
      .replace(/\benfermedad\b/gi, 'condición visible');
  }

  function labelSintoma(key) {
    return SINTOMA_LABELS[key] || String(key || '').replace(/_/g, ' ');
  }

  function labelTipoPiel(valor) {
    var map = {
      grasa: 'Grasa',
      mixta: 'Mixta',
      seca: 'Seca',
      normal: 'Normal',
      no_concluyente: 'No estoy seguro/a',
    };
    return map[valor] || valor || 'No estoy seguro/a';
  }

  function resolveSeveridad(dato) {
    return (dato && (dato.severidad_v8 || dato.severidad)) || 'ninguno';
  }

  function getSintomas(resultados) {
    return (resultados.visual && resultados.visual.sintomas) || resultados.sintomas_detalle || {};
  }

  function getRecomendaciones(resultados) {
    return resultados.recomendaciones || resultados.rutina_recomendada || {
      rutina_am: [],
      rutina_pm: [],
      cuidado_focalizado: [],
    };
  }

  function buildHeroTitulo(displayName) {
    return displayName
      ? displayName + ', tu ritual personalizado está listo.'
      : 'Tu ritual personalizado está listo.';
  }

  function buildRutinaFocusLine(resultados) {
    var sintomas = getSintomas(resultados);
    var top = Object.keys(SINTOMA_LABELS)
      .map(function (key) { return { key: key, dato: sintomas[key] }; })
      .filter(function (x) { return x.dato && resolveSeveridad(x.dato) !== 'ninguno'; })
      .sort(function (a, b) {
        return (SEV_ORDER[resolveSeveridad(b.dato)] || 0) - (SEV_ORDER[resolveSeveridad(a.dato)] || 0);
      })
      .slice(0, 3);

    if (top.length) {
      var labels = top.map(function (x) { return labelSintoma(x.key).toLowerCase(); });
      var lista;
      if (labels.length === 1) lista = labels[0];
      else if (labels.length === 2) lista = labels[0] + ' y ' + labels[1];
      else lista = labels[0] + ', ' + labels[1] + ' y ' + labels[2];
      return 'Tu rutina se enfocará en ' + lista + '.';
    }

    var prioridad = resultados.prioridad_rutina;
    if (prioridad && prioridad !== 'ninguno') {
      return 'Tu rutina se enfocará en ' + labelSintoma(prioridad).toLowerCase() + '.';
    }

    return 'Tu rutina se enfocará en equilibrio, luminosidad y textura uniforme.';
  }


  function prefixName(name, sentence) {
    if (!name) return sentence;
    return name + ', ' + lowercaseFirst(sentence);
  }

  function lowercaseFirst(s) {
    if (!s) return s;
    return s.charAt(0).toLowerCase() + s.slice(1);
  }

  function formatPrecioProducto(price) {
    if (price == null || price === '') return null;
    var num = Number(String(price).replace(/,/g, ''));
    if (isNaN(num)) return '$' + price + ' MXN';
    return '$' + Math.round(num).toLocaleString('es-MX') + ' MXN';
  }

  function detectarTipoProducto(producto) {
    var blob = ((producto.sku || '') + ' ' + (producto.clave || '') + ' ' + (producto.handle || '') + ' ' + (producto.title || '')).toLowerCase();
    if (/salicil/.test(blob)) return 'salicilico';
    if (/blemish/.test(blob)) return 'blemish';
    if (/niacin/.test(blob)) return 'niacinamida';
    if (/vit|liposomal c|antioxidant/.test(blob) && !/pca/.test(blob)) return 'vit_c';
    if (/night|repair/.test(blob)) return 'night_repair';
    if (/hialur/.test(blob)) return 'hialuronico';
    if (/contorno|ojos|we-are-young|young/.test(blob)) return 'contorno_ojos';
    if (/pca|nanotechnological/.test(blob)) return 'pca';
    return 'generico';
  }

  function tituloProductoCosmetico(producto) {
    var tipo = detectarTipoProducto(producto);
    if (TITULOS_COSMETICOS[tipo]) return TITULOS_COSMETICOS[tipo];
    var raw = sanitizeCopy(producto.title);
    return (raw && String(raw).trim()) || 'Producto RŌGMA';
  }

  function etiquetaUsoProducto(periodo) {
    if (periodo === 'am') return 'Mañana (AM)';
    if (periodo === 'pm') return 'Noche (PM)';
    if (periodo === 'focalizado') return 'Cuidado focalizado';
    return null;
  }

  function porQueEnRutina(producto) {
    var motivo = sanitizeCopy(producto.motivo);
    if (motivo && String(motivo).trim()) return String(motivo).trim();
    return paraProducto(producto);
  }

  function paraProducto(producto) {
    var blob = ((producto.sku || '') + ' ' + (producto.clave || '') + ' ' + (producto.handle || '') + ' ' + (producto.title || '')).toLowerCase();
    if (/salicil/.test(blob)) return 'Para cuidado puntual en zonas con granitos visibles.';
    if (/blemish/.test(blob)) return 'Para piel con tendencia a imperfecciones visibles.';
    if (/niacin/.test(blob)) return 'Para apoyar uniformidad del tono y apariencia de marcas.';
    if (/vit|liposomal c|antioxidant/.test(blob) && !/pca/.test(blob)) return 'Para luminosidad y apariencia más vital.';
    if (/night|repair/.test(blob)) return 'Para apoyar renovación nocturna y textura más uniforme.';
    if (/hialur/.test(blob)) return 'Para hidratación, suavidad y apariencia más lisa.';
    if (/contorno|ojos|young/.test(blob)) return 'Para acompañar el cuidado del contorno de ojos.';
    return 'Para apoyar el cuidado diario según tu evaluación.';
  }

  function queAportaPiel(producto) {
    var tipo = detectarTipoProducto(producto);
    return APORTA_PIEL[tipo] || APORTA_PIEL.generico;
  }

  function comoUsarProducto(producto, periodo) {
    var tipo = detectarTipoProducto(producto);
    if (tipo === 'salicilico' || periodo === 'focalizado') {
      return 'Aplica solo sobre las zonas indicadas, evitando contorno de ojos y labios. Úsalo como paso focalizado dentro de tu rutina.';
    }
    if (periodo === 'am') {
      return 'Aplica por la mañana sobre piel limpia. Si usas protector solar, déjalo absorber unos instantes antes de continuar.';
    }
    if (periodo === 'pm') {
      return 'Aplica por la noche sobre piel limpia, como parte de tu ritual PM.';
    }
    if (tipo === 'contorno_ojos') {
      return 'Aplica una pequeña cantidad en el contorno de ojos con toques suaves, sin arrastrar la piel.';
    }
    return 'Integra este producto en el orden de tu rutina personalizada, sobre piel limpia y seca.';
  }

  /* ═══════════════════════════════════════════════════════════
     INIT
     ═══════════════════════════════════════════════════════════ */

  function init() {
    applySilhouetteAssetOverrides();
    applyResponsiveDeviceMode();
    ensureAnalyticsSessionId();
    if (!STATE.analyticsPageViewSent) {
      STATE.analyticsPageViewSent = true;
      trackRogmaEvent('page_view', {
        source: 'shopify',
        path: window.location && window.location.pathname ? window.location.pathname : '',
        referrer: document.referrer || '',
      }, { scanId: '', forceScanId: false });
    }
    ensureStickyCtaMarkup();
    cacheDom();
    ensureLightingUi();
    ensureFaceGuidanceUi();
    ensurePremiumCaptureStatusUi();
    ensureCountdownBadgeUi();
    ensureCaptureTransitionUi();
    ensureCaptureGuideUi();
    bindEvents();
    bindResponsiveModeEvents();
    bindRoutineButtonHistoryRestore();
    resetLightingValidation();
    resetFaceGuidanceValidation();
    preloadFaceGuidance();
  }

  init();
})();













